// MOCK DATA for TORRI — Beyond Ordinary Solar (new premium industrial homepage preview)
// NOTE: This is all mocked/static content for the exploratory homepage.

import certFactory from "../assets/certs/cert-factory-inspection.jpg";
import certIso9001 from "../assets/certs/cert-iso-9001.jpg";
import certIso14001 from "../assets/certs/cert-iso-14001.jpg";
import certIso45001 from "../assets/certs/cert-iso-45001.jpg";
import tl2007 from "../assets/timeline/tl-2007.jpg";
import tl2012 from "../assets/timeline/tl-2012.jpg";
import tl2016 from "../assets/timeline/tl-2016.jpg";
import tl2021 from "../assets/timeline/tl-2021.jpg";
import tl2022 from "../assets/timeline/tl-2022.jpg";
import tl2024 from "../assets/timeline/tl-2024.jpg";
import tl2025 from "../assets/timeline/tl-2025.jpg";

export const brand = {
  name: "TORRI.",
  tagline: "Beyond Ordinary Solar.",
  phone: "+39 030 6480034",
  phoneHref: "tel:+390306480034",
  yellow: "#F9E212",
};

export const nav = [
  { label: "Azienda", href: "/azienda", children: [
    { label: "Il gruppo", href: "/azienda" },
    { label: "Fabbrica", href: "/azienda#fabbrica" },
    { label: "Certificazioni", href: "/azienda#certificazioni" },
    { label: "Solar Lab", href: "/azienda#solar-lab" },
    { label: "Timeline", href: "/azienda#timeline" },
  ] },
  { label: "Tecnologie", href: "/tecnologia", children: [
    { label: "PRISMA 4.0", href: "/tecnologia#tech-prisma-4-0" },
    { label: "X-CORE²", href: "/tecnologia#tech-x-core-2" },
    { label: "ECO-RED", href: "/tecnologia#tech-eco-red" },
    { label: "AURA", href: "/tecnologia#tech-aura" },
    { label: "Ai VESTA", href: "/tecnologia#tech-ai-vesta", vesta: true },
  ] },
  { label: "Prodotti", href: "/prodotti", children: [
    { label: "Pannelli Fotovoltaici", href: "/prodotti/pannelli-fotovoltaici" },
    { label: "Inverter", href: "/prodotti/inverter" },
    { label: "Sistema di Accumulo", href: "/prodotti/sistemi-di-accumulo" },
    { label: "Sistemi di Fissaggio", href: "/prodotti/sistemi-di-fissaggio" },
    { label: "Stazione di Ricarica", href: "/prodotti/stazione-di-ricarica" },
  ] },
  { label: "Chiavi in mano", href: "/chiavi-in-mano", children: [
    { label: "Installatori", href: "/installatori" },
  ] },
  { label: "News", href: "/news" },
  { label: "Contatti", href: "/contatti", children: [
    { label: "Assistenza", href: "/assistenza/garanzia" },
  ] },
];

export const ecosystem = [
  { label: "Configuratore", href: "https://configuratore.torri.solar", desc: "Progetta il tuo impianto" },
  { label: "Partner", href: "https://partner.torri.solar", desc: "Area installatori" },
  { label: "Service", href: "https://service.torri.solar", desc: "Assistenza post-vendita" },
  { label: "Warehouse", href: "https://warehouse.torri.solar", desc: "Logistica e ordini" },
];

export const heroStats = [
  { value: "1977", label: "Gruppo industriale di proprietà famigliare" },
  { value: "2007", label: "Fabbrica di pannelli fotovoltaici" },
  { value: "8 volte", label: "Più resistente alla grandine" },
  { value: "+170", label: "Installatori Partner" },
];

export const solarLab = {
  eyebrow: "Solar Lab",
  title: "Un laboratorio interno alla fabbrica per spingere oltre il limite dell'ordinario.",
  body: "Solar Lab è un programma di formazione teorica e pratica dedicato ai professionisti. Attraverso dimostrazioni tecniche e test, anche distruttivi, mettiamo al centro la robustezza dei moduli fotovoltaici e la loro capacità di durare nel tempo.",
  slots: [
    {
      name: "Solar Day",
      body: "La giornata formativa dedicata agli Ordini professionali: ingegneri, architetti e periti industriali.",
      img: "/media/IMG_5908.webp",
    },
    {
      name: "Solar Academy",
      body: "Il programma formativo dedicato agli studi tecnici per sviluppare competenze avanzate nel fotovoltaico, con speciale focus sui pannelli.",
      img: "/media/IMG_5911.webp",
    },
  ],
  image:
    "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxsYWJvcmF0b3J5JTIwdGVzdGluZ3xlbnwwfHx8fDE3ODYxMTAwOTB8MA&ixlib=rb-4.1.0&q=85",
  video: {
    id: "RbtdqMSDUX4",
    title: "TORRI · Beyond Solar Lab",
    thumb: "/media/IMG_5909.webp",
  },
};

export const certificazioni = {
  eyebrow: "Certificazioni",
  title: "Standard internazionali, controllo Italiano.",
  body: "La Direzione di TORRI.Solar adotta da sempre un approccio orientato al miglioramento continuo, in cui l'etica d'impresa è parte integrante della conduzione aziendale. In quest'ottica l'azienda ha implementato da anni un Sistema di Gestione Integrato conforme alle normative ISO 9001 (Qualità), ISO 14001 (Ambiente) e ISO 45001 (Salute e Sicurezza sul lavoro). A queste si affiancano ulteriori attestazioni a garanzia dell'affidabilità dei prodotti e della trasparenza dei processi, tra cui: Factory Inspection Attestation Photovoltaic Panel e Certificazione ECOEM per la gestione ambientale dei moduli a fine vita.",
  items: [
    { code: "ISO 9001", desc: "Sistema di gestione della qualità", file: certIso9001 },
    { code: "ISO 14001", desc: "Sistema di gestione ambientale", file: certIso14001 },
    { code: "ISO 45001:2018", desc: "Certificato del Sistema di Gestione per la Salute e la Sicurezza sul Lavoro", file: certIso45001 },
    { code: "CE", desc: "Conformità alle direttive europee" },
    { code: "Made in Italy", desc: "Produzione e laboratorio interni" },
  ],
};

export const timeline = {
  eyebrow: "Timeline",
  title: "Dal 2007, la prima fabbrica Italiana di pannelli fotovoltaici.",
  milestones: [
    { year: "2007", title: "La prima fabbrica di pannelli fotovoltaici in Italia.", desc: "Nasce Torri Solare, tra i primi produttori di pannelli fotovoltaici in Europa. Il primo stabilimento, avviato da Giulio e Michele, ha capacità produttiva di 20 MWp circa e prende vita a fianco dell'attività storica di famiglia.", image: tl2007 },
    { year: "2012", title: "Il primo brevetto: la tecnologia DIAMANTE riconosciuta innovativa dal GSE.", desc: "Gli investimenti in ricerca e sviluppo aprono le porte a nuovi prodotti brevettati ed integrati innovativi. La tecnologia DIAMANTE diventa in poco tempo la più venduta.", image: tl2012 },
    { year: "2016", title: "\u201cArtigiani del fotovoltaico\u201d e il periodo post – Conto Energia.", desc: "Viene introdotto per la prima volta il claim \u201cArtigiani del fotovoltaico\u201d per esprimere in modo diretto le forti radici con il territorio e per creare un posizionamento valoriale unico in un periodo di forte contrazione di mercato.", image: tl2016 },
    { year: "2021", title: "Il nuovo Polo Tecnologico a Brescia.", desc: "Dal 2021 l'azienda ha bonificato e riqualificato un lotto industriale a Brescia, da circa 10.000 mq, costruito negli anni '70 e trasformato nel polo tecnologico dove sono concentrate le attività del gruppo. All'interno dell'area avviene la produzione e la sperimentazione dei nuovi prodotti e delle nuove tecnologie.", image: tl2021 },
    { year: "2022", title: "Michele Torri a Dubai Expo 2020.", desc: "L'agenzia ITA – Italian Trade Agency e il Ministero degli Affari Esteri e della Cooperazione Internazionale selezionano l'azienda in rappresentanza delle imprese italiane che investono in tecnologia e sostenibilità in Italia.", image: tl2022 },
    { year: "2024", title: "Il futuro è Beyond Ordinary.", desc: "La nuova linea di produzione completa il ciclo di investimenti in Italia: l'azienda è leader di settore nell'alta gamma con un nuovo claim \u201cBEYOND ORDINARY SOLAR\u201d. Nello stesso anno viene avviata la rete di installatori partner: Beyond Solar Partner diventa in pochi mesi la community del fotovoltaico specializzata più numerosa d'Italia.", image: tl2024 },
    { year: "2025", title: "La Tecnologia X-CORE² disegna nuovi standard di prodotto.", desc: "La nuova tecnologia X-CORE², con domanda di brevetto depositata, è presentata in anteprima presso il Museo Mille Miglia di Brescia ad una platea di oltre 150 installatori partner.", image: tl2025 },
  ],
};

export const gruppo = {
  intro: {
    statement:
      "Oltre 65 anni di storia di impresa famigliare ed investimenti nel mondo industriale e produttivo.",
    body: [
      "Fier S.p.a. è un'azienda all'avanguardia nella produzione di pannelli fotovoltaici dal design distintivo e dalle tecnologie innovative. Leader nell'alta gamma di settore, con know how ed esperienza ventennale nell'assemblaggio di pannelli fotovoltaici.",
      "Risultati ispirati da valori che da sempre caratterizzano ogni investimento, tecnologia e prodotto:",
    ],
    values: [
      { b: "Longevità e sicurezza", t: "valori da elevare per consolidare il patrimonio personale e sociale." },
      { b: "Innovazione", t: "a sviluppare tecnologie capaci di esaltare le caratteristiche dei prodotti." },
      { b: "Design", t: "che coniuga estetica e performance." },
    ],
    ctaLabel: "Sfoglia la presentazione aziendale",
    ctaHref: "/docs/torri-presentazione-aziendale.pdf",
  },
  milestone2008: {
    text: "Nel 2008 TORRI.solar è ufficialmente azienda produttrice di moduli fotovoltaici.",
    image:
      "/media/bus.webp",
  },
  businessUnits: [
    {
      name: "Fonderia dal 1977",
      icon: "foundry",
      body: "Progetta e produce componenti in alluminio pressofuso, completi di lavorazioni meccaniche e trattamenti di finitura. Opera in numerosi settori industriali e realizza anche progetti personalizzati su specifica del cliente. Made in Italy.",
    },
    {
      name: "Fotovoltaico dal 2007",
      icon: "panel",
      body: "Progetta, produce e distribuisce pannelli fotovoltaici di alta gamma e sistemi fotovoltaici completi di inverter, sistemi di storage e stazioni di ricarica.",
    },
  ],
  quote:
    "È una storia di lavoro e sacrificio, di scelte coraggiose e di regole non scritte tramandate da tre generazioni. Ma è anche il più grande punto di incontro tra noi e il mercato.",
  tradizione: {
    title: "La tradizione imprenditoriale",
    body: [
      "La tradizione imprenditoriale risale al 1961, quando Giuseppe Torri avvia la propria attività con piccole pulissoie per metalli a Quinzano d'Oglio, nella pianura padana.",
      "È il 1977 l'anno in cui viene installata la prima pressa per pressofusione ed ha inizio la storia della famiglia nel mondo dei metalli.",
      "Gli anni '90 vedono il figlio Giulio Torri impegnato a sviluppare l'attività nel settore fonderia e nel 2008, con la terza generazione, nasce Torri Solare — azienda produttrice di pannelli fotovoltaici — guidata da Michele Torri.",
    ],
    ctaLabel: "Scopri la fabbrica",
    ctaHref: "/azienda#fabbrica",
    image:
      "https://images.unsplash.com/photo-1697281435920-96ae28dbee14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxhbHVtaW5pdW0lMjBkaWUlMjBjYXN0aW5nJTIwZm91bmRyeSUyMGluZHVzdHJpYWx8ZW58MHx8fHwxNzg2MjI3MjQyfDA&ixlib=rb-4.1.0&q=85",
  },
  polo: {
    title: "Il Polo Tecnologico",
    body:
      "Dal 2021 l'azienda ha bonificato e riqualificato un lotto industriale a Brescia, da circa 10.000 mq, costruito negli anni '70 e trasformato nel polo tecnologico dove sono concentrate le attività del gruppo. All'interno dell'area avviene la produzione e la sperimentazione dei nuovi prodotti e delle nuove tecnologie.",
    points: [
      "La produzione è 100% alimentata da fotovoltaico.",
      "Le nuove tecnologie vengono sperimentate con un campo fotovoltaico esterno da circa 20 kWp adibito a solo test.",
      "Il laboratorio è all'avanguardia ed è il luogo dove vengono effettuati test distruttivi e di performance con gli enti di ricerca.",
      "L'intero stabilimento è autonomo sotto il profilo energetico grazie all'impianto fotovoltaico da 400 kW e al pozzo che alimenta l'intero stabilimento e gli impianti di condizionamento.",
      "Stazione di ricarica Ipercharge da 150 kW/h per la mobilità elettrica, aperta al pubblico.",
    ],
    image:
      "/media/polo2.webp",
    stats: [
      { v: "10.000 mq", k: "Polo tecnologico a Brescia" },
      { v: "400 kW", k: "Impianto fotovoltaico di stabilimento" },
      { v: "20 kWp", k: "Campo esterno dedicato ai test" },
      { v: "150 kW/h", k: "Ipercharge aperta al pubblico" },
    ],
  },
};

export const factory = {
  eyebrow: "La Fabbrica",
  title: "Fondiamo tecnica costruttiva e design industriale, verso pannelli fotovoltaici sempre più robusti e sicuri.",
  points: [
    { k: "Fabbrica Italiana", v: "Stabilimento e laboratorio interni, cultura industriale del prodotto." },
    { k: "Tecnologie proprietarie", v: "Modelli costruttivi evoluti e brevettati, per i massimi standard di robustezza." },
    { k: "Rete partner", v: "La più qualificata rete di installatori Italiana, formazione costante e legame diretto con la fabbrica." },
  ],
  image:
    "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwZmFjdG9yeXxlbnwwfHx8fDE3ODYxMTAwOTB8MA&ixlib=rb-4.1.0&q=85",
  image2:
    "https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwZmFjdG9yeXxlbnwwfHx8fDE3ODYxMTAwOTB8MA&ixlib=rb-4.1.0&q=85",
  video: { id: "d_KYfZO98Jo", title: "Come si produce un pannello fotovoltaico?" },
  documentaryTitle: "Entra in fabbrica con il team di Ingegneria Italia",
  documentarySub:
    "Un tour virtuale dello stabilimento e del laboratorio, accompagnati dal CEO Michele Torri. Come nascono i pannelli e le tecnologie TORRI.",
  documentary: [
    { id: "d_KYfZO98Jo", featured: true, title: "Come si produce un pannello fotovoltaico?", desc: "Il documentario integrale: un viaggio di 10 minuti dentro lo stabilimento con il CEO Michele Torri, dalle celle al laminato finito." },
    { id: "4LbdcvL5i2o", short: true, phase: true, title: "In quanto tempo si produce un pannello fotovoltaico?", desc: "I tempi reali di una linea produttiva, dalla cella al modulo collaudato." },
    { id: "E1lxVGhCe68", short: true, phase: true, title: "Stringatura", desc: "Come le celle vengono saldate in stringhe con precisione robotizzata." },
    { id: "9W_A4vRCA0I", short: true, phase: true, title: "Laminazione", desc: "La fase che sigilla celle, vetro e incapsulanti in un unico modulo." },
    { id: "6yuvyL7_JR8", title: "Test grandine", desc: "La prova d'impatto che dimostra la resistenza dei moduli alla grandine." },
    { id: "C2wR0Z3fS1I", title: "Un pannello fotovoltaico si può calpestare", desc: "Perché un pannello TORRI regge il peso di una persona senza compromettere il circuito." },
    { id: "2cCYOFyWNY0", title: "A cosa serve il silicio?", desc: "Il cuore della cella fotovoltaica spiegato in modo semplice." },
    { id: "LtWlLg3OA3g", title: "Polimero", desc: "Il ruolo dei materiali incapsulanti nella durata e nella sicurezza del pannello." },
    { id: "WjrIE1-X82M", title: "Quanto costa un pannello fotovoltaico?", desc: "I fattori che determinano il prezzo di un pannello di qualità industriale." },
  ],
};

export const technology = {
  eyebrow: "Tecnologie",
  title: "Designed for #pazziabbastanza",
  body:
    "Ci sono cose che ci vengono naturali: proteggere chi amiamo, coltivare le nostre passioni, tramandare la nostra cultura.\nLo stesso spirito guida il nostro modo di fare impresa.\n\nProduciamo in Italia perché abbiamo qualcosa da aggiungere: idee, tecnologie e un modo di progettare in cui la cura dei dettagli diventa sicurezza.\n\nLa nostra ambizione è portare nei moduli fotovoltaici l’ingegno e la qualità che rendono riconoscibile il disegno italiano.\n\nPer qualcuno è una scelta controcorrente. Per noi è il modo più naturale di fare le cose.",
  body2:
    "",
  items: [
    {
      code: "X-CORE²",
      claim: "Progettato per l'endurance",
      desc: "La cornice accoglie un inserto polimerico calibrato per ridistribuire il carico.",
      image: "/tech/xcore-orig-1.jpeg",
    },
    {
      code: "PRISMA 4.0",
      claim: "8 volte più resistente alla grandine",
      desc: "Un modello costruttivo unico, sviluppato per proteggere il circuito in silicio al proprio interno.",
      image: "/tech/prisma-slide-1.webp",
    },
    {
      code: "ECO-RED",
      claim: "Colore senza pigmenti",
      desc: "Sfondo trasparente per la massima dissipazione termica ed estetica architettonica.",
      image: "/tech/ecored-1.webp",
    },
    {
      code: "AURA",
      claim: "Elettronica di sistema",
      desc: "Equilibrio e costanza nell'energia: inverter, accumulo e ricarica integrati.",
      image: "/tech/aura-inverter.jpeg",
    },
  ],
  irs: [
    { label: "TORRI PRISMA 4.0", value: 50.6, note: "24.000g / 450W × 0,95", highlight: true },
    { label: "Mainstream vetro/vetro", value: 23.3, note: "21.000g / 450W × 0,5 · vetro 2mm" },
    { label: "Mainstream vetro/polimero", value: 38.0, note: "18.000g / 450W × 0,95 · vetro 3,2mm" },
  ],
};

export const products = {
  eyebrow: "Prodotti",
  title: "Beyond Ordinary.",
  body:
    "Andare oltre l'ordinario è uno stile di vita, un'attitudine quotidiana. È la ricerca di modelli che mettono in discussione lo status quo, sostituendolo con altri valori comuni. Con il brand TORRI progettiamo e realizziamo oltre 50 modelli.",
  families: [
    {
      name: "PRISMA 4.0",
      tag: "Tecnologia di punta",
      copy: "3 volte più robusto ad urti accidentali, fino a 750 kg/m² di carico neve. 8 volte più resistente alla grandine rispetto allo standard di mercato.",
      image:
        "/img/ext/xau4jdab_IMG_5960-a5526b.webp",
    },
    {
      name: "X-CORE²",
      tag: "La nuova frontiera della sicurezza",
      copy: "Laminato ad alto IRS abbinato a una cornice strutturale evoluta: massima stabilità del modulo e integrità del circuito anche in condizioni critiche.",
      image:
        "/img/ext/gu9a7hcb_IMG_5875-4a02d2.webp",
    },
    {
      name: "ECO-RED",
      tag: "Estetica architettonica",
      copy: "Colore senza pigmenti ottenuto otticamente: sfondo trasparente per la massima dissipazione termica e un'integrazione elegante su facciate e coperture di pregio.",
      image:
        "/tech/ecored-1.webp",
    },
  ],
  modules: [
    { name: "Half Cell 4.0", image: "/products/half-cell-4-0.webp" },
    { name: "Silvered 4.0", image: "/products/silvered-4-0.webp" },
    { name: "Integra Eco-Red", image: "/products/integra-ecored.webp" },
    { name: "Integra Total Black", image: "/products/integra-total-black.webp" },
    { name: "Innova", image: "/products/innova.webp" },
  ],
  categories: ["Moduli Fotovoltaici", "Inverter", "Sistemi di Accumulo", "Sistemi di Fissaggio", "Stazione di Ricarica"],
};

export const productCategories = [
  {
    slug: "pannelli-fotovoltaici",
    label: "Pannelli Fotovoltaici",
    cat: "Moduli Fotovoltaici",
    title: "Pannelli",
    highlight: "Fotovoltaici.",
    sub: "Moduli progettati per la massima longevità: robustezza strutturale, alta efficienza e sicurezza.",
    image: "/img/ext/nu0c1gx0_IMG_5965-6a9d81.webp",
  },
  {
    slug: "inverter",
    label: "Inverter",
    cat: "Inverter",
    title: "Inverter",
    highlight: "AURA.",
    sub: "L'elettronica di sistema dell'ecosistema AURA: inverter ibridi monofase e trifase, dal residenziale all'industriale.",
    image: "/img/ext/rj0ku4dz_IMG_5967-a3bb22.webp",
  },
  {
    slug: "sistemi-di-accumulo",
    label: "Sistema di Accumulo",
    cat: "Sistemi di Accumulo",
    title: "Sistemi di",
    highlight: "Accumulo.",
    sub: "Batterie modulari ad alta e bassa tensione per massimizzare l'autoconsumo, integrate nell'ecosistema AURA.",
    image: "/media/IMG_5966.jpeg",
  },
  {
    slug: "sistemi-di-fissaggio",
    label: "Sistemi di Fissaggio",
    cat: "Sistemi di Fissaggio",
    title: "Sistemi di",
    highlight: "Fissaggio.",
    sub: "Staffe, profilati, morsetti e zavorre per tetto a falda, lamiera e piano. Montaggio rapido e sicuro in cantiere.",
    image: "/media/IMG_5968.jpeg",
  },
  {
    slug: "stazione-di-ricarica",
    label: "Stazione di Ricarica",
    cat: "Stazione di Ricarica",
    title: "Stazione di",
    highlight: "Ricarica.",
    sub: "La ricarica EV integrata nell'ecosistema energetico TORRI: produzione, accumulo e mobilità in un unico sistema.",
    image: "/img/ext/g1bmy99w_IMG_4889-f31c16.webp",
  },
];

export const turnkey = {
  eyebrow: "Divisione Impianti",
  title: "Dalla qualità del produttore\nalla garanzia del chiavi in mano.",
  body:
    "La nostra è una realtà industriale che integra la produzione di pannelli fotovoltaici al mondo del chiavi in mano. Contattaci per un preventivo ed affidati ad un interlocutore industriale competitivo e competente.",
  services: [
    { name: "Installazione impianti fotovoltaici", img: "/img/ext/o9y3ilww_IMG_6385-adf319.webp" },
    { name: "Rimozione amianto", img: "/img/ext/6a2h95eh_IMG_6389-6bc40f.webp" },
    { name: "Produzione e installazione quadri elettrici", img: "/turnkey/quadri-elettrici.webp?v=2" },
    { name: "Rifacimento cabine MT", img: "/turnkey/cabine-mt.webp?v=2" },
  ],
  ctaLabel: "Configura il tuo impianto",
  ctaHref: "https://configuratore.torri.solar",
  image:
    "https://images.unsplash.com/photo-1613665813446-82a78c468a1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwc29sYXIlMjByb29mdG9wfGVufDB8fHx8MTc4NTIwNjE3N3ww&ixlib=rb-4.1.0&q=85",
};

export const partner = {
  eyebrow: "Rete Partner",
  count: "170+",
  title: "Una rete nazionale di Installatori Partner.",
  body:
    "Collaboriamo con professionisti su tutto il territorio italiano. Installatori con cui condividiamo competenza tecnica, cultura del prodotto e valori.",
  regions: ["Nord-Ovest", "Nord-Est", "Centro", "Sud", "Isole"],
  image:
    "https://images.pexels.com/photos/29407508/pexels-photo-29407508.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const scenari = {
  eyebrow: "Scenari di mercato",
  title: "Il mainstream è troppo fragile.",
  sub: "Le normative IEC non bastano a proteggere dalla bassa qualità del prodotto.",
  stats: [
    { n: "76%", d: "degli impianti ispezionati presenta celle con rotture complesse." },
    { n: "47%", d: "l'aumento dei microcrack rilevati tra il 2022 e il 2023." },
    { n: "100%", d: "dei moduli ispezionati dopo una grandinata presenta cricche gravi (rilevate tramite test di elettroluminescenza), sebbene a occhio nudo sembrassero integri, con una media di 5 celle danneggiate per modulo. (Claire Kearns-McCoy, responsabile CEA per le ispezioni sui moduli)" },
    { n: "93%", d: "degli impianti presenta almeno un problema grave di sicurezza, su oltre 800 impianti ispezionati." },
  ],
  source: "Fonte: Clean Energy Associates (CEA) — Ankil Sanghvi, Claire Kearns-McCoy.",
  slides: [
    {
      img: "/img/ext/6e95e152a713ffe0bbb086cf5bc680357e3fd07305ab9b6bdb00de70add9-8aa5e0.webp",
      cap: "Termografia — controllo a caldo in campo",
    },
    {
      img: "/img/ext/dc1bea447e8c6881dfcd4c75382611f6049769e7f1cba404808bda670678-4a325b.webp",
      cap: "Elettroluminescenza — test di laboratorio",
    },
    {
      img: "/img/ext/7320bff5a4563ba0212277d64b00c9b608b491d629c7e9980d0f44a53f6f-542672.webp",
      cap: "Flash Test — curva I-V in laboratorio",
    },
    {
      img: "/img/ext/2e67d65f857733a0ee26baff8dfe7a23e59e109c955a159f5298dbb261f3-6ad439.webp",
      cap: "Isolamento elettrico — test per immersione",
    },
  ],
  blocks: [
    { k: "Termografia", v: "Rileva il comportamento termico del modulo: evidenzia gli hot spot e le aree inattive che surriscaldano. Mostra i sintomi del malfunzionamento, ma non ne individua la causa (fabbrica, trasporto, installazione o manutenzione)." },
    { k: "Elettroluminescenza", v: "Fotografia \u201cai raggi X\u201d della cella: illumina il silicio con corrente e rende visibili microcrack, celle rotte e zone morte invisibili all'occhio. È il test che svela i difetti strutturali reali e la fragilità del laminato." },
    { k: "Flash Test (curva I-V)", v: "Sotto un lampo calibrato allo spettro solare (STC) si misura la curva corrente-tensione del modulo: potenza reale, Voc, Isc, fill factor. Certifica che la potenza dichiarata corrisponda a quella effettiva e smaschera i cali di rendimento nascosti." },
    { k: "Isolamento elettrico (immersione)", v: "Il modulo viene immerso in acqua per verificare la resistenza di isolamento (wet leakage). Garantisce che nessuna corrente disperda verso la cornice: è il test decisivo per la sicurezza contro folgorazioni e per la tenuta nel tempo in condizioni di umidità." },
  ],
};

export const research = {
  eyebrow: "Ricerca · Test · Sicurezza",
  title: "UnConventional Thinking.",
  body:
    "Indaghiamo aspetti spesso trascurati ma decisivi. Prove di grandine, calpestio, carico neve e stress termico: azzerare le variabili esterne significa essere autonomi senza imprevisti.",
  image: "https://thumbs.wbm.im/pw/medium/6953e05795eb911d2db73c902d12b592.jpg",
  tests: [
    { k: "Produzione", v: "Come si produce un pannello fotovoltaico", video: { id: "d_KYfZO98Jo", title: "Come si produce un pannello fotovoltaico?" } },
    { k: "Test Grandine", v: "8 volte lo standard di mercato", video: { id: "6yuvyL7_JR8", title: "Test grandine | TORRI" } },
    { k: "Calpestio", v: "Un pannello si può calpestare", video: { id: "C2wR0Z3fS1I", title: "Un pannello fotovoltaico si può calpestare" } },
    { k: "Silicio", v: "A cosa serve il silicio", video: { id: "2cCYOFyWNY0", title: "A cosa serve il silicio?" } },
    { k: "Polimero", v: "Il ruolo dei materiali incapsulanti", video: { id: "LtWlLg3OA3g", title: "Polimero" } },
    { k: "Costi", v: "Quanto costa un pannello fotovoltaico", video: { id: "WjrIE1-X82M", title: "Quanto costa un pannello fotovoltaico?" } },
  ],
};

export const news = [
  {
    id: 1, title: "Torri: la nuova frontiera della energia solare", cat: "Fiere", date: "Ago 2026", image: "/news/news-1.webp", href: "/news",
    pdf: "/news/media/news-1.pdf", pdfLabel: "Speciale Fotovoltaico — Giornale di Brescia (30.07.2026)", pdfPages: ["/news/media/news-1-p1.webp"],
    excerpt: "Rappresentante del Made in Italy di qualità, Torri Beyond Ordinary Solar è leader nazionale nella produzione di pannelli fotovoltaici robusti, sicuri e longevi.",
    body: [
      { t: "p", c: "Rappresentante del Made in Italy di qualità e profondamente radicata nella tradizione manifatturiera bresciana, Torri Beyond Ordinary Solar è leader nazionale nella produzione di pannelli fotovoltaici robusti, sicuri e longevi. Fondata sulla cultura industriale della famiglia Torri, dal 2007 l’azienda si distingue per la scelta di produrre pannelli fotovoltaici in Europa e per il costante investimento in ricerca e sviluppo." },
      { t: "p", c: "Tra le principali innovazioni spiccano le tecnologie proprietarie Prisma 4.0 e X-Core², recentemente presentata a Intersolar Europe. Il cuore di X-Core² è una cornice ingegnerizzata con inserto polimerico che genera il cosiddetto «effetto lastra», redistribuendo le sollecitazioni meccaniche sull’intera superficie del pannello." },
      { t: "p", c: "I risultati ottenuti durante lo sviluppo sono significativi: oltre il 75% di riduzione del carico concentrato e una capacità di ridistribuzione dei carichi cinque volte superiore rispetto a una cornice tradizionale. In pratica, il carico esercitato da un installatore di 90 kg passa da 1,13 kg/cm² a soli 0,255 kg/cm², riducendo drasticamente il rischio di microfratture delle celle in silicio durante tutto il ciclo di vita dell’impianto." },
      { t: "p", c: "Questa innovazione assume ancora maggiore rilevanza se confrontata con i dati di settore: secondo Clean Energy Associates, il 76% degli impianti ispezionati presenta rotture complesse delle celle, difetti spesso invisibili a occhio nudo ma in grado di generare hotspot, perdite di rendimento e potenziali criticità per la sicurezza." },
      { t: "p", c: "Tecnologia, ma non solo: Torri mette a disposizione del cliente finale un servizio completo, dalla progettazione alla realizzazione dell’impianto, affidandosi a un team interno specializzato di professionisti e installatori e a una rete di partner qualificati." },
    ],
  },
  {
    id: 2, title: "Dalla fonderia alla fabbrica di pannelli fotovoltaici", cat: "Press", date: "Ago 2026", image: "/news/news-2.webp", href: "/news",
    pdf: "/news/media/news-2.pdf", pdfLabel: "Articolo su Meccanica & Fonderia", pdfPages: ["/news/media/news-2-p1.webp"],
    excerpt: "Ci sono aziende che seguono il mercato e aziende che scelgono di costruirlo. TORRI appartiene a questa seconda categoria: una realtà industriale italiana.",
    body: [
      { t: "h", c: "La fabbrica di Manerbio" },
      { t: "p", c: "Ci sono aziende che seguono il mercato e aziende che scelgono di costruirlo. TORRI appartiene a questa seconda categoria: una realtà industriale italiana profondamente radicata nella tradizione manifatturiera e oggi leader nazionale nella progettazione e produzione di pannelli fotovoltaici sicuri e longevi." },
      { t: "p", c: "La storia dell’azienda nasce con Michele Torri, esponente della terza generazione di imprenditori della famiglia TORRI ed erede di una cultura industriale maturata all’interno della storica fonderia di Quinzano, TORRI FONDERIE. Un patrimonio di competenze nella lavorazione dei metalli, nella meccanica di precisione e nella cultura del prodotto che continua ancora oggi a rappresentare il DNA dell’azienda." },
      { t: "p", c: "È proprio questa impostazione, tipica delle migliori imprese manifatturiere italiane, ad aver portato TORRI ad affrontare il settore fotovoltaico con un approccio completamente diverso rispetto alla semplice importazione dall’Asia. Dal 2007 l’azienda investe costantemente in ricerca e sviluppo con un obiettivo preciso: realizzare pannelli fotovoltaici capaci di garantire robustezza, sicurezza e longevità ben oltre gli standard di mercato." },
      { t: "p", c: "Tra queste spicca PRISMA 4.0, il modello costruttivo che esprime l’approccio ingegneristico di TORRI alla realizzazione del pannello fotovoltaico. L’impiego di materiali selezionati e di processi produttivi proprietari consente di ottenere una struttura estremamente robusta, progettata per offrire una maggiore resistenza alle sollecitazioni meccaniche, agli eventi atmosferici estremi e alle criticità che possono compromettere la vita utile dell’impianto." },
      { t: "h", c: "Le tecnologie proprietarie Made in Brescia" },
      { t: "p", c: "Il 2026 rappresenta un ulteriore punto di svolta nella storia dell’azienda. In occasione di Intersolar Europe, TORRI ha presentato al pubblico europeo X-CORE², la nuova tecnologia proprietaria protetta da brevetto industriale, design e marchio tridimensionale, sviluppata per affrontare una delle principali criticità del fotovoltaico moderno: la fragilità strutturale dei pannelli." },
      { t: "p", c: "Il cuore della tecnologia è una speciale cornice ingegnerizzata con inserto polimerico, capace di generare il cosiddetto “effetto lastra” e di redistribuire le sollecitazioni meccaniche sull’intera superficie del pannello. I risultati ottenuti durante lo sviluppo sono particolarmente significativi: oltre il 75% di riduzione del carico concentrato e una capacità di ridistribuzione dei carichi cinque volte superiore rispetto a una cornice tradizionale." },
      { t: "p", c: "In termini pratici, il carico esercitato da un installatore di 90 kg passa da 1,13 kg/cm² a soli 0,255 kg/cm², riducendo drasticamente il rischio di microfratture delle celle in silicio durante l’intero ciclo di vita dell’impianto fotovoltaico." },
      { t: "p", c: "La risposta del mercato è stata immediata. Installatori, progettisti, EPC e operatori provenienti da tutta Europa hanno riconosciuto nella nuova tecnologia una risposta concreta alla crescente richiesta di affidabilità, sicurezza e rendimento nel lungo periodo. Parallelamente è cresciuto anche il Progetto Partner TORRI, la rete di professionisti qualificati composta da installatori e studi di progettazione che scelgono ogni giorno di rappresentare il marchio sul territorio." },
      { t: "h", c: "La divisione impianti chiavi in mano" },
      { t: "p", c: "A trainare la crescita dell’azienda è anche la divisione dedicata alla realizzazione di impianti fotovoltaici chiavi in mano. TORRI mette a disposizione del cliente finale un servizio completo, dalla progettazione alla realizzazione dell’impianto, affidandosi a un team interno specializzato di professionisti e installatori e alla propria rete di partner qualificati." },
      { t: "p", c: "Per TORRI, il futuro del fotovoltaico non può prescindere da una visione profondamente manifatturiera, legata alla cultura industriale europea: sviluppare tecnologie proprietarie e produrre in Europa beni sicuri, affidabili e durevoli nel tempo." },
    ],
  },
  {
    id: 3, title: "La serie A di pallacanestro è entrata in fabbrica con noi", cat: "Sponsor", date: "Ago 2026", image: "/news/news-3.jpg", href: "/news", youtube: "Bjq6l_hZSnI",
    excerpt: "Scopri come i campioni della pallacanestro Germani Brescia hanno testato la resistenza delle nostre tecnologie. Ne abbiamo visto delle belle!",
    body: [
      { t: "p", c: "Scopri come i campioni della pallacanestro Germani Brescia hanno testato la resistenza delle nostre tecnologie. Ne abbiamo visto delle belle!" },
    ],
  },
  {
    id: 4, title: "Come si produce un pannello fotovoltaico?", cat: "Educational", date: "Mag 2026", image: "/news/news-4.jpg", href: "/news", youtube: "d_KYfZO98Jo",
    excerpt: "Dal wafer di silicio al modulo pronto per l’installazione: scopri le fasi produttive di un pannello fotovoltaico, dalla stringatura alla laminazione fino ai test finali.",
    body: [
      { t: "p", c: "Dal wafer di silicio al modulo pronto per l’installazione: scopri le fasi produttive di un pannello fotovoltaico, dalla stringatura alla laminazione fino ai test finali." },
    ],
  },
  {
    id: 5, title: "I pannelli solari resistono alla grandine?", cat: "Educational", date: "Mag 2026", image: "/news/news-5.jpg", href: "/news", youtube: "6yuvyL7_JR8",
    excerpt: "I pannelli fotovoltaici vengono sottoposti a test contro la grandine, ma i danni invisibili possono compromettere la produzione nel tempo.",
    body: [
      { t: "p", c: "I pannelli fotovoltaici vengono sottoposti a test contro la grandine, ma i danni invisibili possono compromettere la produzione nel tempo." },
    ],
  },
  {
    id: 6, title: "A cosa serve il silicio nei pannelli fotovoltaici?", cat: "Educational", date: "Mag 2026", image: "/news/news-6.jpg", href: "/news", youtube: "2cCYOFyWNY0",
    excerpt: "Il silicio è il materiale alla base delle celle fotovoltaiche. Scopri perché viene usato nei pannelli solari e perché deve essere protetto.",
    body: [
      { t: "p", c: "Il silicio è il materiale alla base delle celle fotovoltaiche. Scopri perché viene usato nei pannelli solari e perché deve essere protetto." },
    ],
  },
  {
    id: 7, title: "A cosa serve il polimero nei pannelli fotovoltaici?", cat: "Educational", date: "Mag 2026", image: "/news/news-7.jpg", href: "/news", youtube: "LtWlLg3OA3g",
    excerpt: "Il polimero protegge le celle in silicio nei pannelli fotovoltaici. Scopri la differenza tra EVA e POE e perché incide sulla qualità del modulo.",
    body: [
      { t: "p", c: "Il polimero protegge le celle in silicio nei pannelli fotovoltaici. Scopri la differenza tra EVA e POE e perché incide sulla qualità del modulo." },
    ],
  },
  {
    id: 8, title: "Quanto costa un pannello fotovoltaico?", cat: "Educational", date: "Mag 2026", image: "/news/news-8.jpg", href: "/news", youtube: "WjrIE1-X82M",
    excerpt: "Il costo di un pannello fotovoltaico dipende da silicio, vetro, polimeri, manodopera e controlli qualità. Ecco cosa incide davvero sul prezzo finale.",
    body: [
      { t: "p", c: "Il costo di un pannello fotovoltaico dipende da silicio, vetro, polimeri, manodopera e controlli qualità. Ecco cosa incide davvero sul prezzo finale." },
    ],
  },
  {
    id: 9, title: "Un pannello fotovoltaico si può calpestare?", cat: "Educational", date: "Mag 2026", image: "/news/news-9.jpg", href: "/news", youtube: "C2wR0Z3fS1I",
    excerpt: "Camminare sopra un pannello fotovoltaico può causare microcricche invisibili e perdita di potenza. Ecco perché è meglio evitarlo.",
    body: [
      { t: "p", c: "Camminare sopra un pannello fotovoltaico può causare microcricche invisibili e perdita di potenza. Ecco perché è meglio evitarlo." },
    ],
  },
  {
    id: 10, title: "Durabilità, affidabilità e qualità costruttiva sono l'anima della tecnologia italiana — con PV Magazine", cat: "Press", date: "Mar 2026", image: "/news/news-10.webp", href: "/news",
    pdf: "/news/media/news-10.pdf", pdfLabel: "PV Magazine Italia — Edizione Speciale Key Rimini 2026", pdfPages: ["/news/media/news-10-p1.webp", "/news/media/news-10-p2.webp", "/news/media/news-10-p3.webp", "/news/media/news-10-p4.webp", "/news/media/news-10-p5.webp"],
    excerpt: "Michele Torri, fondatore e CEO di Torri Solar, spiega a pv magazine Italia di essere favorevole a un requisito Made in EU solo a determinate condizioni.",
    body: [
      { t: "h", c: "La voce di Torri Solar" },
      { t: "p", c: "Michele Torri, fondatore e CEO di Torri Solar, spiega a pv magazine Italia di essere favorevole a un requisito Made in EU solo a determinate condizioni. “Per noi Made in EU non può limitarsi al semplice assemblaggio finale in Europa: deve significare valore industriale reale generato sul territorio, con criteri chiari su filiera, tracciabilità, responsabilità produttiva e continuità nel tempo”, dice Torri." },
      { t: "p", c: "Secondo l’imprenditore, la filiera italiana ha una “cultura del fare prodotto” profondamente diversa rispetto a modelli industriali extra-UE. “La manifattura italiana, e in particolare quella legata all’ingegneria e al prodotto energetico, è storicamente orientata a durabilità, affidabilità e qualità costruttiva, non alla logica del costo minimo o della sostituzione rapida”, sostiene Torri." },
      { t: "p", c: "Torri considera comunque il Made in EU un’opportunità, soprattutto nel caso di regole chiare. “Torri si posiziona in modo unico: non come alternativa al prodotto mainstream solamente perché prodotto in Italia, ma come categoria distinta, che mette al centro la resistenza meccanica, la sicurezza dell’impianto e la continuità delle prestazioni nel lungo periodo”." },
      { t: "p", c: "“Nei bandi pubblici e nei meccanismi di incentivo dovrebbero entrare criteri tecnici più evoluti: requisiti di robustezza, sicurezza antincendio, ispezionabilità, affidabilità nel lungo periodo e modelli costruttivi che riducano il rischio operativo degli impianti”, dice Torri, che chiede poi sostegno strutturale agli investimenti industriali orientati verso brevetti e innovazione di prodotto." },
      { t: "p", c: "Torri afferma che, per il 2026, vuole consolidare la crescita della produzione italiana, introducendo tra l’altro nel mercato italiano il pannello X-Core². Al momento la capacità produttiva è di circa 80 MW annui. “Introdurremo un ulteriore sistema di elettroluminescenza direttamente in fase di stringatura, che si affiancherà ai due controlli già presenti in linea, con l’obiettivo di azzerare le criticità legate al circuito in silicio e innalzare ulteriormente gli standard qualitativi”, dichiara Torri." },
      { t: "p", c: "“Vediamo l’n-Type come la base industriale più solida oggi disponibile, mentre soluzioni come xBC potranno trovare spazio in segmenti dove qualità ed efficienza vengono realmente valorizzate. La perovskite rappresenta un’area di grande interesse tecnologico, ma prima di diventare rilevante dovrà dimostrare stabilità, durabilità e affidabilità certificata nel mondo reale”." },
      { t: "p", c: "Secondo Torri, il modello costruttivo Prisma 4.0 massimizza sicurezza e longevità del modulo: “pannelli tre volte più robusti e otto volte più resistenti alla grandine rispetto al prodotto mainstream e ai requisiti IEC di riferimento. Stessa filosofia della tecnologia X-Core² (domanda di brevetto depositata), che ridistribuisce il carico applicato sul pannello fino a 5 volte”." },
      { t: "p", c: "Fonte: PV Magazine — Sergio Matalucci e Massimiliano Tripodo." },
    ],
  },
  {
    id: 11, title: "Grande successo a Key Energy 2026: oltre 120 partner presenti allo stand", cat: "Fiere", date: "Mar 2026", image: "/news/news-11.webp", href: "/news",
    excerpt: "Si è appena conclusa Key Energy 2026, uno degli appuntamenti più importanti in Europa per il settore delle energie rinnovabili. Per TORRI è stata un’edizione particolarmente significativa.",
    body: [
      { t: "p", c: "Si è appena conclusa Key Energy 2026, uno degli appuntamenti più importanti in Europa per il settore delle energie rinnovabili. Per TORRI è stata un’edizione particolarmente significativa: tre giorni di incontri, confronto tecnico con installatori e professionisti del settore, e soprattutto la presentazione al pubblico della nuova tecnologia brevettata." },
      { t: "p", c: "Durante la manifestazione oltre 500 installatori si sono fermati allo stand per approfondire le caratteristiche dei moduli, mentre 120 partner TORRI sono passati a trovarci per confrontarsi su progetti, opportunità di mercato e sviluppi futuri. A questi si aggiungono oltre 30 nuove richieste di adesione al progetto partner, un segnale concreto di come la rete stia continuando a crescere." },
      { t: "h", c: "La prima presentazione pubblica della tecnologia X-CORE², con domanda di brevetto depositata" },
      { t: "p", c: "Focus della fiera è stata la prima presentazione ufficiale al pubblico della tecnologia X-CORE², con domanda di brevetto depositata, sviluppata da TORRI per migliorare la protezione del circuito in silicio e aumentare la robustezza strutturale del modulo fotovoltaico. La risposta del pubblico è stata immediata: installatori e operatori del settore hanno dimostrato grande interesse per un approccio progettuale che punta a rafforzare la sicurezza e l’affidabilità del pannello nel lungo periodo." },
      { t: "h", c: "Il ruolo della fabbrica: dove nasce la qualità del modulo" },
      { t: "p", c: "A Key Energy molti installatori hanno voluto approfondire la centralità della fabbrica nel determinare la qualità reale di un modulo fotovoltaico. TORRI progetta e realizza i propri pannelli in Italia seguendo un modello produttivo che mette al centro processi industriali controllati, selezione dei materiali, tecnologie costruttive proprietarie e standard elevati di robustezza e protezione del circuito in silicio." },
      { t: "h", c: "Made in Italy, tecnologia e affidabilità nel tempo" },
      { t: "p", c: "Nel mercato globale del fotovoltaico, spesso dominato da logiche di costo e produzione su larga scala, TORRI porta avanti un posizionamento chiaro: valorizzare la qualità industriale del prodotto e la solidità del processo produttivo. La partecipazione a Key Energy 2026 ha confermato come il mercato stia guardando con sempre maggiore attenzione non solo all’efficienza, ma anche a robustezza, affidabilità e qualità costruttiva." },
    ],
  },
  {
    id: 12, title: "Bando Agrisolare 2026: fino all'80% di fondo perduto per i pannelli fotovoltaici TORRI", cat: "Bandi", date: "Mar 2026", image: "/news/news-12.webp", href: "/news",
    excerpt: "Sono state pubblicate le linee guida definitive del bando Agrisolare 2026, il programma di incentivi dedicato alla diffusione del fotovoltaico nel comparto agricolo.",
    body: [
      { t: "p", c: "Sono state pubblicate le linee guida definitive del bando Agrisolare 2026, il programma di incentivi dedicato alla diffusione del fotovoltaico nel comparto agricolo e agroindustriale. L’apertura dello sportello è prevista dal 10 marzo 2026 al 9 aprile 2026, con procedura a sportello fino a esaurimento delle risorse disponibili, pari a 789 milioni di euro." },
      { t: "p", c: "Il bando è rivolto a imprenditori agricoli, imprese agroindustriali e cooperative agricole e prevede un contributo a fondo perduto fino all’80% dell’investimento, con un massimale di 1.000 €/kWp per l’impianto fotovoltaico. Sono inoltre ammissibili sistemi di accumulo fino a 700 €/kWh (massimo 50.000 euro complessivi) e infrastrutture di ricarica per veicoli elettrici fino a 10.000 euro." },
      { t: "h", c: "Registro ENEA e requisiti tecnici dei moduli fotovoltaici" },
      { t: "p", c: "Uno degli aspetti centrali del bando Agrisolare è l’obbligo di utilizzare moduli fotovoltaici, come i moduli TORRI, iscritti nel registro ENEA. Questo requisito introduce un elemento fondamentale nella scelta del prodotto: non solo conformità normativa, ma anche tracciabilità della filiera e garanzia dei processi produttivi." },
      { t: "p", c: "I pannelli TORRI sono progettati e prodotti in Italia, registrati presso il portale ENEA e realizzati con tecnologia PRISMA 4.0, il modello costruttivo avanzato che aumenta la robustezza del modulo e la protezione del circuito in silicio, garantendo maggiore sicurezza e longevità dell’impianto." },
      { t: "h", c: "Agrisolare come leva per investimenti durevoli" },
      { t: "p", c: "Per le aziende agricole, dove gli impianti sono esposti a carichi strutturali, escursioni termiche e sollecitazioni ambientali costanti, diventa determinante affidarsi a un prodotto progettato secondo criteri industriali avanzati. In questo scenario, il bando Agrisolare non rappresenta solo un incentivo economico, ma un’opportunità per investire in impianti realizzati con standard costruttivi superiori e pienamente conformi ai requisiti normativi." },
    ],
  },
  {
    id: 13, title: "Fotovoltaico Made in Italy: dalla fabbrica TORRI la visione tecnica e tecnologica per sicurezza e longevità degli impianti", cat: "Eventi", date: "Feb 2026", image: "/news/news-13.webp", href: "/news",
    excerpt: "Presso la fabbrica TORRI si è svolta la Convention della rete vendita Italia, un momento di confronto strategico e tecnico dedicato all’evoluzione del mercato fotovoltaico.",
    body: [
      { t: "p", c: "Presso la fabbrica TORRI si è svolta la Convention della rete vendita Italia, un momento di confronto strategico e tecnico dedicato all’evoluzione del mercato fotovoltaico e agli sviluppi di prodotto e di processo previsti per il 2026. L’incontro ha messo al centro i risultati raggiunti e la direzione futura: investimenti in fabbrica, sviluppo di nuove tecnologie, rafforzamento dei controlli qualità e strumenti operativi pensati per aumentare sicurezza, resistenza e longevità degli impianti fotovoltaici." },
      { t: "h", c: "Fabbrica e sviluppo tecnico: il cuore del fotovoltaico ad alta affidabilità" },
      { t: "p", c: "Nel modello TORRI la fabbrica non è solo un luogo produttivo, ma un centro di sviluppo tecnico e controllo industriale. La produzione fotovoltaica Made in Italy viene gestita con processi evoluti e verifiche multilivello lungo tutta la linea, con l’obiettivo di ridurre i rischi nascosti legati a micro-difetti e sollecitazioni meccaniche che possono compromettere nel tempo sicurezza e durata dei moduli." },
      { t: "h", c: "Tecnologie e modello costruttivo: più sicurezza e resistenza" },
      { t: "p", c: "Ampio spazio è stato dedicato alle tecnologie proprietarie e al modello costruttivo adottato sui moduli TORRI, sviluppato per aumentare la resistenza alle sollecitazioni, la protezione del circuito in silicio e la sicurezza complessiva del sistema fotovoltaico. La direzione tecnica è chiara: non inseguire la standardizzazione del mercato, ma investire in tecnologie costruttive che migliorano robustezza strutturale, comportamento agli eventi atmosferici e affidabilità nel ciclo di vita dell’impianto." },
      { t: "h", c: "Roadmap 2026: evoluzione di prodotto, strumenti e servizi" },
      { t: "p", c: "La roadmap tecnica e operativa presentata per il 2026 include nuove soluzioni di prodotto, strumenti gestionali e servizi di supporto, progettati per aumentare la qualità esecutiva e la consapevolezza tecnica lungo tutta la filiera del fotovoltaico. Dal confronto emerso durante l’incontro, il messaggio è netto: il futuro del fotovoltaico non si misura solo in potenza installata, ma nella sicurezza dell’impianto, nella resistenza dei moduli e nella longevità delle prestazioni." },
    ],
  },
  {
    id: 14, title: "TORRI X-CORE² la nuova frontiera della sicurezza nel fotovoltaico", cat: "Press", date: "Ott 2025", image: "/news/news-14.jpg", href: "/news", youtube: "kkloOmlk5e8",
    gallery: [{ src: "/news/media/news-14-extra.webp", caption: "Giornale di Brescia — Speciale Fabbrica Fotovoltaico (08.10.2025)" }],
    excerpt: "Al Museo Mille Miglia di Brescia, davanti a 150 installatori partner, Torri Solare ha presentato la nuova tecnologia X-CORE², con domanda di brevetto depositata.",
    body: [
      { t: "p", c: "Nell’evoluzione tecnologica del settore fotovoltaico Torri Solare va di corsa. È appropriata la scelta del Museo Mille Miglia per presentare a 150 installatori partner dell’azienda bresciana guidata da Michele Torri la nuova tecnologia X-CORE², con domanda di brevetto depositata. La tecnologia “by Torri Solare” è protetta da domanda di brevetto per invenzione industriale, design e marchio tridimensionale." },
      { t: "p", c: "Le caratteristiche. Sviluppando X-CORE² Torri Solare ha guardato alla robustezza. Nei pannelli fotovoltaici un aspetto cruciale è rappresentato dalla fragilità strutturale della maggior parte dei moduli oggi sul mercato." },
      { t: "p", c: "La criticità. Secondo i dati Clean Energy Associates (CEA, 2024), il 76% degli impianti ispezionati presenta rotture complesse delle celle in silicio: difetti invisibili a occhio nudo ma capaci di generare hotspot, cali di rendimento e, nel tempo, rischi di incendio. Causa principale delle microfratture è il calpestio nell’installazione e manutenzione." },
      { t: "p", c: "La soluzione. Torri Solare ha messo a punto la tecnologia X-CORE², attualmente l’unica soluzione che sfrutta “l’effetto lastra” del pannello grazie a un profilo speciale con inserto polimerico. I risultati sono straordinari: più del 75% in meno del carico concentrato, una ridistribuzione del carico 5 volte migliore. Questo si traduce nella garanzia “Unica”: copertura per 10 anni sui danni da calpestio durante l’installazione, 10 anni su danni causati da grandine, 10 anni sulle spese di sostituzione." },
      { t: "h", c: "Successo travolgente: collocati in prevendita 2,5 megawatt" },
      { t: "p", c: "«Con X-CORE² – spiega Michele Torri, fondatore e guida dell’azienda – ci siamo concentrati sulla solidità costruttiva, sviluppando una cornice, con domanda di brevetto depositata, che rende il modulo calpestabile e capace di resistere a carichi elevati senza compromettere l’integrità del silicio». Già con la tecnologia Prisma 4.0, Torri aveva ridefinito gli standard di resistenza: pannelli otto volte più robusti alla grandine, tre volte più resistenti agli urti accidentali e in grado di sopportare fino a 750 kg/mq di carico neve." },
      { t: "p", c: "Il nuovo modulo è stato presentato in anteprima al Museo Mille Miglia di Brescia, ottenendo un riscontro immediato dalla rete commerciale. «In pochi giorni abbiamo raccolto una prevendita di 2,5 megawatt, per un prodotto che sarà in consegna da febbraio 2026». Oggi Torri Solare registra una crescita dell’85% del fatturato, distribuito in modo equilibrato tra il segmento abitativo e quello industriale." },
      { t: "p", c: "Fonte: Giornale di Brescia." },
    ],
  },
  {
    id: 15, title: "Anteprima X-CORE²: un nuovo riferimento per la sicurezza nel fotovoltaico", cat: "Eventi", date: "Ago 2025", image: "/news/news-15.webp", href: "/news",
    excerpt: "Il Museo Mille Miglia di Brescia è stato il palcoscenico dell’anteprima della nuova tecnologia X-CORE², con oltre 55 professionisti tra rete vendita e partner.",
    body: [
      { t: "p", c: "Il Museo Mille Miglia di Brescia è stato il palcoscenico dell’anteprima della nuova tecnologia X-CORE², un evento che ha visto la partecipazione di oltre 55 professionisti, tra rete vendita e una selezione di partner della community Torri. Un incontro prezioso, dove abbiamo condiviso non solo i dettagli tecnici di una tecnologia destinata a segnare un nuovo riferimento nel mercato, ma anche visioni, feedback e riflessioni strategiche sul futuro del fotovoltaico." },
      { t: "h", c: "Un’anteprima che anticipa il lancio ufficiale" },
      { t: "p", c: "L’evento ha confermato l’interesse e l’attesa verso X-CORE²: un prodotto che porta la sicurezza, la robustezza e la durata dei pannelli fotovoltaici a un livello mai raggiunto prima. Il confronto diretto con i partner ci ha permesso di validare le nostre scelte industriali e di prepararci al passo successivo: il lancio ufficiale, che si terrà di nuovo a Brescia, sempre al Museo Mille Miglia, con una platea di circa 200 partecipanti da tutta Italia." },
      { t: "h", c: "Non solo tecnica: un momento di comunità" },
      { t: "p", c: "Oltre alla presentazione tecnica, l’anteprima è stata soprattutto un’occasione di incontro. Un momento per rafforzare la rete, condividere i valori che ci uniscono e ribadire il nostro posizionamento: Torri non è “anche noi”, ma il riferimento dell’alta gamma del fotovoltaico." },
      { t: "h", c: "Uno sguardo al futuro" },
      { t: "p", c: "Con il lancio ufficiale di X-CORE², Torri conferma la propria vocazione: innovare senza compromessi, offrendo al mercato il pannello fotovoltaico più sicuro e robusto al mondo. Un percorso coerente con la nostra missione: difendere il valore industriale del prodotto, contro la logica della standardizzazione e del prezzo al ribasso." },
    ],
  },
  {
    id: 16, title: "Torri Solare al Giornale di Brescia: nasce la Comunità Energetica Nazionale Torri", cat: "Press", date: "Lug 2025", image: "/news/news-16.jpg", href: "/news",
    gallery: [{ src: "/news/media/news-16-extra.webp", caption: "Bonus fotovoltaico e CER — fondo perduto fino al 40%" }],
    excerpt: "La CER Torri non è un’iniziativa isolata: è una rete energetica nazionale strutturata, con 70 configurazioni locali già in fase di attivazione.",
    body: [
      { t: "p", c: "Si è parlato di Comunità Energetiche Rinnovabili nella sede del Giornale di Brescia, durante un incontro che ha riunito voci del territorio, istituzioni, imprese ed esperti del settore. Per Torri Solare è stato anche il momento ideale per raccontare la visione che sta dietro alla nascita della CER Nazionale Torri." },
      { t: "h", c: "Dal territorio alla rete nazionale: la visione Torri" },
      { t: "p", c: "“Ogni volta che si parla di CER c’è il rischio di scoraggiarsi. Ma noi vogliamo proporre una lettura diversa: e se non fosse più una questione di quante comunità attivare, ma di quanta energia possiamo generare insieme?” Con queste parole è stato rilanciato il messaggio centrale della Comunità Energetica Nazionale Torri: un progetto che parte dalle competenze industriali dell’azienda, si fonda sul prodotto italiano e si espande con una rete nazionale strutturata." },
      { t: "h", c: "Prodotto, fabbrica, rete: la filiera italiana che genera valore" },
      { t: "p", c: "Torri Solare non si limita a promuovere l’adesione alle CER: le costruisce e le gestisce, partendo da un impianto produttivo nato nel 2007 e da una vocazione industriale chiara. La CER Torri si basa su tre pilastri: Prodotto (pannelli fotovoltaici realizzati in Italia), Fabbrica (know-how tecnico e industriale consolidato) e Rete (oltre 150 partner locali attivi nella rete Beyond Partner)." },
      { t: "h", c: "Un’opportunità concreta: fondo perduto al 40%" },
      { t: "p", c: "Un elemento distintivo della CER Torri è l’accesso diretto a un fondo perduto fino al 40%, dedicato ai cittadini e alle imprese dei Comuni con meno di 50.000 abitanti. Un vantaggio che Torri gestisce internamente, semplificando l’iter e garantendo un supporto reale all’investimento iniziale." },
      { t: "h", c: "70 configurazioni attive, una governance centralizzata" },
      { t: "p", c: "La CER Torri è una rete energetica nazionale strutturata, con 70 configurazioni locali già in fase di attivazione, ognuna legata a una cabina primaria, tutte governate da un’associazione promossa da Torri. Un modello che garantisce regole chiare, continuità e sostenibilità nel tempo." },
      { t: "p", c: "Fonte: Giornale di Brescia." },
    ],
  },
  {
    id: 17, title: "Torri e Confartigianato Mantova: l'eccellenza è nel DNA dei nostri territori", cat: "Eventi", date: "Mag 2025", image: "/news/news-17.jpg", href: "/news",
    gallery: [{ src: "/news/media/news-17-extra.jpg", caption: "L'incontro con Confartigianato Imprese Mantova" }],
    excerpt: "Torri ha partecipato come relatore all’evento di Confartigianato Imprese Mantova dedicato al nuovo bando per l’autoproduzione di energia da fonti rinnovabili.",
    body: [
      { t: "p", c: "Torri ha partecipato in qualità di relatore all’evento promosso da Confartigianato Imprese Mantova dedicato al nuovo bando per l’autoproduzione di energia da fonti rinnovabili, rivolto alle piccole e medie imprese italiane. L’incontro, che ha coinvolto oltre quaranta professionisti tra installatori, tecnici e imprenditori, ha rappresentato un’importante occasione di aggiornamento e confronto sulle opportunità offerte dal fotovoltaico nel 2025." },
      { t: "h", c: "Incentivi fino al 65% per chi investe in energia solare" },
      { t: "p", c: "Il bando, gestito da Invitalia per conto del Ministero delle Imprese e del Made in Italy, mette a disposizione 320 milioni di euro in contributi a fondo perduto per l’installazione di impianti fotovoltaici o mini-eolici destinati all’autoconsumo. Le agevolazioni includono fino al 40% dell’investimento per micro e piccole imprese, fino al 30% per medie imprese, un ulteriore 30% per i sistemi di accumulo e fino al 50% per la diagnosi energetica preliminare." },
      { t: "h", c: "Il ruolo strategico degli installatori partner" },
      { t: "p", c: "Durante l’intervento di Torri è stato evidenziato come l’installatore oggi ricopra un ruolo sempre più strategico: non solo tecnico, ma anche consulenziale. Per questo motivo, Torri rinnova il proprio impegno a fornire supporto tecnico e documentale ai propri installatori partner, offrendo soluzioni fotovoltaiche di alta gamma, affidabili e pensate per durare nel tempo." },
      { t: "p", c: "Per le aziende, questo bando rappresenta un’occasione concreta per ridurre i costi energetici, migliorare la propria sostenibilità ambientale e valorizzare l’immobile attraverso impianti ad alte prestazioni." },
    ],
  },
  {
    id: 18, title: "Torri al Key Energy 2025: tre giorni di innovazione e connessioni!", cat: "Fiere", date: "Mar 2025", image: "/news/news-18.webp", href: "/news",
    excerpt: "Rimini, 5-7 Marzo 2025 — Si è conclusa un’edizione straordinaria di KEY ENERGY 2025, il punto di riferimento per il settore delle energie rinnovabili.",
    body: [
      { t: "p", c: "Rimini, 5-7 Marzo 2025 — Si è conclusa un’edizione straordinaria di KEY ENERGY 2025, il punto di riferimento per il settore delle energie rinnovabili. Per tre giorni il nostro stand è stato un luogo di confronto e di scambio, dove abbiamo accolto partner, clienti, professionisti e nuove realtà interessate a scoprire la nostra visione del fotovoltaico di alta gamma." },
      { t: "p", c: "Abbiamo avuto il piacere di presentare da vicino la nostra tecnologia PRISMA 4.0, il nostro approccio all’innovazione Made in Italy e il valore del nostro Progetto Partner, pensato per creare una rete sempre più solida tra produttore e installatore." },
      { t: "p", c: "Ogni confronto avuto in questi giorni ha rafforzato la consapevolezza che la qualità, la ricerca e un network di professionisti preparati sono gli elementi chiave per un futuro energetico sostenibile e di eccellenza." },
    ],
  },
  {
    id: 19, title: "Fotovoltaico Made in Italy per l'industria: prodotti di eccellenza e vero valore industriale", cat: "Press", date: "Mar 2026", image: "/img/ext/8zgsi8zr_IMG_4555-9ad22e.webp", href: "/news",
    gallery: [
      { src: "/img/ext/ljc5sgpg_IMG_4553-15afde.webp", caption: "Colonnina di ricarica presso il polo produttivo TORRI." },
    ],
    excerpt: "Per il fotovoltaico Made in Italy è tempo di certezze. La visione industriale di TORRI: robustezza, sicurezza e valore reale generato sul territorio.",
    body: [
      { t: "p", c: "La produzione europea a supporto della filiera fotovoltaica si trova a un punto di svolta. In un contesto normativo in evoluzione, l'industria italiana chiede regole chiare e orizzonti temporali di lungo periodo per programmare investimenti e capacità produttiva. Per TORRI, azienda bresciana che produce pannelli fotovoltaici Made in Italy dal 2007, il momento rappresenta soprattutto un'opportunità: quella di riconoscere e valorizzare il vero valore industriale, non la semplice capacità di assemblaggio." },
      { t: "h", c: "Cosa significa davvero Made in Italy per l'industria" },
      { t: "p", c: "\"Per noi Made in EU non può limitarsi al semplice assemblaggio finale in Europa: deve significare valore industriale reale generato sul territorio, con criteri chiari su filiera, tracciabilità, responsabilità produttiva e continuità nel tempo\", spiega Michele Torri, fondatore e CEO dell'azienda. La manifattura italiana, in particolare quella legata all'ingegneria e al prodotto energetico, è storicamente orientata a durabilità, affidabilità e qualità costruttiva, non alla logica del costo minimo o della sostituzione rapida." },
      { t: "p", c: "In questo quadro TORRI si posiziona in modo distinto: non come alternativa al prodotto mainstream solo perché realizzato in Italia, ma come categoria a sé, che mette al centro la resistenza meccanica, la sicurezza dell'impianto e la continuità delle prestazioni nel lungo periodo — elementi decisivi per il fotovoltaico industriale, dove le superfici sono ampie e la fermata di un impianto ha un costo reale." },
      { t: "h", c: "Incentivi e bandi: servono criteri tecnici evoluti" },
      { t: "p", c: "Perché il Made in Italy generi valore per l'industria servono politiche capaci di distinguere tra semplice capacità produttiva e vero valore industriale, premiando chi costruisce tecnologia con una visione di lungo periodo. \"Nei bandi pubblici e nei meccanismi di incentivo dovrebbero entrare criteri tecnici più evoluti: requisiti di robustezza, sicurezza antincendio, ispezionabilità, affidabilità nel lungo periodo e modelli costruttivi che riducano il rischio operativo degli impianti\", osserva Torri, che chiede anche un sostegno strutturale agli investimenti orientati a brevetti e innovazione di prodotto." },
      { t: "h", c: "Produzione italiana e qualità: gli obiettivi 2026" },
      { t: "p", c: "Per il 2026 TORRI punta a consolidare la crescita della produzione italiana e a introdurre sul mercato nazionale il pannello X-Core². La capacità produttiva è oggi di circa 80 MW annui. A supporto del percorso sono previsti investimenti mirati sui processi produttivi e sul controllo qualità: verrà introdotto un ulteriore sistema di elettroluminescenza direttamente in fase di stringatura, che si affiancherà ai due controlli già presenti in linea, con l'obiettivo di azzerare le criticità legate al circuito in silicio. È inoltre in programma l'inserimento di una corniciatura automatica per ridurre i tempi di attesa e migliorare l'efficienza operativa." },
      { t: "p", c: "Sul fronte tecnologico, l'azienda considera l'n-Type la base industriale più solida oggi disponibile. Il modello costruttivo PRISMA 4.0 massimizza sicurezza e longevità del modulo — pannelli fino a tre volte più robusti e otto volte più resistenti alla grandine rispetto al prodotto mainstream e ai requisiti IEC di riferimento — mentre la tecnologia X-Core², con domanda di brevetto depositata, ridistribuisce il carico applicato sul pannello fino a cinque volte." },
      { t: "h", c: "Produrre in Italia per ridurre il rischio" },
      { t: "p", c: "Nel contesto attuale, i legami strutturali con filiere lontane comportano rischi crescenti: dipendenza dalla supply chain, volatilità normativa, pressione continua sui prezzi e potenziali criticità reputazionali. \"Nel nostro caso la scelta è stata chiara: ridurre strutturalmente il rischio attraverso una produzione in Italia\", afferma Torri. \"Non vediamo la nostra indipendenza come un vincolo, ma come un'opportunità strategica: se il mercato e le regole inizieranno a valorizzare davvero robustezza, sicurezza, compliance e affidabilità nel lungo periodo, l'alta gamma europea non sarà più un'eccezione, ma un riferimento.\"" },
    ],
  },
];

export const newsCategories = ["Tutte", "Press", "Eventi", "Fiere", "Educational", "Bandi", "Sponsor"];

export const manifesto = {
  line: "Buy for Life,\nnot for Now.",
  sub: "La più grande ambizione è rappresentare, attraverso i nostri prodotti, un'industria che nella storia ha modellato il proprio DNA con l'eccellenza. I tempi sono maturi per il fotovoltaico Made in Italy.",
};

export const footer = {
  columns: [
    {
      title: "Azienda",
      links: [
        { label: "Il gruppo", href: "/azienda" },
        { label: "Fabbrica", href: "/azienda#fabbrica" },
        { label: "Certificazioni", href: "/azienda#certificazioni" },
        { label: "Solar Lab", href: "/azienda#solar-lab" },
        { label: "Timeline", href: "/azienda#timeline" },
      ],
    },
    {
      title: "Tecnologie",
      links: [
        { label: "X-CORE²", href: "/tecnologia#tech-x-core-2" },
        { label: "PRISMA 4.0", href: "/tecnologia#tech-prisma-4-0" },
        { label: "ECO-RED", href: "/tecnologia#tech-eco-red" },
        { label: "AURA", href: "/tecnologia#tech-aura" },
        { label: "Ai VESTA", href: "/tecnologia#tech-ai-vesta", vesta: true },
      ],
    },
    {
      title: "Configuratore",
      links: [
        { label: "Chiavi in mano", href: "https://configuratore.torri.solar", desc: "Progetta il tuo impianto" },
        { label: "Analisi bolletta", href: "https://configuratore.torri.solar/free/bolletta", desc: "Stima consumi e risparmio" },
        { label: "Dimensiona sul tetto", href: "https://configuratore.torri.solar/free/tetto", desc: "Misura la superficie utile" },
        { label: "Stazione di ricarica", href: "https://configuratore.torri.solar/free/colonnina", desc: "Configura la tua colonnina" },
      ],
    },
  ],
  extraColumn: {
    title: "Contenuti extra",
    links: [
      { label: "Pannelli fotovoltaici italiani", href: "/pannelli-fotovoltaici-italiani" },
      { label: "Produzione Made in Italy", href: "/produzione-di-pannelli-fotovoltaici-made-in-italy" },
      { label: "Fotovoltaico sul tetto", href: "/fotovoltaico-tetto" },
      { label: "Fotovoltaico a Brescia", href: "/fotovoltaico/brescia" },
      { label: "Fotovoltaico a Bergamo", href: "/fotovoltaico/bergamo" },
    ],
  },
  contact: {
    phone: "+39 030 6480034",
    phoneHref: "tel:+390306480034",
    address: "Via Cremona 123, 25025 Manerbio (BS)",
    email: "info@torrisolare.it",
  },
  legal: [
    { label: "Privacy Policy", href: "/legali/privacy-policy" },
    { label: "Cookie Policy", href: "/legali/cookie-policy" },
    { label: "Note Legali", href: "/legali/note-legali" },
  ],
};

// ---------- Chiavi in mano (Divisione Impianti) ----------
export const chiavi = {
  hero: {
    eyebrow: "Impianti · Chiavi in mano",
    title: "Dalla qualità del produttore",
    highlight: "alla garanzia del chiavi in mano.",
    sub: "Con i pannelli Made in Italy di TORRI. In pochi minuti e in autonomia: profilazione, analisi della bolletta, misurazione del tetto e la tua analisi personalizzata. Poi prenoti una consulenza con un nostro esperto.",
  },
  configurator: {
    eyebrow: "Configuratore online",
    title: "Progetta il tuo impianto in pochi minuti.",
    body: "Profilazione, analisi della bolletta, misurazione del tetto e analisi personalizzata: il configuratore ti guida passo dopo passo. Al termine prenoti una consulenza con un nostro esperto.",
    ctaLabel: "Configura il tuo impianto fotovoltaico ora",
    ctaHref: "https://configuratore.torri.solar",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxsYXB0b3AlMjBzb2xhciUyMGVuZXJneSUyMHNvZnR3YXJlJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc4NjIxMzU0NHww&ixlib=rb-4.1.0&q=85",
  },
  segments: [
    { tag: "Industriale & Agro-industriale", head: "Iper-ammortamento 2026 e incentivo Agrisolare", body: "Per imprese, industrie, artigiani e attività agricole che vogliono abbattere la bolletta, aumentare l'autoconsumo ed efficientare lo stabilimento.", img: "https://images.unsplash.com/photo-1726776230760-ae81dc9d4e55?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwd2FyZWhvdXNlJTIwcm9vZnRvcCUyMHNvbGFyJTIwcGFuZWxzfGVufDB8fHx8MTc4NjI3NTQ4OXww&ixlib=rb-4.1.0&q=85" },
    { tag: "Residenziale", head: "Autoproduci l'energia e recupera il 50%", body: "Per privati che vogliono rendere la propria abitazione più autonoma, sostenibile e meno dipendente dai costi dell'energia.", img: "/media/IMG_7869.webp" },
    { tag: "Utility Scale", head: "Metti a reddito un terreno o una superficie", body: "Per proprietari di terreni o grandi superfici che vogliono trasformare uno spazio inutilizzato in una nuova opportunità economica.", img: "https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHx1dGlsaXR5JTIwc2NhbGUlMjBzb2xhciUyMGZhcm0lMjBmaWVsZCUyMGFlcmlhbHxlbnwwfHx8fDE3ODYyNzU0ODl8MA&ixlib=rb-4.1.0&q=85" },
  ],
  community: {
    eyebrow: "Installatori Partner",
    title: "La più grande Community Italiana.",
    body: "I nostri Installatori Partner sono la garanzia di un'installazione di grande precisione e qualità, di un servizio pre e post vendita di eccellenza in tutta Italia. Contatta un nostro Installatore Partner, entra nel mondo del fotovoltaico insieme a TORRI e vivi un'esperienza di prodotto integrata.",
    ctaLabel: "Trova un installatore",
    ctaHref: "/installatori",
    image: "https://images.unsplash.com/photo-1635424709961-f3a150459ad4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxzb2xhciUyMGluc3RhbGxlcnMlMjB0ZWFtJTIwd29ya2luZyUyMHJvb2Z0b3B8ZW58MHx8fHwxNzg2MjEzNTQ0fDA&ixlib=rb-4.1.0&q=85",
  },
  simulation: {
    eyebrow: "Simulazioni & Business plan",
    title: "Ogni scelta parte dai numeri.",
    body: "Un impianto fotovoltaico deve generare valore nel tempo. La progettazione tecnica è affiancata sempre da una valutazione economica dettagliata, costruita su dati reali e simulazioni: consumi rilevati, produzione stimata, percentuale di autoconsumo, energia scambiata, risparmio annuo e ritorno dell'investimento.",
    image: "/img/ext/hqxxf9nx_IMG_6828-18f80f.webp",
    image2: "/img/ext/9yasq1kx_IMG_6829-10e6b2.webp",
  },
  divisione: {
    eyebrow: "Divisione Impianti",
    title: "Una realtà industriale, dalla produzione al cantiere.",
    body: "La nostra è una realtà industriale che integra la produzione di pannelli fotovoltaici al mondo del chiavi in mano. Contattaci per un preventivo ed affidati ad un interlocutore industriale competitivo e competente.",
    services: [
      { name: "Installazione impianti fotovoltaici", img: "/img/ext/o9y3ilww_IMG_6385-adf319.webp" },
      { name: "Rimozione amianto", img: "/img/ext/6a2h95eh_IMG_6389-6bc40f.webp" },
      { name: "Produzione e installazione quadri elettrici", img: "/turnkey/quadri-elettrici.webp?v=2" },
      { name: "Costruzione e rifacimento cabine MT", img: "/turnkey/cabine-mt.webp?v=2" },
    ],
    image: "https://images.unsplash.com/photo-1635424709870-cdc6e64f0e20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxzb2xhciUyMGluc3RhbGxlcnMlMjB0ZWFtJTIwd29ya2luZyUyMHJvb2Z0b3B8ZW58MHx8fHwxNzg2MjEzNTQ0fDA&ixlib=rb-4.1.0&q=85",
  },
  utility: {
    eyebrow: "Utility Scale",
    title: "Metti a reddito un terreno o una superficie.",
    body: "Per proprietari di campi, terreni o grandi superfici che vogliono trasformare uno spazio inutilizzato in una nuova opportunità economica legata alla produzione di energia rinnovabile.",
    ctaLabel: "Configura il tuo impianto fotovoltaico",
    ctaHref: "https://configuratore.torri.solar",
    image: "https://images.unsplash.com/photo-1629726797843-618688139f5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxhZXJpYWwlMjB2aWV3JTIwbGFyZ2UlMjBzb2xhciUyMGZhcm0lMjBmaWVsZHxlbnwwfHx8fDE3ODYyMTM1NDR8MA&ixlib=rb-4.1.0&q=85",
  },
};

// ---------- Technology detail: PRISMA 4.0 ----------
export const prisma = {
  hero: { eyebrow: "Tecnologie", title: "PRISMA 4.0", claim: "Un modello costruttivo unico.", logo: "/tech/prisma-slide-1.webp" },
  intro: "Vetro con spessore maggiorato e pattern prismatico, copolimeri avanzati come il POE ad alta densità e una ricetta di laminazione unica: scelte industriali sviluppate per proteggere il circuito in silicio al proprio interno.",
  stats: [
    { big: "8 volte", label: "Più resistente alla grandine", note: "Grandine da 45mm a 110 km/h, nello stesso punto all'infinito." },
    { big: "3 volte", label: "Più robusta", note: "750 kg/m² di resistenza a carico neve, durabilità senza eguali." },
  ],
  features: [
    { k: "Vetro PRISMA 4mm", v: "La massima protezione del circuito in silicio grazie al vetro frontale più resistente del mercato." },
    { k: "Resistere, per sempre", v: "Polimero oltre 400 g/cm³ e laminazione oltre 18 minuti, quasi il doppio dello standard di mercato." },
  ],
  studies: [
    { k: "Studi indipendenti", v: "In collaborazione con l'Università di Brescia, su normative IEC e nuove normative dal mondo aeronautico e nautico.", image: "/tech/irs-study.jpeg" },
    { k: "Ricerche di mercato", v: "Studi Clean Energy Associates: la maggioranza dei pannelli in commercio è troppo fragile; il silicio è compromesso nel 76% dei casi già in installazione.", image: "/tech/hail-test.webp" },
    { k: "I risultati ottenuti", v: "−25% rischio incendi, −25% perdita di performance, +25% ROI nei 10 anni, in qualunque condizione.", image: "/tech/hail-test.webp" },
  ],
};

// ---------- Technology detail: X-CORE² ----------
export const xcore = {
  hero: { eyebrow: "Tecnologie", title: "X-CORE²", claim: "Progettato per l'endurance.", logo: "/tech/xcore-orig-1.jpeg" },
  intro: "La cornice, con domanda di brevetto depositata, calibra alluminio anodizzato e inserto polimerico generando un effetto lastra ogni volta che il pannello è sollecitato da fenomeni accidentali come grandine o calpestio.",
  patent: "Tecnologia protetta da domanda di brevetto per invenzione industriale n. 102025000024391, design e marchio tridimensionale.",
  highlights: [
    { k: "Effetto lastra", v: "Ogni carico accidentale impatta 5 volte meno sulla superficie di contatto.", image: "/products/half-cell-4-0.webp" },
    { k: "La riga colorata", v: "Inserto polimerico nel colore che preferisci: giallo autentico, rosso audace, nero elegante.", image: "/products/integra-total-black.webp" },
  ],
  warranty: [
    { y: "10 anni", t: "Danni da calpestio in installazione" },
    { y: "10 anni", t: "Danni causati da grandine" },
    { y: "10 anni", t: "Spese di sostituzione del prodotto reso" },
  ],
  research: [
    { k: "Ricerche di mercato", v: "Secondo la CEA, il 93% degli impianti ispezionati (oltre 800) presenta almeno un problema grave di sicurezza." },
    { k: "Elettroluminescenza", v: "Nel 100% dei moduli ispezionati dopo una grandinata: cricche gravi, in media 5 celle danneggiate, pur apparendo integri a occhio nudo." },
    { k: "I risultati ottenuti", v: "Il carico incidente si riduce di circa il 75%: il peso di una persona da 90 kg passa da 1,13 a 0,255 kg/cm²." },
  ],
};

// ---------- Progetti / Referenze ----------
export const projects = [
  { name: "Impianto industriale — Lombardia", type: "Industriale", power: "1,2 MWp", image: "https://images.unsplash.com/photo-1613665813446-82a78c468a1d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwc29sYXIlMjByb29mdG9wfGVufDB8fHx8MTc4NTIwNjE3N3ww&ixlib=rb-4.1.0&q=85" },
  { name: "Copertura agro-industriale — Emilia", type: "Agrisolare", power: "780 kWp", image: "https://images.pexels.com/photos/35454189/pexels-photo-35454189.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
  { name: "Tetto piano commerciale — Veneto", type: "Commerciale", power: "410 kWp", image: "https://images.unsplash.com/photo-1694327671725-e2a81cda3436?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxjb21tZXJjaWFsJTIwc29sYXIlMjByb29mdG9wfGVufDB8fHx8MTc4NTIwNjE3N3ww&ixlib=rb-4.1.0&q=85" },
  { name: "Campo Utility Scale — Piemonte", type: "Utility Scale", power: "3,4 MWp", image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&q=85&w=940" },
  { name: "Residenziale premium — Brescia", type: "Residenziale", power: "12 kWp", image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?crop=entropy&cs=srgb&fm=jpg&q=85&w=940" },
  { name: "Polo logistico — Toscana", type: "Industriale", power: "950 kWp", image: "https://images.pexels.com/photos/29407508/pexels-photo-29407508.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
];

// ---------- Installatori Partner ----------
export const installers = {
  intro: "I nostri Installatori Partner sono la garanzia di installazioni di precisione e di un servizio pre e post-vendita di eccellenza in tutta Italia. Entra nel mondo del fotovoltaico insieme a TORRI.",
  stats: [
    { v: "170+", l: "Installatori Partner" },
    { v: "20", l: "Regioni coperte" },
    { v: "2007", l: "Storicità industriale" },
    { v: "100%", l: "Prodotto Made in Italy" },
  ],
  benefits: [
    { k: "Formazione tecnica", v: "Percorsi nel Polo Tecnologico su prodotto, sicurezza e installazione.", img: "/formazione-tecnica.webp" },
    { k: "Supporto commerciale", v: "Configuratore, preventivazione e strumenti di vendita dedicati.", img: "/img/ext/rvvwwptl_IMG_5984-54e931.webp" },
    { k: "Marketing & lead", v: "Visibilità sul territorio e generazione di contatti qualificati.", img: "/img/ext/54odjs7b_IMG_5981-438e69.webp" },
    { k: "Assistenza integrata", v: "Un unico interlocutore industriale, dalla fornitura al post-vendita.", img: "https://images.unsplash.com/photo-1626863905121-3b0c0ed7b94c?crop=entropy&cs=srgb&fm=jpg&q=85&w=600" },
  ],
  regions: ["Piemonte", "Lombardia", "Veneto", "Emilia-Romagna", "Toscana", "Lazio", "Campania", "Puglia", "Sicilia", "Sardegna"],
};

// ---------- Technology detail: ECO-RED & AURA (generic template) ----------
export const techDetails = {
  "eco-red": {
    eyebrow: "Tecnologie",
    title: "ECO-RED",
    claim: "Colore senza pigmenti.",
    intro: "La colorazione nasce da un processo ottico, non da pigmenti: sfondo trasparente per la massima dissipazione termica e un'estetica architettonica unica.",
    image: "/tech/ecored-1.webp",
    hero: "/tech/ecored-1.webp",
    points: [
      { k: "Senza pigmenti", v: "Il colore è ottenuto otticamente: nessuna perdita di efficienza da coloranti." },
      { k: "Massima dissipazione", v: "Sfondo trasparente per gestire meglio il calore e la longevità del modulo." },
      { k: "Estetica architettonica", v: "Integrazione elegante su facciate e coperture di pregio." },
    ],
  },
  "aura": {
    eyebrow: "Tecnologie",
    title: "AURA",
    claim: "Equilibrio e costanza nell'energia.",
    intro: "L'elettronica di sistema TORRI: inverter, accumulo e ricarica progettati per lavorare come un unico ecosistema, con un solo interlocutore e un'assistenza integrata.",
    image: "",
    hero: "/tech/aura-inverter.jpeg",
    points: [
      { k: "Inverter", v: "Monofase e trifase, ibridi, commerciali e industriali." },
      { k: "Accumulo", v: "Sistemi HV e LV scalabili per residenziale e business." },
      { k: "Ricarica", v: "Stazione EV Charge integrata nel sistema energetico." },
    ],
  },
};

// ---------- Technology detail modal (popup) ----------
export const techModal = {
  "PRISMA 4.0": {
    code: "PRISMA 4.0",
    caption: "Massima robustezza",
    intro: "Vetro con spessore maggiorato e pattern prismatico, copolimeri avanzati come il POE ad alta densità e una ricetta di laminazione unica: scelte industriali sviluppate per proteggere il circuito in silicio al proprio interno.",
    mediaVideo: "/tech/prisma-c.mp4",
    media: "/img/ext/xdi32q7w_IMG_8514-0a8fb2.webp",
    mediaFit: "contain",
    document: {
      url: "/media/Relazione_PRISMA_4.0_Torri_Solare_IT.pdf",
      name: "Relazione tecnica PRISMA 4.0",
      meta: "PDF · Università degli Studi di Brescia",
      download: "Scarica",
      locked: "Accedi per scaricare",
    },
    points: [
      { k: "8 volte", l: "Più resistente alla grandine", v: "Grandine da 45 mm a 110 km/h, nello stesso punto all'infinito." },
      { k: "3 volte", l: "Più robusta a carico neve", v: "750 kg/m² di resistenza, durabilità senza eguali." },
    ],
    slidesFit: "contain",
    slides: [
      { image: "/tech/prisma-slide-1.webp?v=2" },
      { image: "/tech/prisma-slide-2.webp?v=2" },
    ],
    research: {
      title: "La ricerca sulla resistenza strutturale",
      intro: [
        "TORRI ha avviato un programma di ricerca e sperimentazione dedicato alla resistenza strutturale dei moduli fotovoltaici, con particolare attenzione a due delle sollecitazioni più importanti durante la vita dell'impianto: carichi meccanici estremi e grandine.",
        "L'attività è stata sviluppata con il supporto scientifico del Dipartimento di Ingegneria Meccanica e Industriale dell'Università degli Studi di Brescia, prendendo come riferimento le procedure previste dalla CEI EN IEC 61215:2021.",
        "L'obiettivo non era ottenere una nuova certificazione, ma andare oltre: comprendere i limiti del prodotto, confrontare differenti soluzioni costruttive e utilizzare i risultati per sviluppare moduli sempre più robusti e longevi. È infatti la relazione stessa a precisare che le prove sono state realizzate per sviluppare i prodotti e garantirne elevati standard qualitativi, non per il rilascio di una certificazione.",
      ],
      stats: [
        {
          k: "3 volte",
          l: "la soglia minima di riferimento nei test di carico statico",
          v: [
            "I moduli SILVERED 4.0 sono stati sottoposti a prove di carico distribuito fino ad almeno 700–750 kg/m², contro un livello minimo di prova previsto dalla normativa di circa 240 kg/m².",
            "Le prove sono state accompagnate da verifiche visive, isolamento, flash test ed elettroluminescenza. La relazione conclude che i moduli testati hanno sostenuto carichi pari ad almeno il 290% del minimo previsto dalla normativa.",
            "Più resistenza strutturale significa progettare pensando non soltanto all'installazione di oggi, ma agli anni che il modulo dovrà trascorrere sul tetto.",
          ],
        },
        {
          k: "Oltre 8×",
          l: "l'energia cinetica del test grandine minimo previsto dalla normativa",
          v: [
            "La normativa IEC prende come requisito minimo una sfera di ghiaccio da 25 mm, con energia cinetica di circa 2 J. Il programma sperimentale TORRI si è concentrato invece su sfere da 45 mm, rappresentative di impatti con energia circa 10 volte superiore al minimo normativo.",
            "Sono state testate almeno 200 sfere di ghiaccio e circa 20–25 moduli fotovoltaici, con differenti velocità, posizioni di impatto e configurazioni.",
          ],
        },
        {
          k: "4 mm",
          l: "Una scelta che abbiamo voluto misurare.",
          v: [
            "Uno degli obiettivi della ricerca era confrontare direttamente moduli con vetro frontale da 3,2 mm e 4,0 mm.",
            "Il risultato sperimentale è netto: i moduli con vetro da 4 mm hanno mostrato una resistenza all'impatto da grandine simulata notevolmente maggiore.",
            "Durante le campagne di prova, diversi pannelli da 3,2 mm si sono rotti al primo impatto o entro pochi colpi, mentre buona parte dei moduli da 4 mm ha resistito a sequenze di 10–15 impatti consecutivi.",
          ],
        },
      ],
      closing: [
        "La robustezza non è una dichiarazione. È un parametro che vogliamo conoscere.",
        "Per questo TORRI investe nella ricerca, nella costruzione di propri setup sperimentali e nell'analisi del comportamento reale dei materiali.",
        "La relazione conclusiva evidenzia prestazioni superiori ai valori minimi della IEC sia nei test statici sia negli impatti simulati di grandine; per questi ultimi riporta un superamento di oltre 8 volte dello standard minimo in termini di energia cinetica.",
      ],
      cta: "Accedi all'Area Clienti per consultare la relazione tecnica completa",
      disclaimer: "La relazione integrale contiene metodologia, riferimenti normativi, ricerca bibliografica, setup sperimentale, risultati delle singole prove e indicazioni per gli sviluppi futuri. Le attività descritte sono prove sperimentali di ricerca e sviluppo e non costituiscono una certificazione di prodotto.",
    },
  },
  "X-CORE²": {
    code: "X-CORE²",
    caption: "Ridistribuisce il carico",
    patent: { number: "102025000024391", date: "22/09/2025", image: "/tech/xcore-brevetto.webp" },
    intro: "La cornice, con domanda di brevetto depositata, calibra alluminio anodizzato e inserto polimerico generando un effetto lastra ogni volta che il pannello è sollecitato da fenomeni accidentali come grandine o calpestio.",
    media: "/img/ext/gu9a7hcb_IMG_5875-4a02d2.webp",
    slidesFit: "contain",
    points: [
      { k: "5×", l: "Effetto lastra", v: "Ogni carico accidentale impatta 5 volte meno sulla superficie di contatto." },
      { k: "−75%", l: "Carico incidente", v: "Il peso di una persona da 90 kg passa da 1,13 a 0,255 kg/cm²." },
      { k: "UNICA", l: "Garanzia", v: "La prima garanzia che copre l'integrità del circuito in silicio e le spese di sostituzione." },
    ],
    slides: [
      { image: "/tech/xcore-render.webp", caption: "Innovazione tangibile: profilo speciale con inserto polimerico." },
      { image: "/tech/xcore-orig-2.jpeg", caption: "−75% carico concentrato, 5× ridistribuzione del carico." },
      { image: "/tech/xcore-sezione.webp", caption: "Sezione in azione: controllo della freccia sotto carico." },
    ],
  },
  "ECO-RED": {
    code: "ECO-RED",
    caption: "Massima dissipazione del calore",
    intro: "La colorazione nasce da un processo ottico, non da pigmenti: sfondo trasparente per la massima dissipazione termica e un'estetica architettonica unica.",
    media: "/img/ext/09p6bo86_IMG_4901-114980.webp",
    points: [
      { k: "Zero", l: "Pigmenti", v: "Il colore è ottenuto otticamente: nessuna perdita di efficienza da coloranti." },
      { k: "Massima", l: "Dissipazione termica", v: "Sfondo trasparente per gestire meglio il calore e la longevità del modulo." },
      { k: "Architettura", l: "Estetica architettonica", v: "Integrazione elegante su facciate e coperture di pregio." },
    ],
    slides: [
      { image: "/tech/ecored-3.webp", caption: "Colore rosso ottenuto per via ottica, senza pigmenti: cornice e vetro dedicati." },
      { image: "/tech/ecored-2b.webp", caption: "Superficie continua e profonda: estetica architettonica unica." },
      { image: "/tech/ecored-1.webp", caption: "Installazione reale su copertura: integrazione architettonica di pregio." },
    ],
  },
  "AURA": {
    code: "AURA",
    caption: "Energia in equilibrio",
    intro: "L'elettronica di sistema TORRI: inverter, accumulo e ricarica progettati per lavorare come un unico ecosistema, con un solo interlocutore e un'assistenza integrata.",
    media: "/media/IMG_5876.jpeg",
    points: [
      { k: "Inverter", l: "Monofase e trifase", v: "Ibridi, commerciali e industriali per ogni taglia d'impianto." },
      { k: "Accumulo", l: "HV e LV scalabili", v: "Sistemi modulari per residenziale e business." },
      { k: "Ricarica", l: "EV Charge integrata", v: "Stazione di ricarica nel sistema energetico." },
    ],
    slides: [
      { image: "/tech/aura-accumulo.jpeg", caption: "Accumulo scalabile: sistemi modulari HV e LV." },
      { image: "/tech/aura-ricarica.jpeg", caption: "Ricarica EV integrata nel sistema energetico." },
      { image: "/tech/aura-inverter.jpeg", caption: "Inverter monofase e trifase: ibridi, commerciali e industriali." },
    ],
  },
};

// ---------- Product catalog (single product pages) ----------
// NOTE: specifiche rappresentative/MOCK a fini di anteprima.
export const productCatalog = [
  { slug: "half-cell-4-0", name: "Half Cell 4.0", cat: "Moduli Fotovoltaici", tag: "Massima sicurezza", image: "/products/half-cell-4-0.webp", desc: "Modulo half-cell ad alta efficienza. Tecnologie proprietarie per conferire la massima longevità e sicurezza.", specs: [["Tecnologia", "PRISMA 4.0"], ["Celle", "Half-cell monocristalline"], ["Potenza", "fino a 460 Wp"], ["Garanzia prodotto", "fino a 30 anni"]] },
  { slug: "silvered-4-0", name: "Silvered 4.0", cat: "Moduli Fotovoltaici", tag: "Revamping", image: "/products/silvered-4-0.webp", images: [{ src: "/products/silvered-4-0.webp", caption: "Silvered · Monocristallino PERC" }, { src: "/media/IMG_6237.jpeg", caption: "Silvered · Policristallino (Revamping)" }], desc: "Modulo silver ad elevata robustezza per impianti industriali e commerciali in Revamping.", specs: [["Tecnologia", "PRISMA 4.0"], ["Cornice", "Argento anodizzato"], ["Carico neve", "fino a 750 kg/m²"], ["Garanzia", "fino a 30 anni"]] },
  { slug: "integra-ecored", name: "Integra Eco-Red", cat: "Moduli Fotovoltaici", tag: "Estetica architettonica", image: "/products/integra-ecored.webp", desc: "Modulo con tecnologia ECO-RED: colore senza pigmenti e massima integrazione architettonica.", specs: [["Tecnologia", "ECO-RED"], ["Colore", "Senza pigmenti"], ["Applicazione", "Facciate e coperture di pregio"], ["Garanzia", "fino a 30 anni"]] },
  { slug: "integra-total-black", name: "Integra Total Black", cat: "Moduli Fotovoltaici", tag: "Design elegante", image: "/products/integra-total-black.webp", desc: "Modulo total black dall'estetica elegante, perfetto per industriale e residenziale premium.", specs: [["Tecnologia", "PRISMA 4.0"], ["Finitura", "Total Black"], ["Applicazione", "Residenziale premium"], ["Garanzia", "fino a 30 anni"]] },
  { slug: "innova", name: "Innova", cat: "Moduli Fotovoltaici", tag: "BIPV", image: "/products/innova.webp", desc: "Modulo integrato innovativo, per impianti residenziali e commerciali di prestigio.", specs: [["Tecnologia", "PRISMA 4.0"], ["Celle", "Monocristalline"], ["Applicazione", "Residenziale / Commerciale"], ["Garanzia", "fino a 30 anni"]] },
  { slug: "inverter-monofase-ibrido-high-voltage", name: "Inverter Monofase Ibrido HV", cat: "Inverter", tag: "AURA", image: "/products/inverter-monofase-ibrido-hv.webp", desc: "Inverter monofase ibrido ad alta tensione per accumulo efficiente in ambito residenziale.", specs: [["Tipo", "Ibrido monofase HV"], ["Batteria", "Alta tensione"], ["Uso", "Residenziale"], ["Ecosistema", "AURA"]] },
  { slug: "inverter-monofase-ibrido", name: "Inverter Monofase Ibrido", cat: "Inverter", tag: "AURA", image: "/products/inverter-monofase-ibrido.png", desc: "Inverter monofase ibrido per abitazioni con accumulo.", specs: [["Tipo", "Ibrido monofase"], ["Uso", "Residenziale"], ["Monitoraggio", "App dedicata"], ["Ecosistema", "AURA"]] },
  { slug: "inverter-trifase-ibrido", name: "Inverter Trifase Ibrido", cat: "Inverter", tag: "AURA", image: "/products/inverter-trifase-ibrido.png", desc: "Inverter trifase ibrido per impianti residenziali e small business.", specs: [["Tipo", "Ibrido trifase"], ["Uso", "Residenziale / Business"], ["Accumulo", "Integrabile"], ["Ecosistema", "AURA"]] },
  { slug: "inverter-trifase-commerciale", name: "Inverter Trifase Commerciale", cat: "Inverter", tag: "AURA", image: "/products/inverter-trifase-commerciale.png", desc: "Inverter trifase per impianti commerciali di media taglia.", specs: [["Tipo", "Trifase commerciale"], ["Uso", "Commerciale"], ["Potenza", "media taglia"], ["Ecosistema", "AURA"]] },
  { slug: "inverter-trifase-industriale", name: "Inverter Trifase Industriale", cat: "Inverter", tag: "AURA", image: "/products/inverter-trifase-industriale.png", desc: "Inverter trifase industriale 60–100 kW per grandi impianti.", specs: [["Tipo", "Trifase industriale"], ["Potenza", "60–100 kW"], ["Uso", "Industriale / Utility"], ["Ecosistema", "AURA"]] },
  { slug: "aura-accu-hv-5-5", name: "Aura ACCU-HV-5.5", cat: "Sistemi di Accumulo", tag: "AURA", image: "/products/accu-hv-5-5.png", desc: "Batteria ad alta tensione modulare da 5.5 kWh, scalabile.", specs: [["Tipo", "HV modulare"], ["Capacità", "5.5 kWh per modulo"], ["Scalabile", "Sì"], ["Ecosistema", "AURA"]] },
  { slug: "aura-accu5k-lv", name: "Aura ACCU5K-LV", cat: "Sistemi di Accumulo", tag: "AURA", image: "/products/accu5k-lv.png", desc: "Batteria a bassa tensione per accumulo residenziale.", specs: [["Tipo", "LV"], ["Capacità", "5 kWh"], ["Uso", "Residenziale"], ["Ecosistema", "AURA"]] },
  { slug: "aura-accu-hv", name: "Aura ACCU-HV", cat: "Sistemi di Accumulo", tag: "AURA", image: "/products/accu-hv.png", desc: "Sistema di accumulo ad alta tensione per prestazioni superiori.", specs: [["Tipo", "HV"], ["Capacità", "modulare"], ["Uso", "Residenziale / Business"], ["Ecosistema", "AURA"]] },
  { slug: "aura-ev-stazione-di-ricarica-ac", name: "Aura EV Charge", cat: "Stazione di Ricarica", tag: "AURA", image: "/products/aura-ev-charge.webp?v=2", desc: "Stazione di ricarica AC integrata nell'ecosistema energetico TORRI.", specs: [["Tipo", "Wallbox AC"], ["Integrazione", "Ecosistema AURA"], ["Uso", "Residenziale / Business"], ["Connettività", "Smart"]] },
  { slug: "staffa-prsg", name: "Staffa presagomata PRSG", cat: "Sistemi di Fissaggio", tag: "Tetto Piano", image: "/products/prsg.png", desc: "Staffa presagomata in acciaio con trattamento Magnelis, ideale per installare i pannelli su tetti piani o superfici piane. Disponibile con inclinazioni da 10° a 25°.", specs: [["Materiale", "Acciaio Magnelis (zincatura a caldo)"], ["Inclinazione", "10° / 25°"], ["Orientamento", "Orizzontale"], ["Peso", "7 - 8 Kg"], ["Larghezza modulo", "1048 / 1134 mm"], ["Distanza tra pannelli", "600 - 1200 mm"], ["Modelli", "TRS-PRSG 1048 / 1134"]] },
  { slug: "zavorra", name: "Zavorra", cat: "Sistemi di Fissaggio", tag: "Tetto Piano", image: "/products/zavorra.jpeg", desc: "Massello in calcestruzzo per installare i pannelli in modo sicuro su superfici o tetti piani senza forare. Si completa con staffe a L in alluminio e vite M10x250mm.", specs: [["Materiale", "Calcestruzzo"], ["Modelli", "L 1000 / L 1200"], ["Peso", "29,3 - 34,8 Kg"], ["Altezza", "100 mm"], ["Larghezza", "120 mm"], ["Lunghezza", "1000 / 1200 mm"]] },
  { slug: "morsetto-centrale-mc", name: "Morsetto Centrale MC", cat: "Sistemi di Fissaggio", tag: "Morsetti", image: "/products/mc35.jpeg", images: [{ src: "/products/mc35.jpeg", caption: "MC35 · Argento" }, { src: "/products/mcb35.jpeg", caption: "MCB35 · Nero" }], desc: "Morsetto centrale preassemblato per moduli fotovoltaici con cornice in alluminio.", specs: [["Materiale", "AL60 X63-T5 / SS304 anodizzato"], ["Anodizzazione", "≥ 10 µm"], ["Viteria", "M8x55 inox 304"], ["Spessore modulo", "35 mm"], ["Colore", "Argento / Nero"], ["Coppia di serraggio", "10 Nm"], ["Peso", "0,07 Kg"], ["Garanzia", "10 anni"]] },
  { slug: "morsetto-centrale-mcx", name: "Morsetto Centrale MCX", cat: "Sistemi di Fissaggio", tag: "Morsetti", image: "/products/mcx-1.jpeg", images: [{ src: "/products/mcx-1.jpeg", caption: "MCX · Argento" }, { src: "/products/mcx-2.jpeg", caption: "MCX · Nero" }], desc: "Morsetto centrale preassemblato regolabile per moduli fotovoltaici con cornice in alluminio.", specs: [["Materiale", "AL60 X63-T5 / SS304 anodizzato"], ["Anodizzazione", "≥ 10 µm"], ["Viteria", "M8x55 inox 304"], ["Spessore modulo", "30-40 mm"], ["Colore", "Argento / Nero / Rosso"], ["Coppia di serraggio", "10 Nm"], ["Peso", "0,07 Kg"], ["Garanzia", "10 anni"]] },
  { slug: "morsetto-finale-ec", name: "Morsetto Finale EC", cat: "Sistemi di Fissaggio", tag: "Morsetti", image: "/products/ec-1.jpeg", images: [{ src: "/products/ec-1.jpeg", caption: "EC · Argento" }, { src: "/products/ec-2.jpeg", caption: "EC · Nero" }], desc: "Morsetto finale preassemblato per moduli fotovoltaici con cornice in alluminio.", specs: [["Materiale", "AL60 X63-T5 / SS304 anodizzato"], ["Anodizzazione", "≥ 10 µm"], ["Viteria", "M8x40 inox 304"], ["Spessore modulo", "35 mm"], ["Colore", "Argento / Nero"], ["Coppia di serraggio", "10 Nm"], ["Peso", "0,07 Kg"], ["Garanzia", "10 anni"]] },
  { slug: "morsetto-finale-ecx", name: "Morsetto Finale ECX", cat: "Sistemi di Fissaggio", tag: "Morsetti", image: "/products/ecx-1.jpeg", images: [{ src: "/products/ecx-1.jpeg", caption: "ECX · Argento" }, { src: "/products/ecx-2.jpeg", caption: "ECX · Nero" }], desc: "Morsetto finale preassemblato regolabile per moduli fotovoltaici con cornice in alluminio.", specs: [["Materiale", "AL60 X63-T5 / SS304 anodizzato"], ["Anodizzazione", "≥ 10 µm"], ["Viteria", "M8x40 inox 304"], ["Spessore modulo", "30-40 mm"], ["Colore", "Argento / Nero / Rosso"], ["Coppia di serraggio", "10 Nm"], ["Peso", "0,07 Kg"], ["Garanzia", "10 anni"]] },
  { slug: "giunzione-r2con", name: "Giunzione per Profilato R2CON", cat: "Sistemi di Fissaggio", tag: "Profilati", image: "/products/rcon-1.jpeg", images: [{ src: "/products/rcon-1.jpeg", caption: "R2CON · Vista 1" }, { src: "/products/rcon-2.jpeg", caption: "R2CON · Vista 2" }], desc: "Connettore in acciaio con trattamento Magnelis per collegare due barre di profilato R2-3000 su tetto in coppi e tegole.", specs: [["Materiale", "Acciaio Magnelis"], ["Dimensioni", "35 x 200 mm"], ["Peso", "0,12 Kg"], ["Compatibilità", "Profilo R2-3000"], ["Garanzia", "10 anni"]] },
  { slug: "tappo-tpr2-b", name: "Tappo Rail R2 – TPR2-B", cat: "Sistemi di Fissaggio", tag: "Accessori", image: "/products/tpr2b.jpeg", desc: "Tappo di chiusura per profilato Rail R2, colorazione nera. Rifinisce e protegge le estremità del profilo.", specs: [["Compatibilità", "Profilo R2-3000"], ["Colore", "Nero"], ["Tipo", "Tappo di estremità"]] },
  { slug: "profilato-serie-r2", name: "Profilato Serie-R2", cat: "Sistemi di Fissaggio", tag: "Profilati", image: "/products/r2-1.jpeg", images: [{ src: "/products/r2-1.jpeg", caption: "Serie-R2 · Vista 1" }, { src: "/products/r2-2.jpeg", caption: "Serie-R2 · Vista 2" }], desc: "Profilo in alluminio per il fissaggio di pannelli con orientamento orizzontale su tetti in coppi e tegole. Anti-infiltrazione, con servizio di taglio su misura.", specs: [["Materiale", "AL60 X63-T5 / SS304 anodizzato"], ["Anodizzazione", "≥ 10 µm"], ["Lunghezza", "3000 mm"], ["Colore", "Argento"], ["Accessori", "Tappo TPR2-B"]] },
  { slug: "staffa-h101-sth1-1", name: "Staffa H101 – STH1-1", cat: "Sistemi di Fissaggio", tag: "Tetto a Falda", image: "/products/sth1-1-1.jpeg", images: [{ src: "/products/sth1-1-1.jpeg", caption: "STH1-1 · Vista 1" }, { src: "/products/sth1-1-2.jpeg", caption: "STH1-1 · Vista 2" }], desc: "Staffa in acciaio per l'installazione di pannelli su manti di copertura in tegole e listelli di altezza variabile.", specs: [["Materiale", "SS304 anodizzato"], ["Viteria", "N°1 M8x25 inox 304"], ["H fissaggio", "113-189 mm"], ["Coppia di serraggio", "10 Nm"], ["Garanzia", "10 anni"]] },
  { slug: "staffa-sth1-5", name: "Staffa STH1-5-AR / STH1-5", cat: "Sistemi di Fissaggio", tag: "Tetto a Falda", image: "/products/sth1-5-1.jpeg", images: [{ src: "/products/sth1-5-1.jpeg", caption: "STH1-5-AR · Vista 1" }, { src: "/products/sth1-5-2.png", caption: "STH1-5-AR · Vista 2" }], desc: "Staffa in acciaio con 2 variabili di regolazione per l'installazione di pannelli su manti di copertura in tegole e listelli.", specs: [["Materiale", "SS304 inox"], ["Viteria", "N°1 M10x30 inox 304"], ["H fissaggio", "150-189 mm"], ["Coppia di serraggio", "10 Nm"], ["Garanzia", "10 anni"]] },
  { slug: "staffa-sth1-7", name: "Staffa STH1-7-AR / STH1-7", cat: "Sistemi di Fissaggio", tag: "Tetto a Falda", image: "/products/sth1-7-1.jpeg", images: [{ src: "/products/sth1-7-1.jpeg", caption: "STH1-7-AR · Vista 1" }, { src: "/products/sth1-7-2.jpeg", caption: "STH1-7-AR · Vista 2" }], desc: "Staffa in alluminio anodizzato con 2 variabili di regolazione (1 verticale e 1 orizzontale) per l'installazione su manti in tegole e listelli.", specs: [["Materiale", "Alluminio anodizzato"], ["Viteria", "N°2 M8x35 inox 304"], ["H fissaggio", "149-184 mm"], ["Garanzia", "10 anni"]] },
  { slug: "mini-profilato-minir", name: "Mini Profilato Forato MINIR", cat: "Sistemi di Fissaggio", tag: "Tetto in Lamiera", image: "/products/minir-1.jpeg", images: [{ src: "/products/minir-1.jpeg", caption: "MINIR · Vista 1" }, { src: "/products/minir-2.jpeg", caption: "MINIR · Vista 2" }], desc: "Profilato con base forata (375 mm) adatto per coperture in lamiera, impermeabilizzato con gomma EPDM.", specs: [["Materiale", "AL60 X63-T5 / SS304 anodizzato"], ["Anodizzazione", "≥ 10 µm"], ["Viteria", "N°1 M8x35 + N°6 ST6.3x25 inox 304"], ["Dimensione", "30x77x375 mm"], ["Impermeabilizzazione", "Gomma EPDM"], ["Colore", "Argento"], ["Coppia di serraggio", "10 Nm"], ["Modelli", "MINIR+MC35 / MCB35, MINIR-EC35 / ECB35, MINIR-2000"], ["Garanzia", "10 anni"]] },
  { slug: "mini-profilato-minir2", name: "Mini Profilato Forato MINIR2", cat: "Sistemi di Fissaggio", tag: "Tetto in Lamiera", image: "/products/minir-1.jpeg", images: [{ src: "/products/minir-1.jpeg", caption: "MINIR2 · Vista 1" }, { src: "/products/minir-2.jpeg", caption: "MINIR2 · Vista 2" }], desc: "Profilato con base forata (375 mm) adatto per coperture in lamiera, impermeabilizzato con gomma EPDM.", specs: [["Materiale", "AL60 X63-T5 / SS304 anodizzato"], ["Anodizzazione", "≥ 10 µm"], ["Viteria", "N°1 M8x35 + N°6 ST6.3x25 inox 304"], ["Dimensione", "30x77x375 mm"], ["Impermeabilizzazione", "Gomma EPDM"], ["Colore", "Argento"], ["Coppia di serraggio", "10 Nm"], ["Modelli", "MINIR2+MCX, MINIR2+ECX"], ["Compatibile con", "Morsetti innovativi ECX e MCX"], ["Garanzia", "10 anni"]] },
  { slug: "vite-tirafondo-m10x250", name: "Vite Tirafondo M10x250-AR", cat: "Sistemi di Fissaggio", tag: "Aggancio Rapido", image: "/products/vite-tirafondo-1.jpeg", images: [{ src: "/products/vite-tirafondo-1.jpeg", caption: "M10x250-AR · Assemblata" }, { src: "/products/vite-tirafondo-2.jpeg", caption: "M10x250-AR · Vite" }], desc: "Aggancio rapido in alluminio con unica vite già assemblata e sistema a molla, per sistema ad aggancio rapido R2.", specs: [["Materiale", "AL60 X63-T5 / SS304 anodizzato"], ["Viteria", "M10x250 + M8x25 inox"], ["H filetto", "67 mm"], ["Colore", "Argento"], ["Coppia di serraggio", "10 Nm"], ["Sistema", "Aggancio rapido R2"], ["Garanzia", "10 anni"]] },
];

// ---------- Dettaglio tecnologia vetro ARC ----------
export const arcInfo = {
  title: "ARC — Anti-Reflective Coating",
  paragraphs: [
    "Il vetro frontale è trattato con un rivestimento antiriflesso ARC nanostrutturato, progettato per aumentare la trasmittanza della radiazione solare verso le celle.",
    "Il coating crea uno strato a indice di rifrazione intermedio tra aria e vetro, riducendo il salto di indice all'interfaccia e quindi le perdite ottiche dovute alla riflessione secondo le leggi di Fresnel.",
    "La struttura e lo spessore ottico del rivestimento sono inoltre progettati per generare interferenza distruttiva tra le componenti della luce riflessa, diminuendo ulteriormente la riflettanza nelle lunghezze d'onda di interesse per la conversione fotovoltaica.",
    "Il risultato è una maggiore trasmittanza solare del vetro e un incremento del photon flux incidente sulle celle, con una riduzione delle perdite ottiche del modulo.",
  ],
};

// ---------- Dettaglio tecnologia cella TOPCon ----------
export const topconInfo = {
  title: "Celle TOPCon ad alta efficienza",
  paragraphs: [
    "I moduli TORRI utilizzano celle N-Type TOPCon (Tunnel Oxide Passivated Contact) di ultima generazione.",
    "La tecnologia TOPCon introduce sul retro della cella un sottilissimo strato di ossido di silicio e un contatto passivato in silicio policristallino, riducendo la ricombinazione dei portatori di carica e quindi le perdite elettriche interne.",
    "Rispetto alle precedenti tecnologie PERC, consente maggiore efficienza di conversione, migliore comportamento alle alte temperature, maggiore risposta in condizioni di bassa irradiazione e minore degradazione nel tempo.",
  ],
};

// ---------- Dettaglio tecnologia cella PERC / Revamping (Silvered) ----------
export const percInfo = {
  title: "Celle PERC e policristalline per Revamping",
  paragraphs: [
    "I moduli TORRI per revamping fotovoltaico possono essere realizzati con celle PERC monocristalline o policristalline, permettendo di intervenire anche su impianti di precedente generazione con configurazioni oggi difficilmente reperibili sul mercato.",
    "La tecnologia della cella viene selezionata in funzione delle caratteristiche del modulo da sostituire. L'obiettivo non è semplicemente aumentare la potenza nominale, ma ottenere il corretto matching elettrico con l'impianto esistente.",
    "Per ogni configurazione vengono analizzati Voc, Vmp, Isc, Imp, curva I-V, coefficienti di temperatura, numero e disposizione delle celle, verificandone la compatibilità con tensione di stringa, finestra MPPT e limiti operativi dell'inverter.",
    "L'utilizzo di celle policristalline permette inoltre di sviluppare soluzioni dedicate alla sostituzione di moduli di generazioni precedenti, ricercando caratteristiche elettriche e dimensionali coerenti con quelle originarie.",
    "Anche la costruzione meccanica può essere configurata considerando dimensioni del modulo, disposizione delle celle, posizione della junction box, cablaggi e sistema di fissaggio.",
    "In questo modo il nuovo modulo viene progettato per integrarsi nell'architettura elettrica e meccanica esistente, riducendo mismatch e modifiche all'impianto e consentendo interventi di revamping anche su configurazioni non più disponibili nella produzione fotovoltaica standard.",
  ],
};

// ---------- Tecnologia Solrif® — Fotovoltaico integrato nella copertura (BIPV) ----------
export const solrifInfo = {
  title: "Tecnologia Solrif® — Fotovoltaico integrato nella copertura",
  image: "/tech/solrif-manual.webp",
  manual: "/media/Quick-Manual-Solrif.pdf",
  paragraphs: [
    "Solrif® è il sistema brevettato di integrazione fotovoltaica sviluppato da Ernst Schweizer AG per trasformare il modulo fotovoltaico in un vero elemento funzionale della copertura.",
    "Lo speciale profilo perimetrale Solrif® consente ai moduli di essere installati direttamente sulla struttura del tetto con una posa modulare sovrapposta, analoga al principio delle tegole. Il campo fotovoltaico sostituisce quindi la copertura tradizionale, integrando in un unico sistema produzione di energia, protezione dagli agenti atmosferici e continuità architettonica.",
    "Il sistema prevede una posa flottante dei moduli su listellatura: gli elementi non vengono rigidamente serrati al telaio, ma posati e assicurati mediante specifici elementi di fissaggio. La configurazione dei punti di ancoraggio viene determinata in funzione dei carichi di vento e neve previsti dal progetto. La struttura sottostante mantiene inoltre una camera di ventilazione e uno strato secondario di tenuta e drenaggio.",
    "La geometria modulare permette di realizzare integrazioni complete o parziali della copertura, gestendo colmi, gronde, bordi, cambi di pendenza, finestre da tetto, camini e altri elementi architettonici mediante componenti specifici. I singoli moduli rimangono inoltre rimovibili e sostituibili anche successivamente all'installazione.",
    "La particolare configurazione del profilo lascia libero il bordo inferiore del vetro, favorendo il deflusso dell'acqua, l'autopulizia e lo scivolamento della neve. I profili sono realizzati in alluminio e gli elementi di fissaggio in acciaio inox.",
    "Il risultato è un sistema BIPV nel quale modulo fotovoltaico e copertura diventano un unico elemento costruttivo.",
  ],
};

// ---------- Descrizioni specifiche per modulo (override datasheet condiviso) ----------
export const moduleDescriptions = {
  "integra-ecored":
    "Modulo fotovoltaico in silicio monocristallino TOPCon: 390Watt, 108 celle. Tecnologia PRISMA 4.0: vetro 4mm prismatico interno, polimero POE frontale con densità 430g/m³, backsheet trasparente, cornici di colore rosso. Dimensioni 1722x1134x35mm, peso 24kg, resistenza carico statico 750Kg/m2, resistenza grandine 45mm a 110Km/h. Garanzia 30 anni sui difetti di fabbrica e 30 anni sulla performance lineare. Classe 1 di reazione fuoco, certificato classe E, Broof (t2).",
  "integra-total-black":
    "Modulo fotovoltaico in silicio monocristallino TOPCon. Tecnologia PRISMA 4.0: vetro 4mm prismatico interno, polimero POE frontale con densità 430g/m², backsheet nero, cornici di colore nero. Resistenza carico statico 750Kg/m², resistenza grandine 45mm a 110Km/h. Garanzia 30 anni sui difetti di fabbrica e 30 anni sulla performance lineare. Classe 1 di reazione fuoco, certificato classe E, Broof (t2).",
  "silvered-4-0":
    "Modulo fotovoltaico in silicio monocristallino PERC: 330/335Watt, 60 celle. Tecnologia PRISMA 4.0: vetro 4mm prismatico interno, polimero POE frontale con densità 430g/m³, backsheet trasparente, cornici di colore silver. Dimensioni 1665x1002x35mm, peso 21kg, resistenza carico statico 750Kg/m2, resistenza grandine 45mm a 110Km/h. Garanzia 30 anni sui difetti di fabbrica e 30 anni sulla performance lineare. Classe 1 di reazione fuoco.",
};

// ---------- Datasheet completo pannelli fotovoltaici ----------
export const panelDatasheet = {
  description:
    "Modulo fotovoltaico in silicio monocristallino TOPCon > 25%. Tecnologia PRISMA 4.0: vetro 4 mm prismatico interno, polimero POE frontale con densità 430g/m², backsheet bianco, cornici di colore silver. Resistenza carico statico 750Kg/m², resistenza grandine 45mm a 110Km/h. Garanzia 30 anni sui difetti di fabbrica e 30 anni sulla performance lineare. Classe 1 di reazione fuoco, certificato classe E, Broof (t2).",
  design: [
    ["Configurazione", "Vetro - Polimero"],
    ["Colorazione", "Cornice silver / Sfondo bianco"],
    ["Tecnologie celle", "TOPCon"],
    ["Numero celle", "108 celle (450W) / 120 celle (495W)"],
    ["Rapporto di layout", "0,230 kWp/m²"],
    ["Numero di fili conduttori", "16 Bus Bar"],
    ["Dimensioni", "1134 x 1722 mm (450W) / 1134 x 1909 mm (495W)"],
    ["Spessore cornice", "35 mm"],
    ["Peso", "24 Kg (450W) / 29 Kg (495W)"],
    ["Lunghezza cavi", "1.200mm"],
    ["Resistenza carico neve", "750 Kg/m²"],
    ["Resistenza alla grandine", "HW5 (Ø45mm, 110Km/h)"],
  ],
  glass: [
    ["Spessore vetro", "4,0 mm"],
    ["Composizione vetro", "temprato a basso contenuto di ferro"],
    ["Tipologia vetro", "prismatico interno"],
    ["Trattamento nanotecnologico", "ARC (Anti-reflecting-coating)"],
    ["Trasmittanza solare", "≥ 93,8 %"],
  ],
  encapsulant: [
    ["Composizione polimero", "POE (Poliossietilene)"],
    ["Densità polimero", "430 gr/m²"],
  ],
  electrical: {
    cols: ["Pmpp (Wp)", "Vmpp (V)", "Impp (A)", "Voc (V)", "Isc (A)", "Eff. prod. (%)", "Eff. circuito (%)"],
    rows: [
      { model: "TRS 450-54M-H8N", values: ["450 Wp", "32,50 V", "13,85 A", "39,16 V", "14,49 A", "23,0 %", "25,1 %"] },
      { model: "TRS 495-60M-H8N", values: ["495 Wp", "36,08 V", "13,72 A", "43,39 V", "14,49 A", "22,9 %", "25,1 %"] },
    ],
  },
  temperature: {
    cols: ["Coefficiente Pmpp", "Coefficiente Voc", "Coefficiente Isc", "NOCT"],
    rows: [
      { model: "TRS 450-54M-H8N", values: ["-0,30 % / °C", "-0,25 V % / °C", "+0,046 % / °C", "45°C ± 2°C"] },
      { model: "TRS 495-60M-H8N", values: ["-0,30 % / °C", "-0,25 V % / °C", "+0,046 % / °C", "45°C ± 2°C"] },
    ],
  },
  productCerts: [
    ["IEC 61215 - 2:2017 (ed.II)", "TÜV SÜD"],
    ["IEC 61730 - 2:2018 (ed.II)", "TÜV SÜD"],
    ["PID / Nebbia Salina / Ammonia", "TÜV SÜD"],
    [{ title: "Reazione al fuoco:", lines: ["Classe 1 (UNI 917A)", "Broof (t2) EN-13501-5:2016", "Classe E EN-13501-1:2018"] }, "Istituto Giordano"],
    ["Tecnologia PRISMA 4.0", "Università degli Studi di Brescia"],
  ],
  companyCerts: [
    ["ISO 9001:2015 Qualità", "KIWA"],
    ["ISO 14001:2015 Ambiente", "KIWA"],
    ["ISO 45001:2018 Sicurezza", "KIWA"],
    ["Factory Inspection Attestation Photovoltaic (PV) Panels", "KIWA"],
  ],
  warranties: [
    ["Difetti di fabbrica", "30 anni"],
    ["Performance lineare", "30 anni"],
    ["PPS", "Riservata agli installatori partner"],
  ],
  notes: [
    "*Definiamo tutti i nostri prodotti attraverso l'efficienza di circuito, un indice che abbiamo studiato per rapportare la massima efficienza di cella con la dimensione del pannello fotovoltaico per ottenere la migliore performance termica.",
    "**STC (standard test conditions) - 1000 Watt/m², AM 1.5, 25°C",
    "***PPS (Prodotto/Performance/Servizio) - Garanzia riservata ai partner che copre la manodopera necessaria per l'eventuale sostituzione di prodotti difettosi per i primi due anni.",
    "****La Factory Inspection non è disponibile per tutti i prodotti, chiedere all'ufficio commerciale prima dell'acquisto.",
    "Le specifiche tecniche sono soggette a continui aggiornamenti e possono variare in qualsiasi momento senza alcun preavviso. Verificare condizioni e validità delle garanzie direttamente con l'azienda al momento dell'acquisto.",
  ],
};

// Certificazioni prodotto Silvered: restano come prima (senza Broof/Classe E).
const silveredProductCerts = [
  ["IEC 61215 - 2:2017 (ed.II)", "TÜV SÜD"],
  ["IEC 61730 - 2:2018 (ed.II)", "TÜV SÜD"],
  ["PID / Nebbia Salina / Ammonia", "TÜV SÜD"],
  ["Reazione al fuoco: Classe 1 (UNI 917A)", "Istituto Giordano"],
  ["Tecnologia PRISMA 4.0", "Università degli Studi di Brescia"],
];

// ---------- Scheda tecnica dedicata Half Cell X-CORE² (solo download "Scheda tecnica in anteprima") ----------
export const xcoreHalfCellDatasheet = {
  ...panelDatasheet,
  xcore: true,
  image: "/img/ext/dhwq55k7_IMG_6531-8875f6.webp",
  polymerColors: [
    { label: "Nero", image: "/media/IMG_6317.webp" },
    { label: "Rosso", image: "/media/IMG_6314.webp" },
    { label: "Giallo", image: "/img/ext/oecjzogk_IMG_6512-b96d53.webp" },
  ],
  description:
    "Modulo fotovoltaico in silicio monocristallino TOPCon > 25%. Tecnologia PRISMA 4.0: vetro 4 mm prismatico interno, polimero POE frontale con densità 430g/m², backsheet bianco, cornici con Tecnologia X-CORE² di colore nero. Resistenza carico statico 750Kg/m², resistenza grandine 45mm a 110Km/h. Garanzia 30 anni sui difetti di fabbrica e 30 anni sulla performance lineare. Classe 1 di reazione fuoco, certificato classe E, Broof (t2).",
  design: panelDatasheet.design.map((r) => {
    if (r[0] === "Spessore cornice") return [r[0], "30 mm"];
    if (r[0] === "Colorazione") return [r[0], "Cornice nero anodizzato / Sfondo bianco"];
    return r;
  }),
  electrical: {
    cols: panelDatasheet.electrical.cols,
    rows: panelDatasheet.electrical.rows.map((r) => ({ ...r, model: `${r.model} X-CORE²` })),
  },
  temperature: {
    cols: panelDatasheet.temperature.cols,
    rows: panelDatasheet.temperature.rows.map((r) => ({ ...r, model: `${r.model} X-CORE²` })),
  },
};


// ---------- Datasheet dedicati per modulo (override completo del datasheet condiviso) ----------
export const moduleDatasheets = {
  "x-core-2": {
    ...xcoreHalfCellDatasheet,
    badge: "X-CORE²",
    showcaseTitle: "Tecnologia X-CORE²",
    image: "/products/x-core-2-cover.jpg",
    infoSlots: [
      { big: "5 volte", bigSize: 15, title: "Effetto lastra", desc: "Ogni carico accidentale impatta 5 volte meno sulla superficie di contatto." },
      { big: "−75%", bigSize: 17, title: "Riduzione d'impatto", desc: "Il peso di una persona da 90 kg passa da 1,13 a 0,255 kg/cm²." },
    ],
  },
  "half-cell-4-0": {
    ...panelDatasheet,
    frame: { grad: "linear-gradient(135deg,#f2f2f2 0%,#c4c4c4 45%,#9a9a9a 100%)", textColor: "#2b2b2b", label: "Tecnologia PRISMA 4.0" },
    infoSlots: [
      { big: "8 volte", title: "Più resistente alla grandine", desc: "Grandine da 45 mm a 110 km/h, nello stesso punto all'infinito." },
      { big: "3 volte", title: "Più robusta a carico neve", desc: "750 kg/m² di resistenza, durabilità senza eguali." },
    ],
  },

  "integra-ecored": {
    ...panelDatasheet,
    description: moduleDescriptions["integra-ecored"],
    frame: { grad: "linear-gradient(135deg,#f2f2f2 0%,#c4c4c4 45%,#9a9a9a 100%)", textColor: "#2b2b2b", label: "Tecnologia ECO-RED" },
    infoSlots: [
      { big: "ZERO", bigSize: 21, title: "pigmenti", desc: "Il colore è ottenuto otticamente: nessuna perdita di efficienza da coloranti." },
      { big: "MASSIMA", bigSize: 21, title: "dissipazione del calore", desc: "Grazie allo sfondo trasparente che aumenta la longevità del modulo." },
    ],
    design: [
      ["Configurazione", "Vetro - Polimero"],
      ["Colorazione", "Cornice red / Sfondo red"],
      ["Tecnologie celle", "TOPCon"],
      ["Numero celle", "108 celle"],
      ["Rapporto di layout", "0,199 kW/m²"],
      ["Numero di fili conduttori", "16 Bus Bar"],
      ["Dimensioni", "1134 mm x 1722 mm"],
      ["Spessore cornice", "35 mm"],
      ["Peso", "24 Kg"],
      ["Lunghezza cavi", "1.200mm"],
      ["Resistenza carico neve", "750 Kg/m²"],
      ["Resistenza alla grandine", "HW5 (Ø45mm, 110Km/h)"],
    ],
    electrical: {
      cols: panelDatasheet.electrical.cols,
      rows: [{ model: "TRS 390-54M-H8N ECO-RED", values: ["390 Wp", "30,7 V", "12,71 A", "37,9 V", "13,54 A", "19,9 %", "24,5 %"] }],
    },
    temperature: {
      cols: panelDatasheet.temperature.cols,
      rows: [{ model: "TRS 390-54M-H8N ECO-RED", values: ["-0,30 % / °C", "-0,25 V % / °C", "+0,046 % / °C", "45°C ± 2°C"] }],
    },
  },
  "integra-total-black": {
    ...panelDatasheet,
    description: moduleDescriptions["integra-total-black"],
    frame: { grad: "linear-gradient(135deg,#f2f2f2 0%,#c4c4c4 45%,#9a9a9a 100%)", textColor: "#2b2b2b", label: "Tecnologia PRISMA 4.0" },
    infoSlots: [
      { big: "8 volte", title: "Più resistente alla grandine", desc: "Grandine da 45 mm a 110 km/h, nello stesso punto all'infinito." },
      { big: "3 volte", title: "Più robusta a carico neve", desc: "750 kg/m² di resistenza, durabilità senza eguali." },
    ],
    design: [
      ["Configurazione", "Vetro - Polimero"],
      ["Colorazione", "Cornice Black / Sfondo Black / Ribbon Black"],
      ["Tecnologie celle", "TOPCon"],
      ["Numero celle", "108 celle"],
      ["Rapporto di layout", "0,230 kWp/m²"],
      ["Numero di fili conduttori", "16 Bus Bar"],
      ["Dimensioni", "1134 mm x 1722 mm"],
      ["Spessore cornice", "35 mm"],
      ["Peso", "24 Kg"],
      ["Lunghezza cavi", "1.200mm"],
      ["Resistenza carico neve", "750 Kg/m²"],
      ["Resistenza alla grandine", "HW5 (Ø45mm, 110Km/h)"],
    ],
    electrical: {
      cols: panelDatasheet.electrical.cols,
      rows: [{ model: "TRS 450-54M-H8N TOTAL BLACK", values: ["450 Wp", "32,50 V", "13,85 A", "39,16 V", "14,49 A", "23,0 %", "25,1 %"] }],
    },
    temperature: {
      cols: panelDatasheet.temperature.cols,
      rows: [{ model: "TRS 450-54M-H8N TOTAL BLACK", values: ["-0,30 % / °C", "-0,25 V % / °C", "+0,046 % / °C", "45°C ± 2°C"] }],
    },
  },
  "silvered-4-0": {
    ...panelDatasheet,
    productCerts: silveredProductCerts,
    description: moduleDescriptions["silvered-4-0"],
    cellTech: "PERC",
    infoSlots: [
      { big: "8 volte", title: "Più resistente alla grandine", desc: "Grandine da 45 mm a 110 km/h, nello stesso punto all'infinito." },
      { big: "3 volte", title: "Più robusta a carico neve", desc: "750 kg/m² di resistenza, durabilità senza eguali." },
    ],
    design: [
      ["Configurazione", "Vetro - Polimero"],
      ["Colorazione", "Cornice silver / Sfondo bianco"],
      ["Tecnologie celle", "PERC"],
      ["Numero celle", "60 celle"],
      ["Rapporto di layout", "0,201 kWp/m²"],
      ["Numero di fili conduttori", "5 Bus Bar"],
      ["Dimensioni", "1002 mm x 1665 mm"],
      ["Spessore cornice", "35 mm"],
      ["Peso", "22 Kg"],
      ["Lunghezza cavi", "+1000 mm"],
      ["Resistenza carico neve", "750 Kg/m²"],
      ["Resistenza alla grandine", "HW5 (Ø45mm, 110Km/h)"],
    ],
    electrical: {
      cols: panelDatasheet.electrical.cols,
      rows: [
        { model: "TRS 330-220M-SILVERED", values: ["330 Wp", "38,80 V", "9,76 A", "41,60 V", "10,30 A", "19,82 %", "22,6 %"] },
        { model: "TRS 335-220M-SILVERED", values: ["335 Wp", "34,00 V", "9,85 A", "41,80 V", "10,39 A", "20,15 %", "22,9 %"] },
      ],
    },
    temperature: {
      cols: panelDatasheet.temperature.cols,
      rows: [
        { model: "TRS 330-220M-SILVERED", values: ["-0,30 % / °C", "-0,25 V % / °C", "+0,046 % / °C", "45°C ± 2°C"] },
        { model: "TRS 335-220M-SILVERED", values: ["-0,30 % / °C", "-0,25 V % / °C", "+0,046 % / °C", "45°C ± 2°C"] },
      ],
    },
  },
  "innova": {
    ...panelDatasheet,
    solrif: {
      title: "Tecnologia Solrif® — Fotovoltaico integrato nella copertura",
      subtitle: "Inquadra il QR code per scoprire la pagina prodotto.",
      url: "https://www.torri.solar/prodotto/innova",
    },
    image: "/products/innova.webp",
    infoSlots: [
      { big: "8 volte", title: "Più resistente alla grandine", desc: "Grandine da 45 mm a 110 km/h, nello stesso punto all'infinito." },
      { big: "3 volte", title: "Più robusta a carico neve", desc: "750 kg/m² di resistenza, durabilità senza eguali." },
    ],
    design: [
      ["Configurazione", "Vetro - Polimero"],
      ["Colorazione", "Cornice silver / Sfondo bianco"],
      ["Tecnologie celle", "TOPCon"],
      ["Numero celle", "108 celle"],
      ["Rapporto di layout", "0,230 kWp/m²"],
      ["Numero di fili conduttori", "16 Bus Bar"],
      ["Dimensioni", "1158 mm x 1768 mm"],
      ["Spessore cornice", "15 mm"],
      ["Peso", "26 Kg"],
      ["Lunghezza cavi", "1.200mm"],
      ["Resistenza carico neve", "750 Kg/m²"],
      ["Resistenza alla grandine", "HW5 (Ø45mm, 110Km/h)"],
    ],
    electrical: {
      cols: panelDatasheet.electrical.cols,
      rows: [{ model: "TRS 450-54M-H8N INNOVA", values: ["450 Wp", "32,50 V", "13,85 A", "39,16 V", "14,49 A", "23,0 %", "25,1 %"] }],
    },
    temperature: {
      cols: panelDatasheet.temperature.cols,
      rows: [{ model: "TRS 450-54M-H8N INNOVA", values: ["-0,30 % / °C", "-0,25 V % / °C", "+0,046 % / °C", "45°C ± 2°C"] }],
    },
  },
};

// Meta prodotto per la scheda X-CORE² (prodotto a sé, primo tra i moduli nella bozza).
export const xcoreModuleMeta = {
  slug: "x-core-2",
  name: "X-CORE²",
  cat: "Moduli Fotovoltaici",
  tag: "Brevetto depositato",
  image: "/products/x-core-2-cover.jpg",
  desc: xcoreHalfCellDatasheet.description,
};

const HC_ELEC_COLS = panelDatasheet.electrical.cols;
const HC_TEMP_COLS = panelDatasheet.temperature.cols;
const hcDesign = (cells, layout, dim, peso, cavi) => [
  ["Configurazione", "Vetro - Polimero"],
  ["Colorazione", "Cornice silver / Sfondo bianco"],
  ["Tecnologie celle", "TOPCon"],
  ["Numero celle", cells],
  ["Rapporto di layout", layout],
  ["Numero di fili conduttori", "16 Bus Bar"],
  ["Dimensioni", dim],
  ["Spessore cornice", "35 mm"],
  ["Peso", peso],
  ["Lunghezza cavi", "1.200mm"],
  ["Resistenza carico neve", "750 Kg/m²"],
  ["Resistenza alla grandine", "HW5 (Ø45mm, 110Km/h)"],
];
const hcDs = (model, wp, cells, layout, dim, peso, cavi, elec) => ({
  ...panelDatasheet,
  description: `Modulo fotovoltaico half-cell in silicio monocristallino TOPCon ${model}: ${wp}, ${cells}. Dimensioni ${dim}, peso ${peso}. Resistenza carico neve 750 Kg/m², grandine HW5.`,
  design: hcDesign(cells, layout, dim, peso, cavi),
  electrical: { cols: HC_ELEC_COLS, rows: [{ model, values: elec }] },
  temperature: { cols: HC_TEMP_COLS, rows: [{ model, values: ["-0,30 % / °C", "-0,25 V % / °C", "+0,046 % / °C", "45°C ± 2°C"] }] },
});
const tbDesign = (cells, layout, dim, peso, cavi) => [
  ["Configurazione", "Vetro - Polimero"],
  ["Colorazione", "Cornice Black / Sfondo Black / Ribbon Black"],
  ["Tecnologie celle", "TOPCon"],
  ["Numero celle", cells],
  ["Rapporto di layout", layout],
  ["Numero di fili conduttori", "16 Bus Bar"],
  ["Dimensioni", dim],
  ["Spessore cornice", "35 mm"],
  ["Peso", peso],
  ["Lunghezza cavi", "1.200mm"],
  ["Resistenza carico neve", "750 Kg/m²"],
  ["Resistenza alla grandine", "HW5 (Ø45mm, 110Km/h)"],
];
const tbDs = (model, wp, cells, layout, dim, peso, cavi, elec) => ({
  ...panelDatasheet,
  description: `Modulo fotovoltaico total black in silicio monocristallino TOPCon ${model}: ${wp}, ${cells}. Cornice, sfondo e ribbon di colore black. Dimensioni ${dim}, peso ${peso}. Resistenza carico neve 750 Kg/m², grandine HW5.`,
  design: tbDesign(cells, layout, dim, peso, cavi),
  electrical: { cols: HC_ELEC_COLS, rows: [{ model, values: elec }] },
  temperature: { cols: HC_TEMP_COLS, rows: [{ model, values: ["-0,30 % / °C", "-0,25 V % / °C", "+0,046 % / °C", "45°C ± 2°C"] }] },
});
const svDesign = (cells, layout, dim, peso, cavi) => [
  ["Configurazione", "Vetro - Polimero"],
  ["Colorazione", "Cornice silver / Sfondo bianco"],
  ["Tecnologie celle", "PERC"],
  ["Numero celle", cells],
  ["Rapporto di layout", layout],
  ["Numero di fili conduttori", "5 Bus Bar"],
  ["Dimensioni", dim],
  ["Spessore cornice", "35 mm"],
  ["Peso", peso],
  ["Lunghezza cavi", cavi],
  ["Resistenza carico neve", "750 Kg/m²"],
  ["Resistenza alla grandine", "HW5 (Ø45mm, 110Km/h)"],
];
const svDs = (model, wp, cells, layout, dim, peso, cavi, elec) => ({
  ...panelDatasheet,
  productCerts: silveredProductCerts,
  description: `Modulo fotovoltaico Silvered per revamping con celle PERC ${model}: ${wp}, ${cells}. Cornice silver / sfondo bianco. Dimensioni ${dim}, peso ${peso}. Resistenza carico neve 750 Kg/m², grandine HW5.`,
  cellTech: "PERC",
  design: svDesign(cells, layout, dim, peso, cavi),
  electrical: { cols: HC_ELEC_COLS, rows: [{ model, values: elec }] },
  temperature: { cols: HC_TEMP_COLS, rows: [{ model, values: ["-0,30 % / °C", "-0,25 V % / °C", "+0,046 % / °C", "45°C ± 2°C"] }] },
});

export const productArchive = {
  "half-cell-4-0": [
    { model: "TRS 585-72M-H8N", power: "585 Wp", size: "1134 x 2278 mm", cells: "144 celle",
      datasheet: hcDs("TRS 585-72M-H8N HALF CELL", "585 Wp", "144 celle", "0,226 kWp/m²", "1134 x 2278 mm", "31 Kg", "1200 mm", ["585 Wp", "42,93 V", "13,63 A", "51,47 V", "14,39 A", "22,5 %", "24,5 %"]) },
    { model: "TRS 485-60M-H8N", power: "485 Wp", size: "1134 x 1909 mm", cells: "120 celle",
      datasheet: hcDs("TRS 485-60M-H8N HALF CELL", "485 Wp", "120 celle", "0,227 kWp/m²", "1134 x 1909 mm", "29 Kg", "+1200 mm / -1200 mm", ["485 Wp", "35,78 V", "13,56 A", "43,09 V", "14,34 A", "22,5 %", "24,5 %"]) },
    { model: "TRS 440-54M-H8N", power: "440 Wp", size: "1134 x 1722 mm", cells: "108 celle",
      datasheet: hcDs("TRS 440-54M-H8N HALF CELL", "440 Wp", "108 celle", "0,227 kWp/m²", "1134 x 1722 mm", "24 Kg", "+1000 mm / -1000 mm", ["440 Wp", "32,29 V", "13,63 A", "38,86 V", "14,42 A", "22,5 %", "24,5 %"]) },
  ],
  "integra-total-black": [
    { model: "TRS 485-60M-H8N", power: "485 Wp", size: "1134 x 1909 mm", cells: "120 celle",
      datasheet: tbDs("TRS 485-60M-H8N TOTAL BLACK", "485 Wp", "120 celle", "0,227 kWp/m²", "1134 x 1909 mm", "29 Kg", "+1200 mm", ["485 Wp", "35,78 V", "13,56 A", "43,09 V", "14,34 A", "22,3 %", "24,5 %"]) },
    { model: "TRS 440-54M-H8N", power: "440 Wp", size: "1134 x 1722 mm", cells: "108 celle",
      datasheet: tbDs("TRS 440-54M-H8N TOTAL BLACK", "440 Wp", "108 celle", "0,227 kWp/m²", "1134 x 1722 mm", "24 Kg", "+1000 mm", ["440 Wp", "32,29 V", "13,63 A", "38,86 V", "14,42 A", "22,5 %", "24,5 %"]) },
  ],
  "silvered-4-0": [
    { model: "TRS 290-220P-SILVERED", power: "290 Wp", size: "990 x 1640 mm", cells: "60 celle",
      datasheet: { ...svDs("TRS 290-220P-SILVERED", "290 Wp", "60 celle", "0,227 kWp/m²", "990 x 1640 mm", "22 Kg", "+1000 mm", ["290 Wp", "32,00 V", "9,06 A", "38,9 V", "9,47 A", "17,86 %", "19,9 %"]),
        image: "/media/IMG_6237.jpeg",
        description: "Modulo fotovoltaico in silicio policristallino, Full Cell, 290 Watt, 60 celle, vetro 4mm, backsheet bianco, cornici di colore silver, dimensioni 1640x990x35mm, 22 kg, garanzia 30 anni sui difetti di fabbrica e 30 anni sulla performance lineare, classe 1 di reazione fuoco.",
        design: [
          ["Configurazione", "Vetro - Polimero"],
          ["Colorazione", "Cornice silver / Sfondo bianco"],
          ["Tecnologie celle", "Policristallino"],
          ["Numero celle", "60 celle"],
          ["Rapporto di layout", "0,227 kWp/m²"],
          ["Numero di fili conduttori", "5 Bus Bar"],
          ["Dimensioni", "990 mm x 1640 mm"],
          ["Spessore cornice", "35 mm"],
          ["Peso", "22 Kg"],
          ["Lunghezza cavi", "1.200mm"],
          ["Resistenza carico neve", "750 Kg/m²"],
          ["Resistenza alla grandine", "HW5 (Ø45mm, 110Km/h)"],
        ],
        companyCerts: [
          ["ISO 9001:2015 Qualità", "KIWA"],
          ["ISO 14001:2015 Ambiente", "KIWA"],
          ["ISO 45001:2018 Sicurezza", "KIWA"],
        ] } },
  ],
};

export const legalPages = {
  "privacy-policy": {
    title: "Privacy Policy",
    updated: "Ultimo aggiornamento: agosto 2026",
    body: [
      { p: "Informativa sul trattamento dei dati personali ai sensi del Regolamento (UE) 2016/679 – GDPR." },
      { h: "1. Titolare del trattamento" },
      { p: "Il Titolare del trattamento dei dati personali raccolti attraverso il sito torri.solar è:" },
      { p: "FIER S.p.A. a socio unico — Via Cremona, 123 — 25025 Manerbio (BS) – Italia — P.IVA / C.F. 03720770985." },
      { p: "Per qualsiasi richiesta relativa alla protezione dei dati personali è possibile utilizzare i recapiti indicati nella sezione Contatti del sito." },
      { h: "2. Quali dati trattiamo" },
      { p: "Attraverso il sito possono essere raccolte le seguenti categorie di dati:" },
      { ul: [
        "dati identificativi, quali nome, cognome e ragione sociale;",
        "dati di contatto, quali telefono ed e-mail;",
        "indirizzo e dati relativi all'ubicazione dell'immobile o dell'impianto;",
        "dati tecnici relativi all'impianto fotovoltaico;",
        "dati contenuti nei documenti volontariamente caricati dall'utente;",
        "informazioni relative alle richieste di preventivo, assistenza, garanzia o candidatura;",
        "dati relativi alla navigazione sul sito;",
        "dati tecnici del dispositivo e della connessione;",
        "informazioni relative alla provenienza del contatto e alle campagne di marketing, ove consentito;",
        "eventuali ulteriori informazioni volontariamente comunicate dall'utente.",
      ] },
      { h: "3. Finalità del trattamento" },
      { p: "I dati possono essere trattati per:" },
      { sh: "Gestione delle richieste" },
      { p: "Rispondere a richieste di informazioni, contatto, consulenza, preventivo o appuntamento." },
      { sh: "Configurazione e progettazione dell'impianto" },
      { p: "Elaborare le informazioni fornite dall'utente per effettuare analisi preliminari, dimensionamenti, simulazioni e proposte relative a impianti e servizi TORRI." },
      { sh: "Gestione del rapporto precontrattuale e contrattuale" },
      { p: "Predisporre offerte, contratti, ordini e svolgere le attività necessarie all'esecuzione del rapporto con il cliente." },
      { sh: "Assistenza, manutenzione e garanzia" },
      { p: "Gestire segnalazioni, richieste tecniche, pratiche di garanzia, manutenzioni e attività post-vendita." },
      { sh: "Candidature alla rete TORRI" },
      { p: "Gestire richieste provenienti da Installatori Partner, Partner Commerciali, professionisti o altri soggetti interessati a collaborare con TORRI." },
      { sh: "Adempimenti amministrativi e normativi" },
      { p: "Adempiere agli obblighi previsti dalla normativa civilistica, fiscale, contabile e dalle altre disposizioni applicabili." },
      { sh: "Sicurezza" },
      { p: "Garantire la sicurezza del sito, prevenire utilizzi impropri, frodi o accessi non autorizzati." },
      { sh: "Comunicazioni commerciali" },
      { p: "Previo consenso, inviare informazioni su prodotti, servizi, iniziative, eventi, novità e opportunità TORRI attraverso e-mail, telefono, WhatsApp o altri canali autorizzati." },
      { sh: "Analisi e miglioramento" },
      { p: "Ove consentito, analizzare l'utilizzo del sito e delle relative funzionalità per migliorare contenuti, servizi ed esperienza degli utenti." },
      { h: "4. Base giuridica" },
      { p: "Il trattamento viene effettuato, a seconda delle circostanze, sulla base di:" },
      { ul: [
        "esecuzione di misure precontrattuali richieste dall'interessato;",
        "esecuzione di un contratto;",
        "adempimento di obblighi legali;",
        "legittimo interesse del Titolare, nei limiti consentiti dalla normativa;",
        "consenso dell'interessato, quando richiesto.",
      ] },
      { p: "Il consenso eventualmente prestato può essere revocato in qualsiasi momento, senza pregiudicare la liceità del trattamento effettuato prima della revoca." },
      { h: "5. Conferimento dei dati" },
      { p: "Il conferimento dei dati contrassegnati come obbligatori è necessario per poter gestire la relativa richiesta. Il mancato conferimento può rendere impossibile fornire il servizio richiesto. Il conferimento dei dati per finalità commerciali e promozionali è invece facoltativo." },
      { h: "6. Comunicazioni tramite e-mail, telefono e WhatsApp" },
      { p: "Quando necessario per gestire una richiesta, un appuntamento, un progetto, un contratto, un intervento, una manutenzione o una pratica di assistenza, FIER S.p.A. potrà utilizzare i recapiti forniti dall'interessato." },
      { p: "L'utilizzo dei medesimi canali per finalità promozionali avverrà quando previsto sulla base di uno specifico consenso o di altra base giuridica applicabile." },
      { h: "7. Destinatari dei dati" },
      { p: "I dati possono essere trattati da personale autorizzato di FIER S.p.A. e, quando necessario, comunicati a soggetti che collaborano all'erogazione dei servizi, quali:" },
      { ul: [
        "Installatori Partner TORRI;",
        "professionisti e progettisti;",
        "fornitori di servizi informatici e cloud;",
        "fornitori di servizi di comunicazione;",
        "società che gestiscono sistemi di pagamento;",
        "consulenti;",
        "soggetti incaricati delle attività amministrative;",
        "fornitori e subappaltatori coinvolti nella realizzazione o manutenzione degli impianti;",
        "autorità e soggetti pubblici nei casi previsti dalla legge.",
      ] },
      { p: "I soggetti esterni trattano i dati secondo il ruolo loro attribuito dalla normativa applicabile." },
      { h: "8. Installatori Partner TORRI" },
      { p: "Nell'ambito della gestione di richieste commerciali, sopralluoghi, installazioni, manutenzioni, assistenza e garanzie, alcuni dati possono essere comunicati a Installatori Partner TORRI qualificati quando ciò sia necessario per l'esecuzione del servizio. La comunicazione avviene limitatamente ai dati necessari allo svolgimento dell'attività assegnata." },
      { h: "9. Trasferimenti internazionali" },
      { p: "Alcuni fornitori tecnologici utilizzati dal sito potrebbero trattare dati al di fuori dello Spazio Economico Europeo. In tali casi il trattamento avverrà nel rispetto delle condizioni previste dal GDPR e mediante gli strumenti di garanzia applicabili." },
      { h: "10. Conservazione" },
      { p: "I dati vengono conservati per il tempo necessario al perseguimento delle finalità per cui sono stati raccolti e successivamente per il periodo richiesto dagli obblighi di legge o necessario alla tutela dei diritti del Titolare." },
      { p: "Le richieste commerciali che non danno origine a un rapporto contrattuale saranno conservate per un periodo proporzionato alle finalità per cui sono state raccolte. I dati utilizzati per attività promozionali saranno trattati fino alla revoca del consenso o comunque secondo i termini previsti dalla normativa applicabile." },
      { h: "11. Dati caricati dall'utente" },
      { p: "Quando il sito consente il caricamento di bollette, fotografie, documenti tecnici, fatture, DDT o altra documentazione, tali informazioni vengono utilizzate esclusivamente per le finalità connesse al servizio richiesto. L'utente è invitato a non trasmettere informazioni non necessarie." },
      { h: "12. Processi automatizzati e strumenti digitali" },
      { p: "Alcune funzionalità del sito possono utilizzare sistemi automatizzati per:" },
      { ul: [
        "organizzare le richieste;",
        "estrarre informazioni dai documenti;",
        "effettuare elaborazioni preliminari;",
        "effettuare simulazioni;",
        "classificare le richieste;",
        "indirizzare la richiesta verso il processo o il referente più appropriato.",
      ] },
      { p: "Tali strumenti hanno funzione di supporto operativo e non comportano, salvo ove diversamente indicato, decisioni esclusivamente automatizzate produttive di effetti giuridici sull'interessato." },
      { h: "13. Diritti dell'interessato" },
      { p: "Nei casi previsti dal GDPR, l'interessato può esercitare i diritti di:" },
      { ul: [
        "accesso;",
        "rettifica;",
        "cancellazione;",
        "limitazione del trattamento;",
        "opposizione;",
        "portabilità;",
        "revoca del consenso.",
      ] },
      { p: "L'interessato può inoltre proporre reclamo al Garante per la protezione dei dati personali." },
      { h: "14. Sicurezza" },
      { p: "FIER S.p.A. adotta misure tecniche e organizzative adeguate a proteggere i dati personali da perdita, accesso non autorizzato, alterazione, divulgazione o utilizzo improprio." },
      { h: "15. Collegamenti a servizi esterni" },
      { p: "Il sito può contenere collegamenti a siti, piattaforme e servizi di terzi. Il trattamento effettuato da tali soggetti è disciplinato dalle rispettive informative privacy." },
      { h: "16. Aggiornamenti" },
      { p: "La presente informativa può essere aggiornata per adeguarla a modifiche normative, organizzative o tecnologiche. La versione pubblicata sul sito è quella applicabile al momento della consultazione." },
    ],
  },
  "cookie-policy": {
    title: "Cookie Policy",
    updated: "Ultimo aggiornamento: agosto 2026",
    body: [
      { p: "Il sito torri.solar, gestito da FIER S.p.A., utilizza cookie e tecnologie analoghe per garantire il corretto funzionamento del sito e, previo consenso quando richiesto, per analizzare l'utilizzo dei servizi e misurare l'efficacia delle attività di comunicazione." },
      { h: "Cosa sono i cookie" },
      { p: "I cookie sono piccoli file che un sito può memorizzare sul dispositivo dell'utente durante la navigazione." },
      { p: "Alcuni cookie sono indispensabili per il funzionamento del sito; altri vengono utilizzati per analisi statistiche, personalizzazione o attività di marketing." },
      { h: "Cookie necessari" },
      { p: "Sono necessari al funzionamento tecnico del sito e delle funzionalità richieste dall'utente. Possono essere utilizzati, ad esempio, per:" },
      { ul: [
        "sicurezza;",
        "gestione della sessione;",
        "memorizzazione delle preferenze privacy;",
        "funzionamento dei form;",
        "autenticazione;",
        "prevenzione di abusi;",
        "bilanciamento e funzionamento dell'infrastruttura.",
      ] },
      { p: "Questi cookie non richiedono consenso quando sono strettamente necessari all'erogazione del servizio." },
      { h: "Cookie analitici" },
      { p: "Consentono di comprendere come viene utilizzato il sito, ad esempio:" },
      { ul: [
        "pagine visitate;",
        "provenienza delle visite;",
        "durata delle sessioni;",
        "dispositivi utilizzati;",
        "interazioni con le pagine;",
        "utilizzo delle principali funzionalità.",
      ] },
      { p: "Quando richiesto dalla normativa, vengono attivati solo dopo il consenso dell'utente." },
      { h: "Cookie di marketing e profilazione" },
      { p: "Possono essere utilizzati per misurare campagne pubblicitarie, attribuire conversioni e proporre comunicazioni maggiormente pertinenti. Possono riguardare, se effettivamente installati sul sito, servizi quali:" },
      { ul: ["Google Ads;", "Meta;", "LinkedIn;", "altre piattaforme pubblicitarie."] },
      { p: "Questi strumenti vengono attivati solo quando consentito e dopo aver raccolto il consenso necessario." },
      { h: "Google Tag Manager" },
      { p: "Il sito può utilizzare Google Tag Manager come sistema per gestire centralmente tag e strumenti di misurazione." },
      { p: "Google Tag Manager non deve essere utilizzato per aggirare le preferenze espresse dall'utente attraverso il banner cookie. I tag soggetti a consenso devono essere attivati esclusivamente secondo le preferenze selezionate." },
      { h: "Gestione delle preferenze" },
      { p: "Al primo accesso al sito viene mostrato un pannello che consente di:" },
      { ul: ["Accettare tutti", "Rifiutare i cookie non necessari", "Personalizzare"] },
      { p: "L'utente deve poter modificare successivamente le proprie preferenze attraverso il comando «Gestisci preferenze cookie» presente sul sito." },
      { p: "La revoca del consenso deve essere semplice quanto la sua prestazione." },
      { h: "Cookie e servizi effettivamente utilizzati" },
      { p: "La presente sezione deve essere generata e mantenuta aggiornata sulla base della scansione effettiva del sito. Per ogni cookie/tecnologia indicare almeno:" },
      { ul: ["Nome", "Provider", "Finalità", "Categoria", "Durata", "Dominio", "Prima/terza parte"] },
      { p: "Non inserire servizi non realmente presenti." },
      { h: "Servizi di terze parti" },
      { p: "Alcune funzionalità possono comportare collegamenti o interazioni con servizi esterni. Il trattamento effettuato da tali soggetti è disciplinato anche dalle rispettive informative." },
      { h: "Durata" },
      { p: "La durata dei cookie varia in funzione della relativa finalità. Alcuni vengono eliminati alla chiusura della sessione, mentre altri possono permanere per periodi più lunghi. La durata specifica deve essere riportata nell'elenco aggiornato dei cookie." },
      { h: "Titolare del trattamento" },
      { p: "FIER S.p.A. a socio unico — Via Cremona, 123 — 25025 Manerbio (BS) – Italia — P.IVA / C.F. 03720770985." },
      { p: "Per maggiori informazioni sul trattamento dei dati personali consultare la Privacy Policy." },
    ],
  },
  "note-legali": {
    title: "Note Legali",
    updated: "Ultimo aggiornamento: agosto 2026",
    body: [
      { h: "Proprietà del sito" },
      { p: "Il sito torri.solar è gestito da:" },
      { p: "FIER S.p.A. a socio unico — Via Cremona, 123 — 25025 Manerbio (BS) – Italia — P.IVA / C.F. 03720770985 — Capitale sociale € 500.000,00 i.v." },
      { p: "TORRI è un marchio utilizzato da FIER S.p.A." },
      { h: "Contenuti" },
      { p: "I contenuti presenti sul sito hanno finalità informative, commerciali e divulgative." },
      { p: "FIER S.p.A. presta attenzione all'accuratezza e all'aggiornamento delle informazioni pubblicate, ma caratteristiche, disponibilità, configurazioni e specifiche dei prodotti possono essere aggiornate nel tempo nell'ambito del continuo sviluppo tecnologico." },
      { p: "Per le caratteristiche applicabili a uno specifico prodotto o fornitura fanno fede la documentazione tecnica, le condizioni di vendita e gli accordi contrattuali applicabili." },
      { h: "Proprietà intellettuale" },
      { p: "Marchi, denominazioni, loghi, fotografie, video, testi, disegni, rendering, schede tecniche, documentazione, grafica, tecnologie, brevetti e altri contenuti presenti sul sito sono protetti dalla normativa applicabile in materia di proprietà intellettuale e industriale." },
      { p: "È vietata la riproduzione, distribuzione, modifica o utilizzazione per finalità commerciali senza preventiva autorizzazione del relativo titolare." },
      { h: "TORRI" },
      { p: "Il marchio TORRI, la relativa identità visiva e i segni distintivi associati non possono essere utilizzati senza autorizzazione." },
      { p: "L'eventuale appartenenza alla rete Installatori Partner TORRI non autorizza utilizzi del marchio differenti da quelli espressamente previsti dagli accordi applicabili." },
      { h: "Immagini e rappresentazioni" },
      { p: "Fotografie, rendering, configurazioni e rappresentazioni dei prodotti possono avere finalità illustrative." },
      { p: "Colori, finiture, dimensioni apparenti e dettagli possono variare in funzione del dispositivo utilizzato, della configurazione scelta e dell'evoluzione del prodotto." },
      { h: "Dati tecnici" },
      { p: "Le informazioni tecniche pubblicate sul sito rappresentano le caratteristiche dei prodotti secondo la documentazione disponibile al momento della pubblicazione. Per progettazione, installazione, utilizzo e manutenzione devono essere sempre consultati:" },
      { ul: [
        "scheda tecnica applicabile;",
        "manuale di installazione;",
        "certificazioni;",
        "condizioni di garanzia;",
        "eventuali prescrizioni specifiche;",
        "normativa applicabile.",
      ] },
      { h: "Simulazioni energetiche ed economiche" },
      { p: "Eventuali simulazioni relative a:" },
      { ul: [
        "produzione energetica;",
        "autoconsumo;",
        "risparmio;",
        "benefici economici;",
        "tempi di ritorno;",
        "rendimento;",
        "evoluzione dei prezzi dell'energia;",
        "incentivi;",
        "producibilità dell'impianto;",
      ] },
      { p: "costituiscono elaborazioni previsionali effettuate sulla base dei dati disponibili e delle ipotesi utilizzate. I risultati effettivi possono variare in funzione, tra l'altro, di:" },
      { ul: [
        "condizioni meteorologiche;",
        "irraggiamento;",
        "orientamento e inclinazione;",
        "ombreggiamenti;",
        "condizioni dell'impianto;",
        "consumi effettivi;",
        "comportamento dell'utente;",
        "prezzi dell'energia;",
        "condizioni contrattuali;",
        "evoluzione normativa;",
        "disponibilità e condizioni degli incentivi.",
      ] },
      { p: "Salvo specifico impegno contrattuale scritto, tali simulazioni non costituiscono garanzia di produzione, rendimento o beneficio economico." },
      { h: "Configuratore" },
      { p: "Gli strumenti di configurazione presenti sul sito hanno lo scopo di fornire una prima elaborazione del progetto sulla base delle informazioni inserite dall'utente." },
      { p: "La configurazione preliminare può richiedere successive verifiche tecniche, documentali, progettuali e commerciali." },
      { p: "FIER S.p.A. può pertanto correggere o aggiornare la configurazione quando emergano informazioni tecniche, condizioni del sito o elementi non disponibili durante la prima elaborazione." },
      { h: "Prezzi" },
      { p: "Quando presenti, prezzi e indicazioni economiche devono essere interpretati secondo le condizioni specificate nella relativa pagina, configurazione, offerta o preventivo." },
      { p: "Il prezzo definitivo è quello risultante dall'offerta o dal contratto accettato dalle parti." },
      { h: "Incentivi e normativa" },
      { p: "Le informazioni relative a incentivi, agevolazioni fiscali, comunità energetiche, contributi o altre misure normative hanno carattere informativo." },
      { p: "Normativa, requisiti e disponibilità delle misure possono cambiare." },
      { p: "L'applicabilità al singolo caso deve essere verificata sulla base delle condizioni vigenti e delle caratteristiche specifiche del soggetto e dell'intervento." },
      { h: "Richieste di garanzia" },
      { p: "L'invio di una segnalazione o l'apertura online di una pratica di garanzia non costituisce riconoscimento, accettazione o conferma della copertura in garanzia da parte di FIER S.p.A." },
      { p: "Ogni richiesta è soggetta a verifica tecnica e documentale secondo le condizioni di garanzia applicabili al prodotto interessato." },
      { p: "FIER S.p.A. potrà richiedere ulteriori informazioni, fotografie, documentazione, verifiche tecniche o l'intervento dell'installatore prima di determinare l'applicabilità della garanzia." },
      { p: "L'eventuale autorizzazione alla sostituzione di prodotti, all'esecuzione di interventi o al sostenimento di costi deve essere espressamente confermata da FIER S.p.A." },
      { h: "Installatori Partner TORRI" },
      { p: "Il sito può consentire di individuare Installatori Partner TORRI presenti sul territorio." },
      { p: "L'appartenenza alla rete indica l'esistenza di un rapporto di collaborazione con TORRI secondo le condizioni applicabili, ma non implica necessariamente che il Partner sia incaricato da FIER S.p.A. per uno specifico intervento." },
      { p: "La presenza, la distanza e la disponibilità degli Installatori Partner possono variare nel tempo." },
      { p: "Nell'ambito dei servizi chiavi in mano, FIER S.p.A. potrà affidare in tutto o in parte attività di sopralluogo, installazione, collaudo, assistenza, manutenzione e interventi in garanzia a Installatori Partner TORRI qualificati, secondo quanto previsto dalle condizioni contrattuali applicabili." },
      { h: "Collegamenti a siti esterni" },
      { p: "Il sito può contenere collegamenti a siti, piattaforme o servizi di terzi." },
      { p: "FIER S.p.A. non esercita necessariamente alcun controllo sui contenuti, sulla disponibilità o sulle modalità di trattamento dei dati di tali servizi e non assume responsabilità per contenuti o servizi forniti autonomamente da soggetti terzi." },
      { p: "L'accesso a siti esterni avviene sotto la responsabilità dell'utente e secondo le relative condizioni di utilizzo." },
      { h: "Disponibilità del sito e dei servizi digitali" },
      { p: "FIER S.p.A. si impegna a mantenere il sito e i relativi servizi digitali disponibili e aggiornati, ma non garantisce la continuità ininterrotta del servizio." },
      { p: "Potranno verificarsi sospensioni temporanee dovute, a titolo esemplificativo, a manutenzione, aggiornamenti, problemi tecnici, indisponibilità di servizi di terzi o cause non dipendenti da FIER S.p.A." },
      { h: "Limitazione di responsabilità" },
      { p: "Nei limiti consentiti dalla normativa applicabile, FIER S.p.A. non risponde di decisioni assunte esclusivamente sulla base di informazioni, simulazioni o contenuti presenti sul sito senza le necessarie verifiche tecniche, professionali o contrattuali." },
      { p: "Rimangono in ogni caso ferme le responsabilità inderogabili previste dalla legge e gli obblighi espressamente assunti da FIER S.p.A. nei confronti del cliente mediante specifico contratto." },
      { h: "Privacy e Cookie" },
      { p: "Il trattamento dei dati personali raccolti attraverso il sito è disciplinato dalla Privacy Policy." },
      { p: "L'utilizzo di cookie e tecnologie analoghe è disciplinato dalla Cookie Policy." },
      { p: "Le relative informative costituiscono parte integrante delle condizioni di utilizzo del sito." },
      { h: "Modifiche" },
      { p: "FIER S.p.A. si riserva la facoltà di modificare e aggiornare in qualsiasi momento i contenuti del sito e le presenti Note Legali." },
      { p: "La versione applicabile è quella pubblicata sul sito al momento della consultazione." },
      { h: "Legge applicabile" },
      { p: "Le presenti Note Legali sono disciplinate dalla legge italiana." },
      { p: "Per eventuali controversie si applicano le disposizioni sulla competenza previste dalla normativa vigente, restando ferme le tutele inderogabili riconosciute ai consumatori." },
    ],
  },
};


// ---------- Datasheet tecnici inverter (dati ufficiali per modello) ----------
const trifaseHV = {
  banner: "HIGH VOLTAGE",
  models: ["AURA 8.0 K-H", "AURA 10.0 K-H", "AURA 20.0 K-H", "AURA 30.0 K-H"],
  images: [
    { src: "/products/inverter-trifase-ibrido.png", caption: "AURA 8.0 / 10.0 K-H" },
    { src: "/products/inverter-trifase-commerciale.png", caption: "AURA 20.0 / 30.0 K-H" },
  ],
  sections: [
    {
      title: "Configurazione ambientale",
      rows: [
        { k: "Massima efficienza (PV in CA)", v: ["98.4%", "98.4%", "98.2%", "98.4%"] },
        { k: "Massima efficienza pesata Euro (PV ad CA)", v: ["97.9%", "97.9%", "97.9%", "97.9%"] },
        { k: "Massima efficienza batterie", v: ["98.0%", "98.0%", "98.0%", "98.0%"] },
      ],
    },
    {
      title: "Dati tecnici ingresso PV",
      rows: [
        { k: "Massima potenza in ingresso", v: ["15000W", "15000W", "30000W", "45000W"] },
        { k: "Massima tensione in ingresso CC", v: ["1000V", "1000V", "1000V", "1000V"] },
        { k: "Massima componente in ingresso (input A / input B)", v: ["20A/30A", "20A/30A", "-", "-"] },
        { k: "Massima corrente per ogni MPPT (input A / input B)", v: ["30A/40A", "30A/40A", "32A/32A", "32A/32A/32A"] },
        { k: "Massima corrente cortocircuito (input A / input B)", v: ["-", "-", "40A/40A", "40A/40A/40A"] },
        { k: "Intervallo MPPT di tensione CC", v: ["160V - 950V", "160V - 950V", "160V - 950V", "160V - 950V"] },
        { k: "N\u00b0 di MPPT indipendenti", v: ["2", "2", "2", "3"] },
        { k: "N\u00b0 di stringhe per MPPT", v: ["1+2", "1+2", "2/2", "2/2/2"] },
      ],
    },
    {
      title: "Dati tecnici ingresso batteria",
      rows: [
        { k: "Tipologia di batterie compatibili", v: ["Ioni di litio (AURA ACC)", "Ioni di litio (AURA ACC)", "Ioni di litio (AURA ACC)", "Ioni di litio (AURA ACC)"] },
        { k: "Tensione nominale batterie", v: ["200V-600V", "200V-600V", "230V-800V", "230V-800V"] },
        { k: "Intervallo di tensione batterie", v: ["200V-600V", "200V-600V", "120V-800V", "120V-800V"] },
        { k: "Massima corrente di carica/scarica", v: ["50A/50A", "50A/50A", "60A/60A", "2*75A/2*75A"] },
        { k: "Massima potenza di carica/scarica", v: ["15000W/9300W", "15000W/10500W", "30000W/24000W", "45000W/36000W"] },
        { k: "Curva di carica batterie al Litio", v: ["Auto-adattamento del BMS", "Auto-adattamento del BMS", "Auto-adattamento del BMS", "Auto-adattamento del BMS"] },
      ],
    },
    {
      title: "Dati tecnici uscita CA",
      rows: [
        { k: "Potenza attiva nominale CA", v: ["8000W", "10000W", "20000W", "30000W"] },
        { k: "Massima potenza apparente in uscita CA", v: ["8800VA", "11000VA", "22000VA", "33000VA"] },
        { k: "Massima potenza in uscita CA (FP=1)", v: ["8800W", "11000W", "22000W", "33000W"] },
        { k: "Massima corrente in uscita CA", v: ["3*13.3A", "3*16.7A", "3*33.3A", "3*50A"] },
        { k: "Massima potenza per singola fase", v: ["4kW", "5kW", "10Kw", "11Kw"] },
        { k: "Massima corrente (uscita)", v: ["18.2A", "22.7A", "-", "-"] },
        { k: "Potenza apparente (ingresso)", v: ["15kVA", "15kVA", "40000VA", "45000VA"] },
        { k: "Massima corrente (Ingresso)", v: ["3*25A", "3*25A", "3*60.6A", "3*68.2A"] },
        { k: "Tensione nominale CA", v: ["380V / 400V / 415V, 3W+N+PE", "380V / 400V / 415V, 3W+N+PE", "380V / 400V / 415V, 3W+N+PE", "380V / 400V / 415V, 3W+N+PE"] },
        { k: "Intervallo di tensione CA", v: ["277V-520V (Regolabile)", "277V-520V (Regolabile)", "-", "-"] },
        { k: "Frequenza nominale in uscita", v: ["50Hz / 60Hz", "50Hz / 60Hz", "50Hz / 60Hz", "50Hz / 60Hz"] },
        { k: "Intervallo frequenza CA", span: "45Hz-55Hz / 55Hz-65Hz (In accordo con gli standard di rete locali)" },
        { k: "Connessione alla rete", v: ["Trifase", "Trifase", "Trifase", "Trifase"] },
        { k: "Fattore di potenza", span: "> 0.99 Potenza nominale (Regolabile 0.8 LD - 0.8 LG)" },
        { k: "THDI", v: ["<3% (Potenza nominale)", "<3% (Potenza nominale)", "<3% (Potenza nominale)", "<3% (Potenza nominale)"] },
      ],
    },
    {
      title: "Uscita (backup)",
      rows: [
        { k: "Potenza nominale in uscita", v: ["8000W", "10000W", "20000W", "30000W"] },
        { k: "Corrente nominale in uscita", v: ["3*12.2A", "3*15.2A", "3*30.3A", "3*45.5A"] },
        { k: "Massima potenza singola fase", v: ["4kW", "5kW", "-", "-"] },
        { k: "Massima corrente singola fase", v: ["18.2A", "22.7A", "-", "-"] },
        { k: "Massima potenza (5min)", v: ["9600VA", "12000VA", "24000VA", "36000VA"] },
        { k: "Massima potenza (10s)", v: ["12000VA", "15000VA", "30000VA", "45000VA"] },
        { k: "Tensione di uscita nominale", v: ["380V / 400V, 3W+N+PE", "380V / 400V, 3W+N+PE", "380V / 400V / 415V, 3W+N+PE", "380V / 400V / 415V, 3W+N+PE"] },
        { k: "Frequenza nominale in uscita", v: ["50Hz / 60Hz", "50Hz / 60Hz", "50Hz / 60Hz", "50Hz / 60Hz"] },
        { k: "Tempo di trasferimento", v: ["10ms (typ) / 20ms (max)", "10ms (typ) / 20ms (max)", "<10ms (typ)", "<10ms (typ)"] },
        { k: "THD tensione", v: ["<3% (R Carico), 5% (RCD carico)", "<3% (R Carico), 5% (RCD carico)", "<3% (R Carico), 100% (R carico)", "<3% (R Carico), 100% (R carico)"] },
      ],
    },
    {
      title: "Protezioni",
      rows: [
        { k: "Protezione anti-isola", v: ["Supportato", "Supportato", "Supportato", "Supportato"] },
        { k: "Protezione sovracorrente CA", v: ["Supportato", "Supportato", "Supportato", "Supportato"] },
        { k: "Protezione corto-circuito CA", v: ["Supportato", "Supportato", "Supportato", "Supportato"] },
        { k: "Protezione sovratensione CA", v: ["Supportato", "Supportato", "Supportato", "Supportato"] },
        { k: "Scaricatore di sovratensione", v: ["DC Tipo II, AC Tipo II", "DC Tipo II, AC Tipo II", "DC Tipo II, AC Tipo III", "DC Tipo II, AC Tipo III"] },
        { k: "Rilevamento isolamento", v: ["Supportato", "Supportato", "Supportato", "Supportato"] },
      ],
    },
    {
      title: "Dati tecnici generali",
      rows: [
        { k: "Altitudine massima di lavoro", v: ["4000m (>2000m declassamento)", "4000m (>2000m declassamento)", "4000m (>2000m declassamento)", "4000m (>2000m declassamento)"] },
        { k: "Rumorosit\u00e0", v: ["30dB", "30dB", "-", "-"] },
        { k: "Grado di protezione ambientale", v: ["IP65", "IP65", "IP66", "IP66"] },
        { k: "Intervallo di temperatura", v: ["-25 ~ 45", "-25 ~ 45", "-25 ~ 60", "-25 ~ 60"] },
        { k: "Umidit\u00e0 relativa", v: ["0 ~ 100%", "0 ~ 100%", "0 ~ 100%", "0 ~ 100%"] },
        { k: "Sistema di raffreddamento", v: ["Convenzione naturale", "Convenzione naturale", "Convenzione naturale", "Ventola smart"] },
        { k: "Montaggio", v: ["A muro", "A muro", "A muro", "A muro"] },
        { k: "Dimensioni (L*H*S)", v: ["530mm*550mm*212mm", "530mm*550mm*212mm", "660mm*596mm*235mm", "660mm*596mm*235mm"] },
        { k: "Peso", v: ["32Kg", "32Kg", "45Kg", "55Kg"] },
        { k: "PV connettori", v: ["MC4/H4", "MC4/H4", "MC4/H4", "MC4/H4"] },
      ],
    },
    {
      title: "HMI & COM",
      rows: [
        { k: "Display", v: ["LED+APP (Bluetooth)", "LED+APP (Bluetooth)", "LED+APP (Bluetooth)", "LED+APP (Bluetooth)"] },
        { k: "Comunicazione di interfaccia", v: ["CAN/RS485 (per BMS), DRM/RCR (for DI) / RS485 (per Meter) 1*DO, Optional: WiFi/GPRS/4G/Ethernet", "CAN/RS485 (per BMS), DRM/RCR (for DI) / RS485 (per Meter) 1*DO, Optional: WiFi/GPRS/4G/Ethernet", "CAN/RS485 (per BMS), DRM/RS485 (per Meter), Optional: WiFi/LAN, 3*DO, 2*DI", "CAN/RS485 (per BMS), DRM/RS485 (per Meter), Optional: WiFi/LAN, 3*DO, 2*DI"] },
      ],
    },
    {
      title: "Certificazioni di prodotto",
      rows: [
        { k: "Rete", v: ["IEC 61727/62116, EN 50549-1, VDE 4105, AS 4777, CEI 0-21, G99, C10/11, RD627", "IEC 61727/62116, EN 50549-1, VDE 4105, AS 4777, CEI 0-21, G99, C10/11, RD627", "IEC 61727/62116, EN 50549-1, VDE 4105, AS 4777, CEI 0-21, G99, C10/11, RD627, CEI-016", "IEC 61727/62116, EN 50549-1, VDE 4105, AS 4777, CEI 0-21, G99, C10/11, RD627, CEI-016"] },
        { k: "Safety", v: ["IEC62109-1&2, IEC62477-1", "IEC62109-1&2, IEC62477-1", "IEC62109-1&2, IEC62477-1", "IEC62109-1&2, IEC62477-1"] },
        { k: "Garanzia", v: ["10 ANNI", "10 ANNI", "10 ANNI", "10 ANNI"] },
      ],
    },
    {
      title: "Certificazioni aziendali",
      rows: [
        { k: "ISO 9001:2015 Qualit\u00e0", span: "KIWA" },
        { k: "ISO 14001:2015 Ambiente", span: "KIWA" },
        { k: "ISO 45001:2018 Sicurezza", span: "KIWA" },
        { k: "Factory Inspection Attestation Photovoltaic (PV) Panels", span: "KIWA" },
      ],
    },
  ],
  notes: [
    "* L'intervallo di tensione e di frequenza di uscita pu\u00f2 variare a seconda della normativa locale. Le specifiche sono soggette a modifiche senza preavviso.",
    "* La potenza erogata in backup dipende dal numero e dal tipo di batterie nonch\u00e9 dallo stato di sistema (Temperatura, Capacit\u00e0 residua).",
    "Le specifiche tecniche sono soggette a continui aggiornamenti e possono variare in qualsiasi momento senza alcun preavviso.",
    "Verificare condizioni e validit\u00e0 delle garanzie direttamente con l'azienda al momento dell'acquisto.",
  ],
};

export const inverterDatasheets = {
  "inverter-trifase-ibrido": { ...trifaseHV, image: "/products/inverter-trifase-ibrido.png" },
  "inverter-trifase-commerciale": {
    image: "/products/inverter-trifase-commerciale.png",
    models: ["AURA 15 K-GC", "AURA 25 K-GC"],
    sections: [
      {
        title: "Efficienza",
        rows: [
          { k: "Massima efficienza", v: ["98.4%", "98.4%"] },
          { k: "Efficienza pesata (Euro)", v: ["98.0%", "98.0%"] },
        ],
      },
      {
        title: "Dati tecnici ingresso PV",
        rows: [
          { k: "Massima tensione in ingresso", v: ["1100V", "1100V"] },
          { k: "Massima Pot ingresso CC", v: ["22500W", "37500W"] },
          { k: "Tensione nominale in ingresso", v: ["620V", "620V"] },
          { k: "Massima corrente in ingresso", v: ["2*30A", "2*30A"] },
          { k: "Massima corrente per ogni MPPT", v: ["2*40A", "2*40A"] },
          { k: "Tensione nominale di partenza", v: ["180V", "180V"] },
          { k: "Intervallo MPPT di tensione CC", v: ["160V - 1000V", "160V - 1000V"] },
          { k: "Massimo N° di stringhe per MPPT", v: ["4 (2/2)", "4 (2/2)"] },
          { k: "N° MPPT indipendenti", v: ["2", "2"] },
        ],
      },
      {
        title: "Dati tecnici uscita CA",
        rows: [
          { k: "Potenza attiva nominale CA", v: ["15000W", "25000W"] },
          { k: "Massima potenza apparente CA", v: ["16500VA", "27500VA"] },
          { k: "Massima potenza attiva CA (PF=1)", v: ["16500W", "27500W"] },
          { k: "Massima corrente in uscita CA", v: ["3*25.3A", "3*39.8A"] },
          { k: "Tensione nominale CA", v: ["380V / 400V / 415V, 3W+N+PE", "380V / 400V / 415V, 3W+N+PE"] },
          { k: "Intervallo tensione CA", span: "260V-510V (regolabile a seconda degli standard di rete locale)" },
          { k: "Frequenza nominale di rete", v: ["50Hz / 60Hz", "50Hz / 60Hz"] },
          { k: "Intervallo di frequenza alla rete", span: "45Hz-55Hz / 55Hz-65Hz (In accordo con gli standard di rete locali)" },
          { k: "Distorsione armonica totale", v: ["<3% (Potenza nominale)", "<3% (Potenza nominale)"] },
          { k: "Fattore di potenza", span: "> 0.99 Potenza nominale (Regolabile 0.8 LD - 0.8 LG)" },
          { k: "Limitazione immissione in rete*", v: ["Programmabile", "Programmabile"] },
        ],
      },
      {
        title: "Protezione",
        rows: [
          { k: "Sezionatore CC", v: ["Supportato", "Supportato"] },
          { k: "Protezione anti-isola", v: ["Supportato", "Supportato"] },
          { k: "Protezione sovratensione CA", v: ["Supportato", "Supportato"] },
          { k: "Protezione corto-circuito CA", v: ["Supportato", "Supportato"] },
          { k: "Connessione inversa CC", v: ["Supportato", "Supportato"] },
          { k: "Scaricatore di sovratensioni", span: "CA Tipo III (Tipo II opzionale) / CC Tipo III (Tipo II opzionale)" },
          { k: "Rilevamento isolamento", v: ["Supportato", "Supportato"] },
          { k: "Protezione corrente di dispersione", v: ["Supportato", "Supportato"] },
        ],
      },
      {
        title: "Dati generici",
        rows: [
          { k: "Tipologia", v: ["Senza trasformatore", "Senza trasformatore"] },
          { k: "Grado di protezione ambientale", v: ["IP66", "IP66"] },
          { k: "Consumo notturno", v: ["<1W", "<1W"] },
          { k: "Raffreddamento", v: ["Convezione forzata da ventole", "Convezione forzata da ventole"] },
          { k: "Intervallo temperature di lavoro", v: ["-25° / +60°", "-25° / +60°"] },
          { k: "Intervallo umidità relativa", v: ["0-100%", "0-100%"] },
          { k: "Massima altitudine", v: ["4000m", "4000m"] },
          { k: "Rumore", v: ["<45dB", "<45dB"] },
          { k: "Dimensioni (L*H*P)", v: ["398mm*460mm*190mm", "398mm*460mm*190mm"] },
          { k: "Peso", v: ["20Kg", "20Kg"] },
        ],
      },
      {
        title: "HMI & COM",
        rows: [
          { k: "Display", v: ["Wireless & APP+LED, LCD (Opzionale)", "Wireless & APP+LED, LCD (Opzionale)"] },
          { k: "Comunicazione di interfaccia", v: ["RS485, Opzionale: WiFi / GPRS / 4G / LAN", "RS485, Opzionale: WiFi / GPRS / 4G / LAN"] },
        ],
      },
      {
        title: "Certificazioni di prodotto",
        rows: [
          { k: "Standard di connessione alla rete", span: "VDE-AR-N 4105, EN 50549-1, CEI 0-21, UNE 206006/206007-1, RD 1699/661&413, IEC 61727/62116, AS4777.2" },
          { k: "Safety", v: ["IEC62109-1, IEC62109-2", "IEC62109-1, IEC62109-2"] },
          { k: "Garanzia", v: ["10 ANNI", "10 ANNI"] },
        ],
      },
      {
        title: "Certificazioni aziendali",
        rows: [
          { k: "ISO 9001:2015 Qualità", span: "KIWA" },
          { k: "ISO 14001:2015 Ambiente", span: "KIWA" },
          { k: "ISO 45001:2018 Sicurezza", span: "KIWA" },
          { k: "Factory Inspection Attestation Photovoltaic (PV) Panels", span: "KIWA" },
        ],
      },
    ],
    notes: [
      "* L'intervallo di tensione e di frequenza di uscita può variare a seconda della normativa locale. Le specifiche sono soggette a modifiche senza preavviso.",
      "* La potenza erogata in backup dipende dal numero e dal tipo di batterie nonché dallo stato di sistema (Temperatura, Capacità residua).",
      "Le specifiche tecniche sono soggette a continui aggiornamenti e possono variare in qualsiasi momento senza alcun preavviso.",
      "Verificare condizioni e validità delle garanzie direttamente con l'azienda al momento dell'acquisto.",
    ],
  },
  "inverter-trifase-industriale": {
    image: "/products/inverter-trifase-industriale.png",
    models: ["AURA 50 K-GC", "AURA 100 K-GC"],
    sections: [
      {
        title: "Efficienza",
        rows: [
          { k: "Massima efficienza", v: ["98.5%", "98.5%"] },
          { k: "Efficienza pesata (Euro)", v: ["97.9%", "98.0%"] },
        ],
      },
      {
        title: "Dati tecnici ingresso PV",
        rows: [
          { k: "Massima tensione in ingresso", v: ["1100V", "1100V"] },
          { k: "Massima Pot ingresso CC", v: ["75000W", "150000W"] },
          { k: "Tensione nominale in ingresso", v: ["620V", "620V"] },
          { k: "Massima corrente in ingresso", v: ["136A (32A/32A/32A/40A)", "3*40A + 5*32A"] },
          { k: "Massima corrente per ogni MPPT", v: ["185A (45A/45A/45A/50A)", "3*50A + 5*45A"] },
          { k: "Tensione nominale di partenza", v: ["200V", "250V / 200V"] },
          { k: "Intervallo MPPT di tensione CC", v: ["180V-1000V", "200V-1000V"] },
          { k: "Massimo N° di stringhe per MPPT", v: ["8 (2/2/2/2)", "16 (8*2)"] },
          { k: "N° MPPT indipendenti", v: ["4", "8"] },
        ],
      },
      {
        title: "Dati tecnici uscita CA",
        rows: [
          { k: "Potenza attiva nominale CA", v: ["50000W", "100000W"] },
          { k: "Massima potenza apparente CA", v: ["55600VA", "110000VA"] },
          { k: "Massima potenza attiva CA (PF=1)", v: ["55600W", "110000W"] },
          { k: "Massima corrente in uscita CA", v: ["3*84.3 A", "3*168.8 A"] },
          { k: "Tensione nominale CA", v: ["380V / 400V / 415V, 3W+N+PE", "380V / 400V / 415V, 3W+N+PE"] },
          { k: "Intervallo tensione CA", span: "277V-520V (regolabile a seconda degli standard di rete locale)" },
          { k: "Frequenza nominale di rete", v: ["50Hz / 60Hz", "50Hz / 60Hz"] },
          { k: "Intervallo di frequenza alla rete", span: "45Hz-55Hz / 55Hz-65Hz (In accordo con gli standard di rete locali)" },
          { k: "Distorsione armonica totale", v: ["<3% (Potenza nominale)", "<3% (Potenza nominale)"] },
          { k: "Fattore di potenza", span: "> 0.99 Potenza nominale (Regolabile 0.8 LD - 0.8 LG)" },
          { k: "Limitazione immissione in rete*", v: ["Programmabile", "Programmabile"] },
        ],
      },
      {
        title: "Protezione",
        rows: [
          { k: "Sezionatore CC", v: ["Supportato", "Supportato"] },
          { k: "Protezione anti-isola", v: ["Supportato", "Supportato"] },
          { k: "Protezione sovratensione CA", v: ["Supportato", "Supportato"] },
          { k: "Protezione corto-circuito CA", v: ["Supportato", "Supportato"] },
          { k: "Connessione inversa CC", v: ["Supportato", "Supportato"] },
          { k: "Scaricatore di sovratensioni", v: ["DC Tipo II / AC Tipo II", "DC Tipo II / AC Tipo II"] },
          { k: "Rilevamento isolamento", v: ["Supportato", "Supportato"] },
          { k: "Protezione corrente di dispersione", v: ["Supportato", "Supportato"] },
        ],
      },
      {
        title: "Dati generici",
        rows: [
          { k: "Tipologia", v: ["Senza trasformatore", "Senza trasformatore"] },
          { k: "Grado di protezione ambientale", v: ["IP65", "IP65"] },
          { k: "Consumo notturno", v: ["<1W", "<10W"] },
          { k: "Raffreddamento", v: ["Convezione forzata da ventole", "Convezione forzata da ventole"] },
          { k: "Intervallo temperature di lavoro", v: ["-25° / +60°", "-25° / +60°"] },
          { k: "Intervallo umidità relativa", v: ["0-100%", "0-100%"] },
          { k: "Massima altitudine", v: ["4000m", "4000m"] },
          { k: "Rumore", v: ["<65dB", "<75dB"] },
          { k: "Dimensioni (L*H*P)", v: ["635mm*530mm*224mm", "850mm*670mm*356mm"] },
          { k: "Peso", v: ["42Kg", "92Kg"] },
        ],
      },
      {
        title: "HMI & COM",
        rows: [
          { k: "Display", v: ["Wireless & APP+LED", "Wireless & APP+LED"] },
          { k: "Comunicazione di interfaccia", v: ["RS485, Opzionale: WiFi / GPRS / 4G / LAN", "RS485, Opzionale: WiFi / GPRS / 4G / LAN"] },
        ],
      },
      {
        title: "Certificazioni di prodotto",
        rows: [
          { k: "Standard di connessione alla rete", span: "VDE-AR-N 4105, EN 50549-1, CEI 0-21/16, G99, UNE 206006/206007-1, UNE 217001, IEC 61727/62116, VDE 0126" },
          { k: "Safety", v: ["IEC62109-1, IEC62109-2", "IEC62109-1, IEC62109-2"] },
          { k: "Garanzia", v: ["10 ANNI", "10 ANNI"] },
        ],
      },
      {
        title: "Certificazioni aziendali",
        rows: [
          { k: "ISO 9001:2015 Qualità", span: "KIWA" },
          { k: "ISO 14001:2015 Ambiente", span: "KIWA" },
          { k: "ISO 45001:2018 Sicurezza", span: "KIWA" },
          { k: "Factory Inspection Attestation Photovoltaic (PV) Panels", span: "KIWA" },
        ],
      },
    ],
    notes: [
      "* L'intervallo di tensione e di frequenza di uscita può variare a seconda della normativa locale. Le specifiche sono soggette a modifiche senza preavviso.",
      "* La potenza erogata in backup dipende dal numero e dal tipo di batterie nonché dallo stato di sistema (Temperatura, Capacità residua).",
      "Le specifiche tecniche sono soggette a continui aggiornamenti e possono variare in qualsiasi momento senza alcun preavviso.",
      "Verificare condizioni e validità delle garanzie direttamente con l'azienda al momento dell'acquisto.",
    ],
  },
  "aura-accu-hv": {
    image: "/products/accu-hv.png",
    models: ["ACCU10K-HV", "ACCU15K-HV", "ACCU20K-HV", "ACCU25K-HV"],
    sections: [
      {
        title: "Dati tecnici",
        rows: [
          { k: "Modulo (5.1 kWh)", span: "AURA ACCU-HV" },
          { k: "Configurazione", v: ["ACCU10K-HV", "ACCU15K-HV", "ACCU20K-HV", "ACCU25K-HV"] },
          { k: "Quantità moduli", v: ["2", "3", "4", "5"] },
          { k: "Tecnologia", v: ["LiFePO4", "LiFePO4", "LiFePO4", "LiFePO4"] },
          { k: "Capacità massima", v: ["50 Ah", "50 Ah", "50 Ah", "50 Ah"] },
          { k: "Tensione nominale [V]", v: ["204.8", "307.2", "409.6", "512"] },
          { k: "Dimensioni HxLxP [m]", v: ["735x560x400", "967x560x400", "1199x560x400", "1431x560x400"] },
          { k: "Energia totale [Kwh]", v: ["10.2", "15.3", "20.4", "25.6"] },
          { k: "Corrente nominale carica/scarica", v: ["30A, 0.6 C", "30A, 0.6 C", "30A, 0.6 C", "30A, 0.6 C"] },
          { k: "Peso [Kg]", v: ["148.1Kg", "207.6 Kg", "266.8 Kg", "326 Kg"] },
          { k: "Cicli vita", span: "6000, 0,5C at 25°, 80% DoD, 80% SOH" },
          { k: "Temperatura di lavoro*", span: "Carica Temperatura: -5°C / 55°C - Scarica Temperatura: -15°C / 55°C" },
          { k: "Massima capacità in parallelo", v: ["256 Kwh", "256 Kwh", "256 Kwh", "256 Kwh"] },
          { k: "Montaggio", span: "A terra (inclusi supporti regolabili)" },
          { k: "Garanzia", span: "10 ANNI" },
          { k: "Grado di protezione", v: ["IP55", "IP55", "IP55", "IP55"] },
          { k: "Comunicazione", span: "RS232, RS485, CAN bus, WIFI & Bluetooth (con dispositivo esterno)" },
          { k: "Certificati", span: "(Lista aggiornata su www.torrisolare.it)" },
        ],
      },
      {
        title: "Certificazioni aziendali",
        rows: [
          { k: "ISO 9001:2015 Qualità", span: "KIWA" },
          { k: "ISO 14001:2015 Ambiente", span: "KIWA" },
          { k: "ISO 45001:2018 Sicurezza", span: "KIWA" },
          { k: "Factory Inspection Attestation Photovoltaic (PV) Panels", span: "KIWA" },
        ],
      },
    ],
    notes: ["* Temperatura di lavoro raccomandata 10 - 30°C."],
  },
  "aura-accu-hv-5-5": {
    image: "/products/accu-hv-5-5.png",
    models: ["ACCU11K-HV", "ACCU16.5K-HV", "ACCU22K-HV", "ACCU27.5K-HV", "ACCU33K-HV", "ACCU38.5K-HV", "ACCU44K-HV"],
    sections: [
      {
        title: "Dati tecnici",
        rows: [
          { k: "Modulo (5.5 kWh)", span: "AURA ACCU-HV" },
          { k: "Configurazione", v: ["ACCU11K-HV", "ACCU16.5K-HV", "ACCU22K-HV", "ACCU27.5K-HV", "ACCU33K-HV", "ACCU38.5K-HV", "ACCU44K-HV"] },
          { k: "Quantità moduli", v: ["2", "3", "4", "5", "6", "7", "8"] },
          { k: "Tecnologia", v: ["LiFePO4", "LiFePO4", "LiFePO4", "LiFePO4", "LiFePO4", "LiFePO4", "LiFePO4"] },
          { k: "Capacità massima", v: ["50 Ah", "50 Ah", "50 Ah", "50 Ah", "50 Ah", "50 Ah", "50 Ah"] },
          { k: "Tensione nominale [V]", v: ["153.6V", "230.4V", "307.2V", "384.0V", "460.8V", "537.6V", "614.4V"] },
          { k: "Dimensioni LxPxH [mm]", v: ["675x360x626", "675x360x796", "675x360x966", "675x360x1136", "675x360x1306", "675x360x1476", "675x360x1646"] },
          { k: "Energia totale [Kwh]", v: ["11kWh", "16.5kWh", "22kWh", "27.5kWh", "33kWh", "38.5kWh", "44kWh"] },
          { k: "Corrente nominale carica/scarica", span: "60A / 60A" },
          { k: "Peso [Kg]", v: ["124 Kg", "174 Kg", "224 Kg", "274 Kg", "324 Kg", "374 Kg", "424 Kg"] },
          { k: "Cicli vita", span: "6000, 0,5C at 25°, 80% DoD, 80% SOH" },
          { k: "Temperatura di lavoro*", span: "Carica Temperatura: -5°C / 55°C - Scarica Temperatura: -20°C / 55°C" },
          { k: "Montaggio", span: "A terra (inclusi supporti regolabili)" },
          { k: "Garanzia", span: "10 ANNI" },
          { k: "Grado di protezione", span: "IP65" },
          { k: "Comunicazione", span: "RS232, RS485, CAN bus, WIFI & Bluetooth (con dispositivo esterno)" },
          { k: "Certificati", span: "(Lista aggiornata su www.torrisolare.it)" },
        ],
      },
      {
        title: "Certificazioni aziendali",
        rows: [
          { k: "ISO 9001:2015 Qualità", span: "KIWA" },
          { k: "ISO 14001:2015 Ambiente", span: "KIWA" },
          { k: "ISO 45001:2018 Sicurezza", span: "KIWA" },
          { k: "Factory Inspection Attestation Photovoltaic (PV) Panels", span: "KIWA" },
        ],
      },
    ],
    notes: ["* Temperatura di lavoro raccomandata 10 - 30°C."],
  },
  "aura-accu5k-lv": {
    image: "/products/accu5k-lv.png",
    models: ["ACCU5K-LV"],
    sections: [
      {
        title: "Dati tecnici",
        rows: [
          { k: "Modello", v: ["ACCU5K-LV"] },
          { k: "Codice", v: ["TRS-ACC-5Kwh"] },
          { k: "Tecnologia", v: ["LiFePO4"] },
          { k: "Dimensioni (L*P*H)", v: ["520mm*443mm*177 mm"] },
          { k: "Peso", v: ["36 Kg"] },
          { k: "Montaggio", v: ["A terra o a parete (staffa inclusa)"] },
          { k: "Kit cavi di connessione all'inverter", v: ["Incluso"] },
          { k: "Intervallo di T di utilizzo in carica / scarica", v: ["0 - 55°C"] },
          { k: "Intervallo di umidità relative ammesso", v: ["-10-55°C"] },
          { k: "Massima altitudine operativa", v: ["2000 m"] },
          { k: "Numero massimo di batterie installabili", v: ["8"] },
          { k: "Certificazioni", v: ["(Lista aggiornata su www.torrisolare.it)"] },
          { k: "Garanzia", v: ["10 ANNI"] },
          { k: "Grado di protezione", v: ["IP55"] },
          { k: "Comunicazione", v: ["RS232, RS485, CAN bus, WIFI & Bluetooth (con dispositivo esterno)"] },
        ],
      },
      {
        title: "Dati capacità",
        rows: [
          { k: "Energia totale", v: ["5.12 [KWh]"] },
          { k: "Capacità utile singolo modulo (profondità di scarica 90%)", v: ["4.6 [Kwh]"] },
          { k: "Capacità", v: ["100 [Ah]"] },
          { k: "Tensione nominale", v: ["51.2 [V]"] },
          { k: "Gamma di tensioni [V]", v: ["46.5V-58.4V"] },
          { k: "Corrente carica massima **", v: ["100 [A]"] },
          { k: "Corrente scarica massima **", v: ["100 [A]"] },
          { k: "Profondità di scarica massima", v: ["90%"] },
        ],
      },
      {
        title: "Certificazioni aziendali",
        rows: [
          { k: "ISO 9001:2015 Qualità", span: "KIWA" },
          { k: "ISO 14001:2015 Ambiente", span: "KIWA" },
          { k: "ISO 45001:2018 Sicurezza", span: "KIWA" },
          { k: "Factory Inspection Attestation Photovoltaic (PV) Panels", span: "KIWA" },
        ],
      },
    ],
    notes: [
      "* Le correnti effettive di carica e scarica possono essere limitate dalle condizioni operative della batteria, nonché dagli inverter alle quali le batterie sono collegate.",
      "Si prega di fare riferimento alla scheda tecnica dell'inverter.",
    ],
  },
  "aura-ev-stazione-di-ricarica-ac": {
    image: "/products/aura-ev-charge.webp?v=2",
    models: ["7KW-MONOFASE", "11/22KW-TRIFASE"],
    sections: [
      {
        title: "Configurazione ambientale",
        rows: [
          { k: "Temperatura operativa", span: "Da -30°C a +50°C" },
          { k: "Umidità relativa", v: ["95%", "95%"] },
        ],
      },
      {
        title: "Potenza in ingresso",
        rows: [
          { k: "Valori in ingresso", v: ["230 Vac, monofase, 32A max, 50/60 Hz", "400 Vac, trifase, 32A*3 max, 50/60 Hz"] },
          { k: "Numero di fase", v: ["L, N, PE", "L, N*3, PE"] },
        ],
      },
      {
        title: "Potenza in uscita",
        rows: [
          { k: "Valori in uscita", v: ["230 Vac, monofase, 32A max, 50/60 Hz, 7.4 kW maximum", "400 Vac, trifase, 32A*3 max, 50/60 Hz, 11/22 kW maximum"] },
          { k: "Interfaccia di carica", v: ["IEC62196-2-2016 connettore Tipo-2", "IEC62196-2-2016 connettore Tipo-2"] },
        ],
      },
      {
        title: "Protezione",
        rows: [
          { k: "Sovra-correnti", v: ["Supportato", "Supportato"] },
          { k: "Sotto/sovra tensioni", v: ["Supportato", "Supportato"] },
          { k: "Corto circuito", v: ["Supportato", "Supportato"] },
          { k: "Sovra temperatura", v: ["Supportato", "Supportato"] },
          { k: "Mancato isolamento", v: ["Supportato", "Supportato"] },
          { k: "Protezione disconnessione", v: ["Supportato", "Supportato"] },
        ],
      },
      {
        title: "Interfaccia utente",
        rows: [
          { k: "Indicatori di stato", span: "Tre led di indicazione, potenza/carica/errore" },
          { k: "Pulsanti", span: "Pulsante di sgancio per emergenza" },
          { k: "Autenticazione user", v: ["RFID", "RFID"] },
        ],
      },
      {
        title: "Case",
        rows: [
          { k: "Protezione", v: ["IP 55", "IP 55"] },
          { k: "Dimensioni", v: ["250x200x350 [mm]", "250x200x350 [mm]"] },
        ],
      },
      {
        title: "Certificazioni aziendali",
        rows: [
          { k: "ISO 9001:2015 Qualità", span: "KIWA" },
          { k: "ISO 14001:2015 Ambiente", span: "KIWA" },
          { k: "ISO 45001:2018 Sicurezza", span: "KIWA" },
          { k: "Factory Inspection Attestation Photovoltaic (PV) Panels", span: "KIWA" },
        ],
      },
    ],
    notes: [
      "* L'intervallo di tensione e di frequenza di uscita può variare a seconda della normativa locale. Le specifiche sono soggette a modifiche senza preavviso.",
    ],
  },
  "inverter-monofase-ibrido": {
    banner: "LOW VOLTAGE",
    image: "/products/inverter-monofase-ibrido.png",
    models: ["AURA 4.6 K-H", "AURA 5.0 K-H", "AURA 6.0 K-H"],
    sections: [
      {
        title: "Configurazione ambientale",
        rows: [
          { k: "Massima efficienza (PV in CA)", v: ["97.3%", "97.3%", "97.3%"] },
          { k: "Massima efficienza (Batteria in CA)", v: ["94.3%", "94.3%", "94.3%"] },
        ],
      },
      {
        title: "Dati tecnici ingresso PV",
        rows: [
          { k: "Massima potenza in ingresso", v: ["9000W", "9000W", "9000W"] },
          { k: "Massima tensione in ingresso CC", v: ["550V", "550V", "550V"] },
          { k: "Massima componente in ingresso (input A / input B)", v: ["15A/15A", "15A/15A", "15A/15A"] },
          { k: "Massima corrente per ogni MPPT (input A / input B)", v: ["20A/20A", "20A/20A", "20A/20A"] },
          { k: "Tensione nominale di attivazione", v: ["90V", "90V", "90V"] },
          { k: "Intervallo MPPT di tensione CC", v: ["70V - 540V", "70V - 540V", "70V - 540V"] },
          { k: "N° di MPPT indipendenti", v: ["2", "2", "2"] },
          { k: "N° di stringhe per MPPT", v: ["1", "1", "1"] },
        ],
      },
      {
        title: "Dati tecnici ingresso batteria",
        rows: [
          { k: "Tipologia di batterie compatibili", v: ["Ioni di litio (AURA ACC)", "Ioni di litio (AURA ACC)", "Ioni di litio (AURA ACC)"] },
          { k: "Tensione nominale batterie", v: ["48V", "48V", "48V"] },
          { k: "Intervallo di tensione batterie", v: ["40V - 65V", "40V - 65V", "40V - 65V"] },
          { k: "Massima corrente di carica/scarica", v: ["120A/120A", "120A/120A", "120A/120A"] },
          { k: "Massima potenza di carica/scarica", v: ["6000W/6000W", "6000W/6000W", "6000W/6000W"] },
          { k: "Curva di carica batterie al Litio", v: ["Auto-adattamento del BMS", "Auto-adattamento del BMS", "Auto-adattamento del BMS"] },
        ],
      },
      {
        title: "Dati tecnici uscita CA",
        rows: [
          { k: "Potenza nominale uscita CA", v: ["4600W", "5000W", "6000W"] },
          { k: "Massima potenza apparente in uscita CA", v: ["4600VA", "5000VA", "6000VA"] },
          { k: "Massima potenza in uscita CA (FP=1)", v: ["4600VA", "5000VA", "6000VA"] },
          { k: "Massima corrente in uscita CA", v: ["22A", "25A", "27.2A"] },
          { k: "Tensione nominale CA", v: ["230V, L+N+PE", "230V, L+N+PE", "230V, L+N+PE"] },
          { k: "Intervallo tensione CA", v: ["150V-300V (Regolabile)", "150V-300V (Regolabile)", "150V-300V (Regolabile)"] },
          { k: "Frequenza nominale di rete", v: ["50Hz / 60Hz", "50Hz / 60Hz", "50Hz / 60Hz"] },
          { k: "Intervallo di frequenza CA", span: "45Hz-55Hz / 55Hz-65Hz (In accordo con gli standard di rete locali)" },
          { k: "Connessione alla rete", v: ["Monofase", "Monofase", "Monofase"] },
          { k: "Fattore di potenza", span: "> 0.99 Potenza nominale (Regolabile 0.8 LD - 0.8 LG)" },
          { k: "Distorsione armonica totale", v: ["<3% (Potenza nominale)", "<3% (Potenza nominale)", "<3% (Potenza nominale)"] },
        ],
      },
      {
        title: "Uscita (backup)",
        rows: [
          { k: "Potenza nominale uscita CA", v: ["4600W", "5000W", "6000W"] },
          { k: "Massima potenza apparente in uscita CA", v: ["20A", "21.7A", "26A"] },
          { k: "Massima potenza in uscita CA (FP=1)", v: ["9200VA", "10000VA", "12000VA"] },
          { k: "Massima corrente in uscita CA", v: ["230V, L+N+PE", "230V, L+N+PE", "230V, L+N+PE"] },
          { k: "Tensione nominale CA", v: ["50Hz / 60Hz", "50Hz / 60Hz", "50Hz / 60Hz"] },
          { k: "Intervallo tensione CA", v: ["10ms (typ) / 20ms (max)", "10ms (typ) / 20ms (max)", "10ms (typ) / 20ms (max)"] },
          { k: "Frequenza nominale di rete", v: ["<3% 100% R carico", "<3% 100% R carico", "<3% 100% R carico"] },
        ],
      },
      {
        title: "Protezioni",
        rows: [
          { k: "Categoria di protezione", v: ["Classe I", "Classe I", "Classe I"] },
          { k: "Sezionatore CC", v: ["Supportato", "Supportato", "Supportato"] },
          { k: "Protezione anti-isola", v: ["Supportato", "Supportato", "Supportato"] },
          { k: "Protezione sovratensione CA", v: ["Supportato", "Supportato", "Supportato"] },
          { k: "Protezione corto-circuito CA", v: ["Supportato", "Supportato", "Supportato"] },
          { k: "Connessione inversa CC", v: ["Supportato", "Supportato", "Supportato"] },
          { k: "Scaricatore di sovratensioni", v: ["DC Tipo III, AC Tipo III", "DC Tipo III, AC Tipo III", "DC Tipo III, AC Tipo III"] },
          { k: "Rilevamento isolamento", v: ["Supportato", "Supportato", "Supportato"] },
          { k: "Protezione corrente di dispersione", v: ["Supportato", "Supportato", "Supportato"] },
          { k: "Categoria sovratensione PV", v: ["II", "II", "II"] },
          { k: "Categoria sovratensione CA", v: ["III", "III", "III"] },
        ],
      },
      {
        title: "Dati tecnici generali",
        rows: [
          { k: "Altitudine massima di lavoro", v: ["4000m", "4000m", "4000m"] },
          { k: "Rumorosità", v: ["<35dB", "<35dB", "<35dB"] },
          { k: "Grado di protezione ambientale", v: ["IP65", "IP65", "IP65"] },
          { k: "Intervallo di temperatura", v: ["-25 ~ 60", "-25 ~ 60", "-25 ~ 60"] },
          { k: "Umidità relativa", v: ["0 ~ 100%", "0 ~ 100%", "0 ~ 100%"] },
          { k: "Sistema di raffreddamento", v: ["Convenzione naturale", "Convenzione naturale", "Convenzione naturale"] },
          { k: "Montaggio", v: ["A muro", "A muro", "A muro"] },
          { k: "Dimensioni (L*H*S)", v: ["515mm*485mm*175mm", "515mm*485mm*175mm", "515mm*485mm*175mm"] },
          { k: "Peso", v: ["25Kg", "25Kg", "25Kg"] },
          { k: "PV connettori", v: ["MC4/H4", "MC4/H4", "MC4/H4"] },
        ],
      },
      {
        title: "HMI & COM",
        rows: [
          { k: "Display", v: ["LED+APP", "LED+APP", "LED+APP"] },
          { k: "Comunicazione di interfaccia", span: "RS485/CAN (for BMS), RS485, USB, DRM/RS485 (per il Meter), Optional: WiFi/GPRS/LAN" },
        ],
      },
      {
        title: "Certificazioni di prodotto",
        rows: [
          { k: "Rete", span: "VDE-AR-N4105, IEC 61727/62116, AS 4777.2, EN 50549-1, C10/11, G99, CEI 0-21, NRS 097-2-1, RD 1699/661/413" },
          { k: "Safety", v: ["IEC62109-1&2, IEC62477-1", "IEC62109-1&2, IEC62477-1", "IEC62109-1&2, IEC62477-1"] },
          { k: "Garanzia", v: ["10 ANNI", "10 ANNI", "10 ANNI"] },
        ],
      },
      {
        title: "Certificazioni aziendali",
        rows: [
          { k: "ISO 9001:2015 Qualità", span: "KIWA" },
          { k: "ISO 14001:2015 Ambiente", span: "KIWA" },
          { k: "ISO 45001:2018 Sicurezza", span: "KIWA" },
          { k: "Factory Inspection Attestation Photovoltaic (PV) Panels", span: "KIWA" },
        ],
      },
    ],
    notes: [
      "* L'intervallo di tensione e di frequenza di uscita può variare a seconda della normativa locale. Le specifiche sono soggette a modifiche senza preavviso.",
      "* La potenza erogata in backup dipende dal numero e dal tipo di batterie nonché dallo stato di sistema (Temperatura, Capacità residua).",
      "Le specifiche tecniche sono soggette a continui aggiornamenti e possono variare in qualsiasi momento senza alcun preavviso.",
      "Verificare condizioni e validità delle garanzie direttamente con l'azienda al momento dell'acquisto.",
    ],
  },
  "inverter-monofase-ibrido-high-voltage": {
    banner: "HIGH VOLTAGE",
    image: "/products/inverter-monofase-ibrido-hv.webp",
    models: ["AURA 4.6 K-H", "AURA 5.0 K-H", "AURA 6.0 K-H"],
    sections: [
      {
        title: "Configurazione ambientale",
        rows: [
          { k: "Massima efficienza (PV in CA)", v: ["97.8%", "97.8%", "97.8%"] },
          { k: "Massima efficienza (Batteria in CA)", v: ["97.0%", "97.0%", "97.0%"] },
        ],
      },
      {
        title: "Dati tecnici ingresso PV",
        rows: [
          { k: "Massima potenza in ingresso", v: ["12000W", "12000W", "12000W"] },
          { k: "Massima tensione in ingresso CC", v: ["550V", "550V", "550V"] },
          { k: "Massima componente in ingresso (input A / input B)", v: ["16A/16A", "16A/16A", "16A/16A"] },
          { k: "Massima corrente per ogni MPPT (input A / input B)", v: ["20A/20A", "20A/20A", "20A/20A"] },
          { k: "Tensione nominale di attivazione", v: ["90V", "90V", "90V"] },
          { k: "Intervallo MPPT di tensione CC", v: ["70V - 540V", "70V - 540V", "70V - 540V"] },
          { k: "N° di MPPT indipendenti", v: ["2", "2", "2"] },
          { k: "N° di stringhe per MPPT", v: ["1", "1", "1"] },
        ],
      },
      {
        title: "Dati tecnici ingresso batteria",
        rows: [
          { k: "Tipologia di batterie compatibili", v: ["Ioni di litio (AURA ACC)", "Ioni di litio (AURA ACC)", "Ioni di litio (AURA ACC)"] },
          { k: "Tensione nominale batterie", v: ["360V", "360V", "360V"] },
          { k: "Intervallo di tensione batterie", v: ["80V - 480V", "80V - 480V", "80V - 480V"] },
          { k: "Massima corrente di carica/scarica", v: ["42A/42A", "42A/42A", "42A/42A"] },
          { k: "Massima potenza di carica/scarica", v: ["9000W/6600W", "9000W/6600W", "9000W/6600W"] },
          { k: "Curva di carica batterie al Litio", v: ["Auto-adattamento del BMS", "Auto-adattamento del BMS", "Auto-adattamento del BMS"] },
        ],
      },
      {
        title: "Dati tecnici uscita CA",
        rows: [
          { k: "Potenza nominale uscita CA", v: ["4600W", "5000W", "6000W"] },
          { k: "Massima potenza apparente in uscita CA", v: ["4600VA", "5500VA", "6600VA"] },
          { k: "Massima potenza in uscita CA (FP=1)", v: ["4600VA", "5500VA", "6600VA"] },
          { k: "Massima corrente in uscita CA", v: ["21A", "25A", "28.7A"] },
          { k: "Tensione nominale CA", v: ["230V, L+N+PE", "230V, L+N+PE", "230V, L+N+PE"] },
          { k: "Intervallo tensione CA", v: ["150V-300V (Regolabile)", "150V-300V (Regolabile)", "150V-300V (Regolabile)"] },
          { k: "Frequenza nominale di rete", v: ["50Hz / 60Hz", "50Hz / 60Hz", "50Hz / 60Hz"] },
          { k: "Intervallo di frequenza CA", span: "45Hz-55Hz / 55Hz-65Hz (In accordo con gli standard di rete locali)" },
          { k: "Connessione alla rete", v: ["Monofase", "Monofase", "Monofase"] },
          { k: "Fattore di potenza", span: "> 0.99 Potenza nominale (Regolabile 0.8 LD - 0.8 LG)" },
          { k: "Distorsione armonica totale", v: ["<3% (Potenza nominale)", "<3% (Potenza nominale)", "<3% (Potenza nominale)"] },
        ],
      },
      {
        title: "Uscita (backup)",
        rows: [
          { k: "Potenza nominale uscita CA", v: ["4600W", "5000W", "6000W"] },
          { k: "Massima potenza apparente in uscita CA", v: ["20A", "21.7A", "26.1A"] },
          { k: "Massima potenza in uscita CA (15s)", v: ["6670VA", "7250VA", "8700VA"] },
          { k: "Massima corrente in uscita CA", v: ["230V, L+N+PE", "230V, L+N+PE", "230V, L+N+PE"] },
          { k: "Tensione nominale CA", v: ["50Hz / 60Hz", "50Hz / 60Hz", "50Hz / 60Hz"] },
          { k: "Intervallo tensione CA", v: ["10ms (typ) / 20ms (max)", "10ms (typ) / 20ms (max)", "10ms (typ) / 20ms (max)"] },
          { k: "Frequenza nominale di rete", v: ["<3% 100% R carico", "<3% 100% R carico", "<3% 100% R carico"] },
        ],
      },
      {
        title: "Protezioni",
        rows: [
          { k: "Categoria di protezione", v: ["Classe I", "Classe I", "Classe I"] },
          { k: "Sezionatore CC", v: ["Supportato", "Supportato", "Supportato"] },
          { k: "Protezione anti-isola", v: ["Supportato", "Supportato", "Supportato"] },
          { k: "Protezione sovratensione CA", v: ["Supportato", "Supportato", "Supportato"] },
          { k: "Protezione corto-circuito CA", v: ["Supportato", "Supportato", "Supportato"] },
          { k: "Connessione inversa CC", v: ["Supportato", "Supportato", "Supportato"] },
          { k: "Scaricatore di sovratensioni", v: ["DC Tipo III, AC Tipo III", "DC Tipo III, AC Tipo III", "DC Tipo III, AC Tipo III"] },
          { k: "Rilevamento isolamento", v: ["Supportato", "Supportato", "Supportato"] },
          { k: "Protezione corrente di dispersione", v: ["Supportato", "Supportato", "Supportato"] },
          { k: "Categoria sovratensione PV", v: ["II", "II", "II"] },
          { k: "Categoria sovratensione CA", v: ["III", "III", "III"] },
        ],
      },
      {
        title: "Dati tecnici generali",
        rows: [
          { k: "Altitudine massima di lavoro", v: ["4000m", "4000m", "4000m"] },
          { k: "Rumorosità", v: ["<35dB", "<35dB", "<35dB"] },
          { k: "Grado di protezione ambientale", v: ["IP66", "IP66", "IP66"] },
          { k: "Intervallo di temperatura", v: ["-25 ~ 60", "-25 ~ 60", "-25 ~ 60"] },
          { k: "Umidità relativa", v: ["0 ~ 100%", "0 ~ 100%", "0 ~ 100%"] },
          { k: "Sistema di raffreddamento", v: ["Convenzione naturale", "Convenzione naturale", "Convenzione naturale"] },
          { k: "Montaggio", v: ["A muro", "A muro", "A muro"] },
          { k: "Dimensioni (L*H*S)", v: ["470mm*360mm*172mm", "470mm*360mm*172mm", "470mm*360mm*172mm"] },
          { k: "Peso", v: ["25Kg", "25Kg", "25Kg"] },
          { k: "PV connettori", v: ["MC4/H4", "MC4/H4", "MC4/H4"] },
        ],
      },
      {
        title: "HMI & COM",
        rows: [
          { k: "Display", v: ["LED+APP", "LED+APP", "LED+APP"] },
          { k: "Comunicazione di interfaccia", span: "RS485/CAN (for BMS), RS485, USB, DRM/RS485 (per il Meter), Optional: WiFi/GPRS/LAN" },
        ],
      },
      {
        title: "Certificazioni di prodotto",
        rows: [
          { k: "Rete", span: "VDE-AR-N4105, IEC 61727/62116, AS 4777.2, EN 50549-1, C10/11, G99, CEI 0-21, NRS 097-2-1, RD 1699/661/413" },
          { k: "Safety", v: ["IEC62109-1&2", "IEC62109-1&2", "IEC62109-1&2"] },
          { k: "Garanzia", v: ["10 ANNI", "10 ANNI", "10 ANNI"] },
        ],
      },
      {
        title: "Certificazioni aziendali",
        rows: [
          { k: "ISO 9001:2015 Qualità", span: "KIWA" },
          { k: "ISO 14001:2015 Ambiente", span: "KIWA" },
          { k: "ISO 45001:2018 Sicurezza", span: "KIWA" },
          { k: "Factory Inspection Attestation Photovoltaic (PV) Panels", span: "KIWA" },
        ],
      },
    ],
    notes: [
      "* L'intervallo di tensione e di frequenza di uscita può variare a seconda della normativa locale. Le specifiche sono soggette a modifiche senza preavviso.",
      "* La potenza erogata in backup dipende dal numero e dal tipo di batterie nonché dallo stato di sistema (Temperatura, Capacità residua).",
      "Le specifiche tecniche sono soggette a continui aggiornamenti e possono variare in qualsiasi momento senza alcun preavviso.",
      "Verificare condizioni e validità delle garanzie direttamente con l'azienda al momento dell'acquisto.",
    ],
  },
};

export const faqTecnologia = [
  { q: "Che cos'è la tecnologia X-CORE²?", a: "X-CORE² è la tecnologia TORRI, con domanda di brevetto depositata, basata su una cornice ingegnerizzata con inserto polimerico che genera il cosiddetto \"effetto lastra\": redistribuisce le sollecitazioni meccaniche sull'intera superficie del pannello, con oltre il 75% di riduzione del carico concentrato e una ridistribuzione dei carichi fino a 5 volte superiore rispetto a una cornice tradizionale. Il risultato è un modulo più robusto, calpestabile e protetto dalle microfratture del silicio." },
  { q: "I pannelli fotovoltaici TORRI resistono alla grandine?", a: "Sì. Grazie al modello costruttivo PRISMA 4.0 i moduli TORRI sono fino a 8 volte più resistenti alla grandine rispetto allo standard di mercato e ai requisiti IEC di riferimento, mantenendo integro il circuito in silicio nel tempo." },
  { q: "Si può camminare sui pannelli fotovoltaici?", a: "In generale calpestare un pannello può causare microcricche invisibili e perdita di potenza. La tecnologia X-CORE² di TORRI rende il modulo calpestabile riducendo drasticamente il carico concentrato durante installazione e manutenzione, minimizzando il rischio di danni al silicio." },
  { q: "Quanto sono robusti i pannelli TORRI?", a: "I moduli TORRI sono fino a 3 volte più robusti agli urti accidentali e sopportano fino a 750 kg/m² di carico neve, grazie alla filosofia costruttiva PRISMA 4.0 e alla tecnologia X-CORE²." },
  { q: "Dove sono prodotti i pannelli fotovoltaici TORRI?", a: "TORRI progetta e produce i propri pannelli fotovoltaici in Italia, nel polo tecnologico di Brescia di circa 10.000 mq, dove avvengono produzione, ricerca e sperimentazione delle nuove tecnologie: un vero fotovoltaico Made in Italy." },
  { q: "Che differenza c'è tra PRISMA 4.0, X-CORE², ECO-RED e AURA?", a: "PRISMA 4.0 è il modello costruttivo che massimizza robustezza e protezione del silicio; X-CORE² è la cornice, con domanda di brevetto depositata, che ridistribuisce i carichi e rende il modulo calpestabile; ECO-RED è la linea dedicata all'estetica e all'integrazione architettonica; AURA è l'ecosistema di accumulo e ricarica che completa l'impianto." },
];
